var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1084,
    height: 619,
    viewBox: "0 0 1084 619",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.274 312.48H533.856L531.146 307.836L533.856 303.192H539.274L541.906 307.836L539.274 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 318.363H523.793L521.084 313.641L523.793 308.997H529.134L531.843 313.641L529.134 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 324.168H533.856L531.146 319.524L533.856 314.802H539.274L541.906 319.524L539.274 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 318.363H543.995L541.286 313.641L543.995 308.997H549.336L552.045 313.641L549.336 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 306.675H543.995L541.286 302.03L543.995 297.309H549.336L552.045 302.03L549.336 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 300.869H533.856L531.146 296.148L533.856 291.504H539.274L541.906 296.148L539.274 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 306.675H523.793L521.084 302.03L523.793 297.309H529.134L531.843 302.03L529.134 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 324.168H513.653L510.944 319.524L513.653 314.802H519.072L521.703 319.524L519.072 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 329.973H523.793L521.084 325.329L523.793 320.685H529.134L531.843 325.329L529.134 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 335.856H533.856L531.146 331.134L533.856 326.49H539.274L541.906 331.134L539.274 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 329.973H543.995L541.286 325.329L543.995 320.685H549.336L552.045 325.329L549.336 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 324.168H554.058L551.349 319.524L554.058 314.802H559.476L562.185 319.524L559.476 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 312.48H554.058L551.349 307.836L554.058 303.192H559.476L562.185 307.836L559.476 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 300.869H554.058L551.349 296.148L554.058 291.504H559.476L562.185 296.148L559.476 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 294.987H543.995L541.286 290.342L543.995 285.698H549.336L552.045 290.342L549.336 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 289.181H533.856L531.146 284.537L533.856 279.816H539.274L541.906 284.537L539.274 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 294.987H523.793L521.084 290.342L523.793 285.698H529.134L531.843 290.342L529.134 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 300.869H513.653L510.944 296.148L513.653 291.504H519.072L521.703 296.148L519.072 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 312.48H513.653L510.944 307.836L513.653 303.192H519.072L521.703 307.836L519.072 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 329.973H503.591L500.882 325.329L503.591 320.685H508.932L511.641 325.329L508.932 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 335.856H513.653L510.944 331.134L513.653 326.49H519.072L521.703 331.134L519.072 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 341.661H523.793L521.084 337.017L523.793 332.373H529.134L531.843 337.017L529.134 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 347.467H533.856L531.146 342.822L533.856 338.178H539.274L541.906 342.822L539.274 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 341.661H543.995L541.286 337.017L543.995 332.373H549.336L552.045 337.017L549.336 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 335.856H554.058L551.349 331.134L554.058 326.49H559.476L562.185 331.134L559.476 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 329.973H564.198L561.489 325.329L564.198 320.685H569.539L572.248 325.329L569.539 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 318.363H564.198L561.489 313.641L564.198 308.997H569.539L572.248 313.641L569.539 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 306.675H564.198L561.489 302.03L564.198 297.309H569.539L572.248 302.03L569.539 306.675Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 294.987H564.198L561.489 290.342L564.198 285.698H569.539L572.248 290.342L569.539 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 289.181H554.058L551.349 284.537L554.058 279.816H559.476L562.185 284.537L559.476 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 283.376H543.995L541.286 278.654L543.995 274.01H549.336L552.045 278.654L549.336 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 277.493H533.856L531.146 272.849L533.856 268.205H539.274L541.906 272.849L539.274 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 283.376H523.793L521.084 278.654L523.793 274.01H529.134L531.843 278.654L529.134 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 289.181H513.653L510.944 284.537L513.653 279.816H519.072L521.703 284.537L519.072 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 294.987H503.591L500.882 290.342L503.591 285.698H508.932L511.641 290.342L508.932 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 306.675H503.591L500.882 302.03L503.591 297.309H508.932L511.641 302.03L508.932 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 318.363H503.591L500.882 313.641L503.591 308.997H508.932L511.641 313.641L508.932 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 335.856H493.451L490.741 331.134L493.451 326.49H498.869L501.501 331.134L498.869 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 341.661H503.591L500.882 337.017L503.591 332.373H508.932L511.641 337.017L508.932 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 347.467H513.653L510.944 342.822L513.653 338.178H519.072L521.703 342.822L519.072 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 353.349H523.793L521.084 348.705L523.793 343.984H529.134L531.843 348.705L529.134 353.349Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 359.155H533.856L531.146 354.51L533.856 349.866H539.274L541.906 354.51L539.274 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 353.349H543.995L541.286 348.705L543.995 343.984H549.336L552.045 348.705L549.336 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 347.467H554.058L551.349 342.822L554.058 338.178H559.476L562.185 342.822L559.476 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 341.661H564.198L561.489 337.017L564.198 332.373H569.539L572.248 337.017L569.539 341.661Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 335.856H574.26L571.551 331.134L574.26 326.49H579.679L582.388 331.134L579.679 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 324.168H574.26L571.551 319.524L574.26 314.802H579.679L582.388 319.524L579.679 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 312.48H574.26L571.551 307.836L574.26 303.192H579.679L582.388 307.836L579.679 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 300.869H574.26L571.551 296.148L574.26 291.504H579.679L582.388 296.148L579.679 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 289.181H574.26L571.551 284.537L574.26 279.816H579.679L582.388 284.537L579.679 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 283.376H564.198L561.489 278.654L564.198 274.01H569.539L572.248 278.654L569.539 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 277.493H554.058L551.426 272.849L554.058 268.205H559.476L562.108 272.849L559.476 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 271.611H543.995L541.364 267.044L543.995 262.4H549.336L551.968 267.044L549.336 271.611Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 265.805H533.856L531.146 261.161L533.856 256.517H539.274L541.906 261.161L539.274 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 271.688H523.793L521.084 267.044L523.793 262.322H529.134L531.843 267.044L529.134 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 277.493H513.653L510.944 272.849L513.653 268.205H519.072L521.703 272.849L519.072 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 283.376H503.591L500.882 278.654L503.591 274.01H508.932L511.641 278.654L508.932 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 289.181H493.451L490.741 284.537L493.451 279.816H498.869L501.501 284.537L498.869 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 300.869H493.451L490.741 296.148L493.451 291.504H498.869L501.501 296.148L498.869 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 312.48H493.451L490.741 307.836L493.451 303.192H498.869L501.501 307.836L498.869 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 324.168H493.451L490.741 319.524L493.451 314.802H498.869L501.501 319.524L498.869 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 341.661H483.311L480.679 337.017L483.311 332.373H488.729L491.438 337.017L488.729 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 347.467H493.451L490.741 342.822L493.451 338.178H498.869L501.501 342.822L498.869 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 353.349H503.591L500.882 348.705L503.591 343.984H508.932L511.641 348.705L508.932 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 359.155H513.653L510.944 354.51L513.653 349.866H519.072L521.703 354.51L519.072 359.155Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 365.037H523.793L521.084 360.316L523.793 355.672H529.134L531.843 360.316L529.134 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 370.843H533.856L531.146 366.198L533.856 361.477H539.274L541.906 366.198L539.274 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 365.037H543.995L541.286 360.316L543.995 355.672H549.336L552.045 360.316L549.336 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 359.155H554.058L551.349 354.51L554.058 349.866H559.476L562.185 354.51L559.476 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 353.349H564.198L561.489 348.705L564.198 343.984H569.539L572.248 348.705L569.539 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 347.467H574.26L571.551 342.822L574.26 338.178H579.679L582.388 342.822L579.679 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 341.661H584.401L581.691 337.017L584.401 332.373H589.741L592.451 337.017L589.741 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 329.973H584.401L581.691 325.329L584.401 320.685H589.741L592.451 325.329L589.741 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 318.363H584.401L581.691 313.641L584.401 308.997H589.741L592.451 313.641L589.741 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 306.675H584.401L581.691 302.03L584.401 297.309H589.741L592.451 302.03L589.741 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 294.987H584.401L581.691 290.342L584.401 285.698H589.741L592.451 290.342L589.741 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 283.376H584.401L581.691 278.654L584.401 274.01H589.741L592.451 278.654L589.741 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.369 277.106H574.493L572.093 272.849L574.493 268.592H579.369L581.846 272.849L579.369 277.106Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.401 256.672H545.931L545.157 255.356L545.931 254.04H547.401L548.176 255.356L547.401 256.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.19 252.414H534.862L533.236 249.551L534.862 246.609H538.19L539.893 249.551L538.19 252.414Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.057 259.845H523.87L521.239 255.356L523.87 250.866H529.057L531.611 255.356L529.057 259.845Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 265.805H513.653L510.944 261.161L513.653 256.517H519.072L521.703 261.161L519.072 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 271.688H503.591L500.882 267.044L503.591 262.322H508.932L511.641 267.044L508.932 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 277.493H493.451L490.741 272.849L493.451 268.205H498.869L501.501 272.849L498.869 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 283.376H483.311L480.679 278.654L483.311 274.01H488.729L491.438 278.654L488.729 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 294.987H483.311L480.679 290.342L483.311 285.698H488.729L491.438 290.342L488.729 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 306.675H483.311L480.679 302.03L483.311 297.309H488.729L491.438 302.03L488.729 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 318.363H483.311L480.679 313.641L483.311 308.997H488.729L491.438 313.641L488.729 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 329.973H483.311L480.679 325.329L483.311 320.685H488.729L491.438 325.329L488.729 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.666 347.467H473.248L470.539 342.822L473.248 338.178H478.666L481.298 342.822L478.666 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 353.349H483.311L480.679 348.705L483.311 343.984H488.729L491.438 348.705L488.729 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 359.155H493.451L490.741 354.51L493.451 349.866H498.869L501.501 354.51L498.869 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 365.037H503.591L500.882 360.316L503.591 355.672H508.932L511.641 360.316L508.932 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 370.843H513.653L510.944 366.198L513.653 361.477H519.072L521.703 366.198L519.072 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 376.648H523.793L521.084 372.004L523.793 367.359H529.134L531.843 372.004L529.134 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.803 379.976H535.326L534.088 377.809L535.326 375.642H537.803L539.042 377.809L537.803 379.976Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 376.648H543.995L541.286 372.004L543.995 367.359H549.336L552.045 372.004L549.336 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 370.843H554.058L551.349 366.198L554.058 361.477H559.476L562.185 366.198L559.476 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 365.037H564.198L561.489 360.316L564.198 355.672H569.539L572.248 360.316L569.539 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 359.155H574.26L571.551 354.51L574.26 349.866H579.679L582.388 354.51L579.679 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 353.349H584.401L581.691 348.705L584.401 343.984H589.741L592.451 348.705L589.741 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 347.467H594.463L591.754 342.822L594.463 338.178H599.881L602.59 342.822L599.881 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 335.856H594.463L591.754 331.134L594.463 326.49H599.881L602.59 331.134L599.881 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 324.168H594.463L591.754 319.524L594.463 314.802H599.881L602.59 319.524L599.881 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 312.48H594.463L591.754 307.836L594.463 303.192H599.881L602.59 307.836L599.881 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 300.869H594.463L591.754 296.148L594.463 291.504H599.881L602.59 296.148L599.881 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 289.181H594.463L591.754 284.537L594.463 279.816H599.881L602.59 284.537L599.881 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.726 277.261H594.618L592.063 272.849L594.618 268.36H599.726L602.281 272.849L599.726 277.261Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.271 269.134H585.871L584.633 267.044L585.871 264.877H588.271L589.509 267.044L588.271 269.134Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.464 250.789H556.07L555.296 249.551L556.07 248.235H557.464L558.16 249.551L557.464 250.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.035 240.417H535.094L533.623 237.863L535.094 235.308H538.035L539.506 237.863L538.035 240.417Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.467 259.149H504.055L501.888 255.356L504.055 251.563H508.467L510.634 255.356L508.467 259.149Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.792 265.805H493.451L490.819 261.161L493.451 256.594H498.792L501.501 261.161L498.792 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 271.688H483.311L480.679 267.044L483.311 262.322H488.729L491.438 267.044L488.729 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.583 275.636H474.332L472.706 272.849L474.332 270.063H477.583L479.131 272.849L477.583 275.636Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.589 289.027H473.326L470.694 284.537L473.326 279.97H478.589L481.144 284.537L478.589 289.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.666 300.869H473.248L470.539 296.148L473.248 291.504H478.666L481.298 296.148L478.666 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.666 312.48H473.248L470.539 307.836L473.248 303.192H478.666L481.298 307.836L478.666 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.666 324.168H473.248L470.539 319.524L473.248 314.802H478.666L481.298 319.524L478.666 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.666 335.856H473.248L470.539 331.134L473.248 326.49H478.666L481.298 331.134L478.666 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.526 353.349H463.108L460.476 348.705L463.108 343.984H468.526L471.236 348.705L468.526 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.666 359.155H473.248L470.539 354.51L473.248 349.866H478.666L481.298 354.51L478.666 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 365.037H483.311L480.679 360.316L483.311 355.672H488.729L491.438 360.316L488.729 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 370.843H493.451L490.741 366.198L493.451 361.477H498.869L501.501 366.198L498.869 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.622 376.106H503.823L501.5 372.004L503.823 367.901H508.622L511.021 372.004L508.622 376.106Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.136 379.202H515.588L514.814 377.809L515.588 376.493H517.136L517.91 377.809L517.136 379.202Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.571 391.2H535.559L534.552 389.497L535.559 387.794H537.571L538.577 389.497L537.571 391.2Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 388.336H543.995L541.286 383.692L543.995 378.97H549.336L552.045 383.692L549.336 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 382.531H554.058L551.349 377.809L554.058 373.165H559.476L562.185 377.809L559.476 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 376.648H564.198L561.489 372.004L564.198 367.359H569.539L572.248 372.004L569.539 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 370.843H574.26L571.551 366.198L574.26 361.477H579.679L582.388 366.198L579.679 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 365.037H584.401L581.691 360.316L584.401 355.672H589.741L592.451 360.316L589.741 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 359.155H594.463L591.754 354.51L594.463 349.866H599.881L602.59 354.51L599.881 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 353.349H604.603L601.894 348.705L604.603 343.984H609.944L612.653 348.705L609.944 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 341.661H604.603L601.894 337.017L604.603 332.373H609.944L612.653 337.017L609.944 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 329.973H604.603L601.894 325.329L604.603 320.685H609.944L612.653 325.329L609.944 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 318.363H604.603L601.894 313.641L604.603 308.997H609.944L612.653 313.641L609.944 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 306.675H604.603L601.894 302.03L604.603 297.309H609.944L612.653 302.03L609.944 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 294.987H604.603L601.894 290.342L604.603 285.698H609.944L612.653 290.342L609.944 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 283.376H604.603L601.894 278.654L604.603 274.01H609.944L612.653 278.654L609.944 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.735 258.297H585.407L583.704 255.356L585.407 252.414H588.735L590.438 255.356L588.735 258.297Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.595 252.414H575.344L573.641 249.551L575.344 246.609H578.595L580.298 249.551L578.595 252.414Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.619 239.256H555.916L555.142 237.863L555.916 236.392H557.619L558.393 237.863L557.619 239.256Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.401 233.373H545.853L545.079 231.98L545.853 230.664H547.401L548.253 231.98L547.401 233.373Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.5 229.503H534.629L532.694 226.175L534.629 222.846H538.5L540.435 226.175L538.5 229.503Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.777 248.08H503.745L501.191 243.668L503.745 239.333H508.777L511.331 243.668L508.777 248.08Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.173 253.034H494.07L492.058 249.551L494.07 245.99H498.173L500.262 249.551L498.173 253.034Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.562 256.285H485.478L485.014 255.356L485.478 254.427H486.562L487.104 255.356L486.562 256.285Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.365 292.974H464.347L462.799 290.343L464.347 287.711H467.365L468.836 290.343L467.365 292.974Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.526 306.675H463.108L460.476 302.03L463.108 297.309H468.526L471.236 302.03L468.526 306.675Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.526 318.363H463.108L460.476 313.641L463.108 308.997H468.526L471.236 313.641L468.526 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.526 329.973H463.108L460.476 325.329L463.108 320.685H468.526L471.236 325.329L468.526 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.526 341.661H463.108L460.476 337.017L463.108 332.373H468.526L471.236 337.017L468.526 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.297 355.439H455.213L454.671 354.51L455.213 353.582H456.297L456.761 354.51L456.297 355.439Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.526 364.96H463.185L460.554 360.316L463.185 355.749H468.526L471.158 360.316L468.526 364.96Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.666 370.843H473.248L470.539 366.198L473.248 361.477H478.666L481.298 366.198L478.666 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 376.648H483.311L480.679 372.004L483.311 367.359H488.729L491.438 372.004L488.729 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.018 381.06H494.302L492.367 377.809L494.302 374.558H498.018L499.875 377.809L498.018 381.06Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.809 405.055H534.32L532.075 401.185L534.32 397.315H538.809L541.054 401.185L538.809 405.055Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 400.024H543.995L541.286 395.302L543.995 390.658H549.336L552.045 395.302L549.336 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 394.141H554.058L551.349 389.497L554.058 384.853H559.476L562.185 389.497L559.476 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 388.336H564.198L561.489 383.692L564.198 378.97H569.539L572.248 383.692L569.539 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 382.531H574.26L571.551 377.809L574.26 373.165H579.679L582.388 377.809L579.679 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 376.648H584.401L581.691 372.004L584.401 367.359H589.741L592.451 372.004L589.741 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 370.843H594.463L591.754 366.198L594.463 361.477H599.881L602.59 366.198L599.881 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 365.037H604.603L601.894 360.316L604.603 355.672H609.944L612.653 360.316L609.944 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 359.155H614.665L611.956 354.51L614.665 349.866H620.083L622.793 354.51L620.083 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 347.467H614.665L611.956 342.822L614.665 338.178H620.083L622.793 342.822L620.083 347.467Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 335.856H614.665L611.956 331.134L614.665 326.49H620.083L622.793 331.134L620.083 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 324.168H614.665L611.956 319.524L614.665 314.802H620.083L622.793 319.524L620.083 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 312.48H614.665L611.956 307.836L614.665 303.192H620.083L622.793 307.836L620.083 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 300.869H614.665L611.956 296.148L614.665 291.504H620.083L622.793 296.148L620.083 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 289.181H614.665L611.956 284.537L614.665 279.816H620.083L622.793 284.537L620.083 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.232 276.1H615.517L613.582 272.849L615.517 269.598H619.232L621.167 272.849L619.232 276.1Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.839 261.935H616.91L616.523 261.161L616.91 260.387H617.839L618.226 261.161L617.839 261.935Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.705 257.755H605.841L604.448 255.356L605.841 252.879H608.705L610.098 255.356L608.705 257.755Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.726 253.963H594.618L592.063 249.551L594.618 245.061H599.726L602.281 249.551L599.726 253.963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.038 245.371H586.103L585.097 243.668L586.103 241.965H588.038L589.045 243.668L588.038 245.371Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.601 242.352H574.338L571.783 237.863L574.338 233.296H579.601L582.156 237.863L579.601 242.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.455 234.766H565.281L563.656 231.98L565.281 229.271H568.455L570.003 231.98L568.455 234.766Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.083 228.419H555.451L554.135 226.175L555.451 223.93H558.083L559.321 226.175L558.083 228.419Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 225.013H543.995L541.286 220.369L543.995 215.648H549.336L552.045 220.369L549.336 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 219.208H533.856L531.146 214.487L533.856 209.842H539.274L541.906 214.487L539.274 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.669 224.162H524.257L522.09 220.369L524.257 216.576H528.669L530.837 220.369L528.669 224.162Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.374 229.658H514.349L512.337 226.175L514.349 222.691H518.374L520.31 226.175L518.374 229.658Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 236.702H503.591L500.882 231.98L503.591 227.336H508.932L511.641 231.98L508.932 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 242.507H493.451L490.741 237.863L493.451 233.218H498.869L501.501 237.863L498.869 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 248.312H483.311L480.679 243.668L483.311 239.024H488.729L491.438 243.668L488.729 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.838 309.771H454.594L453.51 307.836L454.594 305.901H456.838L458 307.836L456.838 309.771Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.154 323.781H453.278L450.801 319.524L453.278 315.267H458.154L460.631 319.524L458.154 323.781Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.154 335.392H453.278L450.801 331.134L453.278 326.955H458.154L460.631 331.134L458.154 335.392Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.154 347.08H453.278L450.801 342.822L453.278 338.565H458.154L460.631 342.822L458.154 347.08Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.282 372.778H465.43L464.966 372.004L465.43 371.23H466.282L466.746 372.004L466.282 372.778Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.886 379.435H475.028L474.1 377.809L475.028 376.184H476.886L477.815 377.809L476.886 379.435Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 411.635H543.995L541.286 406.99L543.995 402.346H549.336L552.045 406.99L549.336 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 405.829H554.058L551.349 401.185L554.058 396.463H559.476L562.185 401.185L559.476 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 400.024H564.198L561.489 395.302L564.198 390.658H569.539L572.248 395.302L569.539 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 394.141H574.26L571.551 389.497L574.26 384.853H579.679L582.388 389.497L579.679 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 388.336H584.401L581.691 383.692L584.401 378.97H589.741L592.451 383.692L589.741 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 382.531H594.463L591.754 377.809L594.463 373.165H599.881L602.59 377.809L599.881 382.531Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 376.648H604.603L601.894 372.004L604.603 367.359H609.944L612.653 372.004L609.944 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 370.843H614.665L611.956 366.198L614.665 361.477H620.083L622.793 366.198L620.083 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 365.037H624.805L622.096 360.316L624.805 355.672H630.146L632.855 360.316L630.146 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 353.349H624.805L622.096 348.705L624.805 343.984H630.146L632.855 348.705L630.146 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 341.661H624.805L622.096 337.017L624.805 332.373H630.146L632.855 337.017L630.146 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 329.973H624.805L622.096 325.329L624.805 320.685H630.146L632.855 325.329L630.146 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 318.208H624.806L622.174 313.641L624.806 309.074H630.146L632.778 313.641L630.146 318.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.366 303.501H626.586L625.734 302.031L626.586 300.482H628.366L629.217 302.031L628.366 303.501Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 294.987H624.805L622.096 290.342L624.805 285.698H630.146L632.855 290.342L630.146 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 283.376H624.805L622.096 278.654L624.805 274.01H630.146L632.855 278.654L630.146 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 271.688H624.805L622.096 267.044L624.805 262.322H630.146L632.855 267.044L630.146 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 260H624.805L622.096 255.356L624.805 250.712H630.146L632.855 255.356L630.146 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.007 254.117H614.743L612.111 249.551L614.743 244.906H620.007L622.638 249.551L620.007 254.117Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 248.312H604.603L601.894 243.668L604.603 239.024H609.944L612.653 243.668L609.944 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 242.507H594.463L591.754 237.863L594.463 233.218H599.881L602.59 237.863L599.881 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.664 236.547H584.478L581.846 231.98L584.478 227.49H589.664L592.295 231.98L589.664 236.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 230.819H574.26L571.551 226.175L574.26 221.53H579.679L582.388 226.175L579.679 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 225.013H564.198L561.489 220.369L564.198 215.648H569.539L572.248 220.369L569.539 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.321 218.976H554.135L551.581 214.487L554.135 209.997H559.321L561.953 214.487L559.321 218.976Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 213.325H543.995L541.286 208.681L543.995 204.037H549.336L552.045 208.681L549.336 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 207.52H533.856L531.146 202.876L533.856 198.154H539.274L541.906 202.876L539.274 207.52Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 213.325H523.793L521.084 208.681L523.793 204.037H529.134L531.843 208.681L529.134 213.325Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 219.208H513.653L510.944 214.487L513.653 209.842H519.072L521.703 214.487L519.072 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.699 224.626H503.745L501.269 220.369L503.745 216.035H508.699L511.176 220.369L508.699 224.626Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 230.819H493.451L490.741 226.175L493.451 221.53H498.869L501.501 226.175L498.869 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.729 236.702H483.311L480.679 231.98L483.311 227.336H488.729L491.438 231.98L488.729 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.104 422.936H544.228L541.751 418.678L544.228 414.421H549.104L551.581 418.678L549.104 422.936Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 417.517H554.058L551.349 412.796L554.058 408.151H559.476L562.185 412.796L559.476 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 411.635H564.198L561.489 406.99L564.198 402.346H569.539L572.248 406.99L569.539 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 405.829H574.26L571.551 401.185L574.26 396.463H579.679L582.388 401.185L579.679 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 400.024H584.401L581.691 395.302L584.401 390.658H589.741L592.451 395.302L589.741 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 394.141H594.463L591.754 389.497L594.463 384.853H599.881L602.59 389.497L599.881 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 388.336H604.603L601.894 383.692L604.603 378.97H609.944L612.653 383.692L609.944 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 382.531H614.665L611.956 377.809L614.665 373.165H620.083L622.793 377.809L620.083 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 376.648H624.805L622.096 372.004L624.805 367.359H630.146L632.855 372.004L630.146 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 370.843H634.868L632.159 366.198L634.868 361.477H640.286L642.995 366.198L640.286 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 359.155H634.868L632.159 354.51L634.868 349.866H640.286L642.995 354.51L640.286 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 347.467H634.868L632.159 342.822L634.868 338.178H640.286L642.995 342.822L640.286 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.435 334.385H635.719L633.862 331.134L635.719 327.961H639.435L641.292 331.134L639.435 334.385Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.119 320.375H637.035L636.571 319.524L637.035 318.595H638.119L638.583 319.524L638.119 320.375Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 312.48H634.868L632.236 307.836L634.868 303.192H640.286L642.918 307.836L640.286 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 300.869H634.868L632.159 296.148L634.868 291.504H640.286L642.995 296.148L640.286 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 289.181H634.868L632.159 284.537L634.868 279.816H640.286L642.995 284.537L640.286 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 277.493H634.868L632.159 272.849L634.868 268.205H640.286L642.995 272.849L640.286 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 265.805H634.868L632.159 261.161L634.868 256.517H640.286L642.995 261.161L640.286 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 254.195H634.868L632.159 249.551L634.868 244.829H640.286L642.995 249.551L640.286 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 248.312H624.805L622.096 243.668L624.805 239.024H630.146L632.855 243.668L630.146 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 242.507H614.665L611.956 237.863L614.665 233.218H620.083L622.793 237.863L620.083 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 236.702H604.603L601.894 231.98L604.603 227.336H609.944L612.653 231.98L609.944 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 230.819H594.463L591.754 226.175L594.463 221.53H599.881L602.59 226.175L599.881 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 225.013H584.401L581.691 220.369L584.401 215.648H589.741L592.451 220.369L589.741 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 219.208H574.26L571.551 214.487L574.26 209.842H579.679L582.388 214.487L579.679 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 213.325H564.198L561.489 208.681L564.198 204.037H569.539L572.248 208.681L569.539 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 207.52H554.058L551.349 202.876L554.058 198.154H559.476L562.185 202.876L559.476 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 201.715H543.995L541.286 196.993L543.995 192.349H549.336L552.045 196.993L549.336 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 195.832H533.856L531.146 191.188L533.856 186.544H539.274L541.906 191.188L539.274 195.832Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 201.715H523.793L521.084 196.993L523.793 192.349H529.134L531.843 196.993L529.134 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 207.52H513.653L510.944 202.876L513.653 198.154H519.072L521.703 202.876L519.072 207.52Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.854 213.171H503.668L501.036 208.681L503.668 204.192H508.854L511.409 208.681L508.854 213.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.794 221.608H485.323L484.549 220.369L485.323 219.053H486.794L487.491 220.369L486.794 221.608Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.017 331.986H435.088L434.624 331.134L435.088 330.36H436.017L436.481 331.134L436.017 331.986Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.408 433.385H544.924L543.144 430.289L544.924 427.27H548.408L550.188 430.289L548.408 433.385Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 429.128H554.058L551.349 424.484L554.058 419.839H559.476L562.185 424.484L559.476 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 423.323H564.198L561.489 418.678L564.198 413.957H569.539L572.248 418.678L569.539 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 417.517H574.26L571.551 412.796L574.26 408.151H579.679L582.388 412.796L579.679 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 411.635H584.401L581.691 406.99L584.401 402.346H589.741L592.451 406.99L589.741 411.635Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 405.829H594.463L591.754 401.185L594.463 396.463H599.881L602.59 401.185L599.881 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 400.024H604.603L601.894 395.302L604.603 390.658H609.944L612.653 395.302L609.944 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 394.141H614.665L611.956 389.497L614.665 384.853H620.083L622.793 389.497L620.083 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 388.336H624.805L622.096 383.692L624.805 378.97H630.146L632.855 383.692L630.146 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 382.531H634.868L632.159 377.809L634.868 373.165H640.286L642.995 377.809L640.286 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 376.648H645.008L642.299 372.004L645.008 367.359H650.349L653.058 372.004L650.349 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 365.037H645.008L642.299 360.316L645.008 355.672H650.349L653.058 360.316L650.349 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 353.272H645.008L642.376 348.705L645.008 344.061H650.349L652.98 348.705L650.349 353.272Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.569 338.565H646.788L645.859 337.017L646.788 335.392H648.569L649.497 337.017L648.569 338.565Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.117 329.509H645.318L642.918 325.329L645.318 321.149H650.117L652.516 325.329L650.117 329.509Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 318.363H645.008L642.299 313.641L645.008 308.997H650.349L653.058 313.641L650.349 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 306.675H645.008L642.299 302.03L645.008 297.309H650.349L653.058 302.03L650.349 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 294.987H645.008L642.299 290.342L645.008 285.698H650.349L653.058 290.342L650.349 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 283.376H645.008L642.299 278.654L645.008 274.01H650.349L653.058 278.654L650.349 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 271.688H645.008L642.299 267.044L645.008 262.322H650.349L653.058 267.044L650.349 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 260H645.008L642.299 255.356L645.008 250.712H650.349L653.058 255.356L650.349 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 248.312H645.008L642.299 243.668L645.008 239.024H650.349L653.058 243.668L650.349 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 242.507H634.868L632.159 237.863L634.868 233.218H640.286L642.995 237.863L640.286 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 236.702H624.805L622.096 231.98L624.805 227.336H630.146L632.855 231.98L630.146 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 230.819H614.665L611.956 226.175L614.665 221.53H620.083L622.793 226.175L620.083 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 225.013H604.603L601.894 220.369L604.603 215.648H609.944L612.653 220.369L609.944 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 219.208H594.463L591.754 214.487L594.463 209.842H599.881L602.59 214.487L599.881 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 213.325H584.401L581.691 208.681L584.401 204.037H589.741L592.451 208.681L589.741 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 207.52H574.26L571.551 202.876L574.26 198.154H579.679L582.388 202.876L579.679 207.52Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 201.715H564.198L561.489 196.993L564.198 192.349H569.539L572.248 196.993L569.539 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 195.832H554.058L551.349 191.188L554.058 186.544H559.476L562.185 191.188L559.476 195.832Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 190.027H543.995L541.286 185.383L543.995 180.661H549.336L552.045 185.383L549.336 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 184.222H533.856L531.146 179.5L533.856 174.856H539.274L541.906 179.5L539.274 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.134 190.027H523.793L521.084 185.383L523.793 180.661H529.134L531.843 185.383L529.134 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.072 195.832H513.653L510.944 191.188L513.653 186.544H519.072L521.703 191.188L519.072 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 201.637H503.591L500.882 196.993L503.591 192.426H508.932L511.563 196.993L508.932 201.637Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.482 206.901H493.838L491.516 202.876L493.838 198.851H498.482L500.804 202.876L498.482 206.901Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 440.816H554.058L551.349 436.172L554.058 431.527H559.476L562.185 436.172L559.476 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 435.011H564.198L561.489 430.289L564.198 425.645H569.539L572.248 430.289L569.539 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 429.128H574.26L571.551 424.484L574.26 419.839H579.679L582.388 424.484L579.679 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 423.323H584.401L581.691 418.678L584.401 413.957H589.741L592.451 418.678L589.741 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 417.517H594.463L591.754 412.796L594.463 408.151H599.881L602.59 412.796L599.881 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 411.635H604.603L601.894 406.99L604.603 402.346H609.944L612.653 406.99L609.944 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 405.829H614.665L611.956 401.185L614.665 396.463H620.083L622.793 401.185L620.083 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 400.024H624.805L622.096 395.302L624.805 390.658H630.146L632.855 395.302L630.146 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 394.141H634.868L632.159 389.497L634.868 384.853H640.286L642.995 389.497L640.286 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 388.336H645.008L642.299 383.692L645.008 378.97H650.349L653.058 383.692L650.349 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 382.531H655.07L652.361 377.809L655.07 373.165H660.489L663.198 377.809L660.489 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 370.843H655.07L652.361 366.198L655.07 361.477H660.489L663.198 366.198L660.489 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.488 359.155H655.07L652.438 354.51L655.07 349.866H660.488L663.12 354.51L660.488 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.256 347.157H655.302L652.748 342.822L655.302 338.488H660.256L662.811 342.822L660.256 347.157Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 335.856H655.07L652.361 331.134L655.07 326.49H660.489L663.198 331.134L660.489 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 324.168H655.07L652.361 319.524L655.07 314.802H660.489L663.198 319.524L660.489 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 312.48H655.07L652.361 307.836L655.07 303.192H660.489L663.198 307.836L660.489 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 300.869H655.07L652.361 296.148L655.07 291.504H660.489L663.198 296.148L660.489 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 289.181H655.07L652.361 284.537L655.07 279.816H660.489L663.198 284.537L660.489 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 277.493H655.07L652.361 272.849L655.07 268.205H660.489L663.198 272.849L660.489 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 265.805H655.07L652.361 261.161L655.07 256.517H660.489L663.198 261.161L660.489 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 254.195H655.07L652.361 249.551L655.07 244.829H660.489L663.198 249.551L660.489 254.195Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 242.507H655.07L652.361 237.863L655.07 233.218H660.489L663.198 237.863L660.489 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 236.702H645.008L642.299 231.98L645.008 227.336H650.349L653.058 231.98L650.349 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 230.819H634.868L632.159 226.175L634.868 221.53H640.286L642.995 226.175L640.286 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 225.013H624.805L622.096 220.369L624.805 215.648H630.146L632.855 220.369L630.146 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 219.208H614.665L611.956 214.487L614.665 209.842H620.083L622.793 214.487L620.083 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 213.325H604.603L601.894 208.681L604.603 204.037H609.944L612.653 208.681L609.944 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 207.52H594.463L591.754 202.876L594.463 198.154H599.881L602.59 202.876L599.881 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 201.715H584.401L581.691 196.993L584.401 192.349H589.741L592.451 196.993L589.741 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 195.832H574.26L571.551 191.188L574.26 186.544H579.679L582.388 191.188L579.679 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 190.027H564.198L561.489 185.383L564.198 180.661H569.539L572.248 185.383L569.539 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 184.222H554.058L551.349 179.5L554.058 174.856H559.476L562.185 179.5L559.476 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 178.339H543.995L541.286 173.695L543.995 169.05H549.336L552.045 173.695L549.336 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.042 172.147H534.088L531.533 167.889L534.088 163.555H539.042L541.519 167.889L539.042 172.147Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.895 176.249H525.031L523.561 173.695L525.031 171.14H527.895L529.366 173.695L527.895 176.249Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.749 180.274H515.898L515.511 179.5L515.898 178.803H516.749L517.214 179.5L516.749 180.274Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 189.949H503.591L500.882 185.383L503.591 180.738H508.932L511.563 185.383L508.932 189.949Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.702 192.117H495.618L494.999 191.188L495.618 190.182H496.702L497.244 191.188L496.702 192.117Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.253 456.452H545.079L543.454 453.665L545.079 450.878H548.253L549.878 453.665L548.253 456.452Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 452.504H554.058L551.349 447.86L554.058 443.138H559.476L562.185 447.86L559.476 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 446.621H564.198L561.489 441.977L564.198 437.333H569.539L572.248 441.977L569.539 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 440.816H574.26L571.551 436.172L574.26 431.527H579.679L582.388 436.172L579.679 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 435.011H584.401L581.691 430.289L584.401 425.645H589.741L592.451 430.289L589.741 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 429.128H594.463L591.754 424.484L594.463 419.839H599.881L602.59 424.484L599.881 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 423.323H604.603L601.894 418.678L604.603 413.957H609.944L612.653 418.678L609.944 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 417.517H614.665L611.956 412.796L614.665 408.151H620.083L622.793 412.796L620.083 417.517Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 411.635H624.805L622.096 406.99L624.805 402.346H630.146L632.855 406.99L630.146 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 405.829H634.868L632.159 401.185L634.868 396.463H640.286L642.995 401.185L640.286 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.194 399.714H645.162L642.686 395.302L645.162 390.968H650.194L652.748 395.302L650.194 399.714Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.25 392.129H656.309L654.76 389.497L656.309 386.865H659.25L660.798 389.497L659.25 392.129Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.241 376.029H665.597L663.275 372.004L665.597 367.979H670.241L672.563 372.004L670.241 376.029Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 365.037H665.21L662.501 360.316L665.21 355.672H670.551L673.26 360.316L670.551 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.08 350.718H666.681L665.52 348.705L666.681 346.615H669.08L670.241 348.705L669.08 350.718Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 341.661H665.21L662.579 337.017L665.21 332.373H670.551L673.26 337.017L670.551 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 329.973H665.21L662.501 325.329L665.21 320.685H670.551L673.26 325.329L670.551 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 318.363H665.21L662.501 313.641L665.21 308.997H670.551L673.26 313.641L670.551 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 306.675H665.21L662.501 302.03L665.21 297.309H670.551L673.26 302.03L670.551 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 294.987H665.21L662.501 290.342L665.21 285.698H670.551L673.26 290.342L670.551 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 283.376H665.21L662.501 278.654L665.21 274.01H670.551L673.26 278.654L670.551 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 271.688H665.21L662.501 267.044L665.21 262.322H670.551L673.26 267.044L670.551 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 260H665.21L662.501 255.356L665.21 250.712H670.551L673.26 255.356L670.551 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 248.312H665.21L662.501 243.668L665.21 239.024H670.551L673.26 243.668L670.551 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 236.702H665.21L662.501 231.98L665.21 227.336H670.551L673.26 231.98L670.551 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 230.819H655.07L652.361 226.175L655.07 221.53H660.489L663.198 226.175L660.489 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 225.013H645.008L642.299 220.369L645.008 215.648H650.349L653.058 220.369L650.349 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 219.208H634.868L632.159 214.487L634.868 209.842H640.286L642.995 214.487L640.286 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 213.325H624.805L622.096 208.681L624.805 204.037H630.146L632.855 208.681L630.146 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 207.52H614.665L611.956 202.876L614.665 198.154H620.083L622.793 202.876L620.083 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 201.715H604.603L601.894 196.993L604.603 192.349H609.944L612.653 196.993L609.944 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 195.832H594.463L591.754 191.188L594.463 186.544H599.881L602.59 191.188L599.881 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 190.027H584.401L581.691 185.383L584.401 180.661H589.741L592.451 185.383L589.741 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 184.222H574.26L571.551 179.5L574.26 174.856H579.679L582.388 179.5L579.679 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 178.339H564.198L561.489 173.695L564.198 169.05H569.539L572.248 173.695L569.539 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.548 170.985H554.987L553.129 167.889L554.987 164.716H558.548L560.405 167.889L558.548 170.985Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.021 164.406H545.234L543.841 162.007L545.234 159.607H548.021L549.414 162.007L548.021 164.406Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.268 159.065H534.862L533.159 156.201L534.862 153.26H538.268L539.893 156.201L538.268 159.065Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 178.339H503.591L500.882 173.695L503.591 169.05H508.932L511.641 173.695L508.932 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.869 184.222H493.451L490.741 179.5L493.451 174.856H498.869L501.501 179.5L498.869 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.104 469.533H544.228L541.828 465.353L544.228 461.173H549.104L551.504 465.353L549.104 469.533Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 464.192H554.058L551.349 459.47L554.058 454.826H559.476L562.185 459.47L559.476 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 458.309H564.198L561.489 453.665L564.198 449.021H569.539L572.248 453.665L569.539 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 452.504H574.26L571.551 447.86L574.26 443.138H579.679L582.388 447.86L579.679 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 446.621H584.401L581.691 441.977L584.401 437.333H589.741L592.451 441.977L589.741 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 440.816H594.463L591.754 436.172L594.463 431.527H599.881L602.59 436.172L599.881 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 435.011H604.603L601.894 430.289L604.603 425.645H609.944L612.653 430.289L609.944 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 429.128H614.665L611.956 424.484L614.665 419.839H620.083L622.793 424.484L620.083 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 423.323H624.805L622.096 418.678L624.805 413.957H630.146L632.855 418.678L630.146 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.209 417.44H634.945L632.313 412.796L634.945 408.229H640.209L642.918 412.796L640.209 417.44Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.298 356.755H676.666L675.428 354.51L676.666 352.266H679.298L680.614 354.51L679.298 356.755Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 335.856H675.273L672.641 331.134L675.273 326.49H680.691L683.4 331.134L680.691 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 324.168H675.273L672.641 319.524L675.273 314.802H680.691L683.4 319.524L680.691 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 312.48H675.273L672.641 307.836L675.273 303.192H680.691L683.4 307.836L680.691 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 300.792H675.273L672.641 296.148L675.273 291.504H680.691L683.323 296.148L680.691 300.792Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.756 285.776H677.285L676.511 284.537L677.285 283.221H678.756L679.453 284.537L678.756 285.776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 277.493H675.273L672.641 272.849L675.273 268.205H680.691L683.4 272.849L680.691 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 265.805H675.273L672.641 261.161L675.273 256.517H680.691L683.4 261.161L680.691 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 254.195H675.273L672.641 249.551L675.273 244.829H680.691L683.4 249.551L680.691 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 242.507H675.273L672.641 237.863L675.273 233.218H680.691L683.4 237.863L680.691 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 230.819H675.273L672.641 226.175L675.273 221.53H680.691L683.4 226.175L680.691 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 225.013H665.21L662.501 220.369L665.21 215.648H670.551L673.26 220.369L670.551 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 219.208H655.07L652.361 214.487L655.07 209.842H660.489L663.198 214.487L660.489 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 213.325H645.008L642.299 208.681L645.008 204.037H650.349L653.058 208.681L650.349 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 207.52H634.868L632.159 202.876L634.868 198.154H640.286L642.995 202.876L640.286 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 201.715H624.805L622.096 196.993L624.805 192.349H630.146L632.855 196.993L630.146 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 195.832H614.665L611.956 191.188L614.665 186.544H620.083L622.793 191.188L620.083 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 190.027H604.603L601.894 185.383L604.603 180.661H609.944L612.653 185.383L609.944 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 184.222H594.463L591.754 179.5L594.463 174.856H599.881L602.59 179.5L599.881 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 178.339H584.401L581.691 173.695L584.401 169.05H589.741L592.451 173.695L589.741 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 172.534H574.26L571.551 167.889L574.26 163.168H579.679L582.388 167.889L579.679 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 160.846H554.058L551.426 156.201L554.058 151.557H559.476L562.108 156.201L559.476 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 154.963H543.995L541.364 150.319L543.995 145.752H549.336L551.968 150.319L549.336 154.963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 149.158H533.856L531.146 144.513L533.856 139.869H539.274L541.906 144.513L539.274 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.431 152.021H525.496L524.567 150.319L525.496 148.693H527.431L528.36 150.319L527.431 152.021Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.848 164.871H504.597L502.971 162.007L504.597 159.22H507.848L509.473 162.007L507.848 164.871Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.631 170.444H494.689L493.141 167.889L494.689 165.258H497.631L499.101 167.889L497.631 170.444Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.342 177.642H483.775L481.53 173.695L483.775 169.747H488.342L490.587 173.695L488.342 177.642Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.041 181.435H474.874L473.79 179.5L474.874 177.642H477.041L478.125 179.5L477.041 181.435Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 475.803H554.058L551.349 471.158L554.058 466.514H559.476L562.185 471.158L559.476 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 469.997H564.198L561.489 465.353L564.198 460.631H569.539L572.248 465.353L569.539 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 464.192H574.26L571.551 459.47L574.26 454.826H579.679L582.388 459.47L579.679 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 458.309H584.401L581.691 453.665L584.401 449.021H589.741L592.451 453.665L589.741 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 452.504H594.463L591.754 447.86L594.463 443.138H599.881L602.59 447.86L599.881 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 446.621H604.603L601.894 441.977L604.603 437.333H609.944L612.653 441.977L609.944 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 440.816H614.665L611.956 436.172L614.665 431.527H620.083L622.793 436.172L620.083 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 435.011H624.805L622.096 430.289L624.805 425.645H630.146L632.855 430.289L630.146 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.209 429.128H634.945L632.236 424.484L634.945 419.917H640.209L642.918 424.484L640.209 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.676 329.896H685.49L682.858 325.329L685.49 320.762H690.676L693.308 325.329L690.676 329.896Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 318.363H685.413L682.704 313.641L685.413 308.997H690.754L693.463 313.641L690.754 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.676 306.52H685.49L682.858 302.031L685.49 297.464H690.676L693.308 302.031L690.676 306.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.289 294.135H685.877L683.709 290.343L685.877 286.55H690.289L692.456 290.343L690.289 294.135Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 283.376H685.413L682.704 278.654L685.413 274.01H690.754L693.463 278.654L690.754 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 271.688H685.413L682.704 267.044L685.413 262.322H690.754L693.463 267.044L690.754 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 260H685.413L682.704 255.356L685.413 250.712H690.754L693.463 255.356L690.754 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 248.312H685.413L682.704 243.668L685.413 239.024H690.754L693.463 243.668L690.754 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 236.702H685.413L682.704 231.98L685.413 227.336H690.754L693.463 231.98L690.754 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 225.013H685.413L682.704 220.369L685.413 215.648H690.754L693.463 220.369L690.754 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 219.208H675.273L672.641 214.487L675.273 209.842H680.691L683.4 214.487L680.691 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 213.325H665.21L662.501 208.681L665.21 204.037H670.551L673.26 208.681L670.551 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 207.52H655.07L652.361 202.876L655.07 198.154H660.489L663.198 202.876L660.489 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 201.715H645.008L642.299 196.993L645.008 192.349H650.349L653.058 196.993L650.349 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 195.832H634.868L632.159 191.188L634.868 186.544H640.286L642.995 191.188L640.286 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 190.027H624.805L622.096 185.383L624.805 180.661H630.146L632.855 185.383L630.146 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 184.222H614.665L611.956 179.5L614.665 174.856H620.083L622.793 179.5L620.083 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 178.339H604.603L601.894 173.695L604.603 169.05H609.944L612.653 173.695L609.944 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 172.534H594.463L591.754 167.889L594.463 163.168H599.881L602.59 167.889L599.881 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 166.651H584.401L581.691 162.007L584.401 157.362H589.741L592.451 162.007L589.741 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.524 160.613H574.415L571.861 156.201L574.415 151.789H579.524L582.078 156.201L579.524 160.613Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.372 151.247H566.365L565.823 150.319L566.365 149.467H567.372L567.913 150.319L567.372 151.247Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 149.158H554.058L551.349 144.513L554.058 139.869H559.476L562.185 144.513L559.476 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 143.352H543.995L541.286 138.708L543.995 133.986H549.336L552.045 138.708L549.336 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 137.547H533.856L531.146 132.825L533.856 128.181H539.274L541.906 132.825L539.274 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.747 142.656H524.18L521.858 138.708L524.18 134.76H528.747L530.992 138.708L528.747 142.656Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.792 160.768H493.451L490.819 156.201L493.451 151.557H498.792L501.501 156.201L498.792 160.768Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.014 408.693H384.001L383.073 406.99L384.001 405.287H386.014L387.02 406.99L386.014 408.693Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.399 487.413H554.136L551.504 482.846L554.136 478.279H559.399L562.031 482.846L559.399 487.413Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 481.685H564.198L561.489 476.964L564.198 472.319H569.539L572.248 476.964L569.539 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 475.803H574.26L571.551 471.158L574.26 466.514H579.679L582.388 471.158L579.679 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 469.997H584.401L581.691 465.353L584.401 460.631H589.741L592.451 465.353L589.741 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 464.192H594.463L591.754 459.47L594.463 454.826H599.881L602.59 459.47L599.881 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 458.309H604.603L601.894 453.665L604.603 449.021H609.944L612.653 453.665L609.944 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 452.504H614.665L611.956 447.86L614.665 443.138H620.083L622.793 447.86L620.083 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 446.621H624.805L622.096 441.977L624.805 437.333H630.146L632.855 441.977L630.146 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 440.816H634.868L632.159 436.172L634.868 431.527H640.286L642.995 436.172L640.286 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.661 323.704H695.785L693.308 319.524L695.785 315.267H700.661L703.061 319.524L700.661 323.704Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.584 312.016H695.785L693.385 307.836L695.785 303.656H700.584L702.983 307.836L700.584 312.016Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.352 299.941H696.017L693.85 296.148L696.017 292.432H700.352L702.519 296.148L700.352 299.941Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 289.181H695.476L692.844 284.537L695.476 279.816H700.894L703.603 284.537L700.894 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 277.493H695.476L692.844 272.849L695.476 268.205H700.894L703.603 272.849L700.894 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 265.805H695.476L692.844 261.161L695.476 256.517H700.894L703.603 261.161L700.894 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 254.195H695.476L692.844 249.551L695.476 244.829H700.894L703.603 249.551L700.894 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 242.507H695.476L692.844 237.863L695.476 233.218H700.894L703.603 237.863L700.894 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 230.819H695.476L692.844 226.175L695.476 221.53H700.894L703.603 226.175L700.894 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 219.208H695.476L692.844 214.487L695.476 209.842H700.894L703.603 214.487L700.894 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 213.325H685.413L682.704 208.681L685.413 204.037H690.754L693.463 208.681L690.754 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 207.52H675.273L672.641 202.876L675.273 198.154H680.691L683.4 202.876L680.691 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 201.715H665.21L662.501 196.993L665.21 192.349H670.551L673.26 196.993L670.551 201.715Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 195.832H655.07L652.361 191.188L655.07 186.544H660.489L663.198 191.188L660.489 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 190.027H645.008L642.299 185.383L645.008 180.661H650.349L653.058 185.383L650.349 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 184.222H634.868L632.159 179.5L634.868 174.856H640.286L642.995 179.5L640.286 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 178.339H624.805L622.096 173.695L624.805 169.05H630.146L632.855 173.695L630.146 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 172.534H614.665L611.956 167.889L614.665 163.168H620.083L622.793 167.889L620.083 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 166.651H604.603L601.894 162.007L604.603 157.362H609.944L612.653 162.007L609.944 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 160.846H594.463L591.754 156.201L594.463 151.557H599.881L602.59 156.201L599.881 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 155.04H584.401L581.691 150.319L584.401 145.674H589.741L592.451 150.319L589.741 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 137.547H554.058L551.349 132.825L554.058 128.181H559.476L562.185 132.825L559.476 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 131.664H543.995L541.286 127.02L543.995 122.376H549.336L552.045 127.02L549.336 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.5 124.62H534.552L532.617 121.215L534.552 117.809H538.5L540.512 121.215L538.5 124.62Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.967 127.949H525.96L525.418 127.02L525.96 126.091H526.967L527.508 127.02L526.967 127.949Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.702 145.442H495.618L495.076 144.513L495.618 143.584H496.702L497.166 144.513L496.702 145.442Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 411.635H362.096L359.387 406.99L362.096 402.346H367.514L370.224 406.99L367.514 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 417.517H372.236L369.527 412.796L372.236 408.151H377.577L380.286 412.796L377.577 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 423.323H382.299L379.667 418.678L382.299 413.957H387.717L390.426 418.678L387.717 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.857 498.172H554.6L552.51 494.457L554.6 490.819H558.857L561.024 494.457L558.857 498.172Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 493.296H564.198L561.489 488.652L564.198 484.007H569.539L572.248 488.652L569.539 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 487.491H574.26L571.551 482.846L574.26 478.125H579.679L582.388 482.846L579.679 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 481.685H584.401L581.691 476.964L584.401 472.319H589.741L592.451 476.964L589.741 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 475.803H594.463L591.754 471.158L594.463 466.514H599.881L602.59 471.158L599.881 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 469.997H604.603L601.894 465.353L604.603 460.631H609.944L612.653 465.353L609.944 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 464.192H614.665L611.956 459.47L614.665 454.826H620.083L622.793 459.47L620.083 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 458.309H624.805L622.096 453.665L624.805 449.021H630.146L632.855 453.665L630.146 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 452.427H634.945L632.236 447.86L634.945 443.215H640.286L642.918 447.86L640.286 452.427Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.098 303.346H707.55L706.699 302.031L707.55 300.637H709.098L709.872 302.031L709.098 303.346Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 294.987H705.615L702.906 290.342L705.615 285.698H710.956L713.665 290.342L710.956 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 283.376H705.615L702.906 278.654L705.615 274.01H710.956L713.665 278.654L710.956 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 271.688H705.615L702.906 267.044L705.615 262.322H710.956L713.665 267.044L710.956 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 260H705.615L702.906 255.356L705.615 250.712H710.956L713.665 255.356L710.956 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 248.312H705.615L702.906 243.668L705.615 239.024H710.956L713.665 243.668L710.956 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 236.702H705.615L702.906 231.98L705.615 227.336H710.956L713.665 231.98L710.956 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 225.013H705.615L702.906 220.369L705.615 215.648H710.956L713.665 220.369L710.956 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 213.325H705.615L702.906 208.681L705.615 204.037H710.956L713.665 208.681L710.956 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 207.52H695.476L692.844 202.876L695.476 198.154H700.894L703.603 202.876L700.894 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 201.715H685.413L682.704 196.993L685.413 192.349H690.754L693.463 196.993L690.754 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 195.832H675.273L672.641 191.188L675.273 186.544H680.691L683.4 191.188L680.691 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 190.027H665.21L662.501 185.383L665.21 180.661H670.551L673.26 185.383L670.551 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 184.222H655.07L652.361 179.5L655.07 174.856H660.489L663.198 179.5L660.489 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 178.339H645.008L642.299 173.695L645.008 169.05H650.349L653.058 173.695L650.349 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 172.534H634.868L632.159 167.889L634.868 163.168H640.286L642.995 167.889L640.286 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 166.651H624.805L622.096 162.007L624.805 157.362H630.146L632.855 162.007L630.146 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 160.846H614.665L611.956 156.201L614.665 151.557H620.083L622.793 156.201L620.083 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 155.04H604.603L601.894 150.319L604.603 145.674H609.944L612.653 150.319L609.944 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.804 149.08H594.54L591.831 144.513L594.54 139.946H599.804L602.436 144.513L599.804 149.08Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 143.275H584.401L581.769 138.708L584.401 134.064H589.741L592.373 138.708L589.741 143.275Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 137.547H574.26L571.551 132.825L574.26 128.181H579.679L582.388 132.825L579.679 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.378 129.652H565.359L563.811 127.02L565.359 124.388H568.378L569.926 127.02L568.378 129.652Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 125.859H554.058L551.349 121.215L554.058 116.493H559.476L562.185 121.215L559.476 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.182 119.821H544.073L541.519 115.332L544.073 110.92H549.182L551.736 115.332L549.182 119.821Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 417.517H352.034L349.324 412.796L352.034 408.151H357.375L360.084 412.796L357.375 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 423.323H362.096L359.387 418.678L362.096 413.957H367.514L370.224 418.678L367.514 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 429.128H372.236L369.527 424.484L372.236 419.839H377.577L380.286 424.484L377.577 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.485 434.701H382.531L379.976 430.289L382.531 425.954H387.485L390.039 430.289L387.485 434.701Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.696 507.848H555.761L554.832 506.145L555.761 504.519H557.696L558.702 506.145L557.696 507.848Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 504.984H564.198L561.489 500.34L564.198 495.618H569.539L572.248 500.34L569.539 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 499.179H574.26L571.551 494.457L574.26 489.813H579.679L582.388 494.457L579.679 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 493.296H584.401L581.691 488.652L584.401 484.007H589.741L592.451 488.652L589.741 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 487.491H594.463L591.754 482.846L594.463 478.125H599.881L602.59 482.846L599.881 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 481.685H604.603L601.894 476.964L604.603 472.319H609.944L612.653 476.964L609.944 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 475.803H614.665L611.956 471.158L614.665 466.514H620.083L622.793 471.158L620.083 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.682 469.068H625.347L623.18 465.353L625.347 461.56H629.682L631.772 465.353L629.682 469.068Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.351 460.786H636.803L636.029 459.47L636.803 458.154H638.351L639.125 459.47L638.351 460.786Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.164 445.925H665.597L663.275 441.977L665.597 438.029H670.164L672.486 441.977L670.164 445.925Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 300.792H715.755L713.046 296.148L715.755 291.504H721.096L723.805 296.148L721.096 300.792Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 289.181H715.678L713.046 284.537L715.678 279.816H721.096L723.805 284.537L721.096 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 277.493H715.678L713.046 272.849L715.678 268.205H721.096L723.805 272.849L721.096 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 265.805H715.678L713.046 261.161L715.678 256.517H721.096L723.805 261.161L721.096 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 254.195H715.678L713.046 249.551L715.678 244.829H721.096L723.805 249.551L721.096 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 242.507H715.678L713.046 237.863L715.678 233.218H721.096L723.805 237.863L721.096 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 230.819H715.678L713.046 226.175L715.678 221.53H721.096L723.805 226.175L721.096 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 219.208H715.678L713.046 214.487L715.678 209.842H721.096L723.805 214.487L721.096 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 207.52H715.678L713.046 202.876L715.678 198.154H721.096L723.805 202.876L721.096 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 201.715H705.615L702.906 196.993L705.615 192.349H710.956L713.665 196.993L710.956 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 195.832H695.476L692.844 191.188L695.476 186.544H700.894L703.603 191.188L700.894 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 190.027H685.413L682.704 185.383L685.413 180.661H690.754L693.463 185.383L690.754 190.027Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 184.222H675.273L672.641 179.5L675.273 174.856H680.691L683.4 179.5L680.691 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 178.339H665.21L662.501 173.695L665.21 169.05H670.551L673.26 173.695L670.551 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 172.534H655.07L652.361 167.889L655.07 163.168H660.489L663.198 167.889L660.489 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 166.651H645.008L642.299 162.007L645.008 157.362H650.349L653.058 162.007L650.349 166.651Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 160.846H634.868L632.159 156.201L634.868 151.557H640.286L642.995 156.201L640.286 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 155.04H624.805L622.096 150.319L624.805 145.674H630.146L632.855 150.319L630.146 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 149.158H614.665L611.956 144.513L614.665 139.869H620.083L622.793 144.513L620.083 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 143.352H604.603L601.894 138.708L604.603 133.986H609.944L612.653 138.708L609.944 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 137.547H594.463L591.754 132.825L594.463 128.181H599.881L602.59 132.825L599.881 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 131.664H584.401L581.691 127.02L584.401 122.376H589.741L592.451 127.02L589.741 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.285 123.537H575.576L574.26 121.215L575.576 118.815H578.285L579.679 121.215L578.285 123.537Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 120.054H564.198L561.489 115.332L564.198 110.688H569.539L572.248 115.332L569.539 120.054Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 114.171H554.058L551.349 109.527L554.058 104.882H559.476L562.185 109.527L559.476 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.91 404.978H352.498L350.331 401.185L352.498 397.392H356.91L359.077 401.185L356.91 404.978Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 423.323H341.894L339.184 418.678L341.894 413.957H347.312L350.021 418.678L347.312 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 429.128H352.034L349.324 424.484L352.034 419.839H357.375L360.084 424.484L357.375 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 435.011H362.096L359.387 430.289L362.096 425.645H367.514L370.224 430.289L367.514 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 440.816H372.236L369.527 436.172L372.236 431.527H377.577L380.286 436.172L377.577 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 516.672H564.198L561.489 511.95L564.198 507.306H569.539L572.248 511.95L569.539 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 510.789H574.26L571.551 506.145L574.26 501.501H579.679L582.388 506.145L579.679 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 504.984H584.401L581.691 500.34L584.401 495.618H589.741L592.451 500.34L589.741 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 499.179H594.463L591.754 494.457L594.463 489.813H599.881L602.59 494.457L599.881 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 493.296H604.603L601.894 488.652L604.603 484.007H609.944L612.653 488.652L609.944 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 487.491H614.665L611.956 482.846L614.665 478.125H620.083L622.793 482.846L620.083 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.902 477.738H627.05L626.663 476.964L627.05 476.267H627.902L628.289 476.964L627.902 477.738Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 464.192H655.07L652.361 459.47L655.07 454.826H660.489L663.198 459.47L660.489 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 458.309H665.21L662.501 453.665L665.21 449.021H670.551L673.26 453.665L670.551 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.23 305.049H726.747L724.966 302.031L726.747 298.934H730.23L732.01 302.031L730.23 305.049Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 294.987H725.818L723.109 290.342L725.818 285.698H731.236L733.868 290.342L731.236 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 283.376H725.818L723.109 278.654L725.818 274.01H731.236L733.868 278.654L731.236 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 271.688H725.818L723.109 267.044L725.818 262.322H731.236L733.868 267.044L731.236 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 260H725.818L723.109 255.356L725.818 250.712H731.236L733.868 255.356L731.236 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 248.312H725.818L723.109 243.668L725.818 239.024H731.236L733.868 243.668L731.236 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 236.702H725.818L723.109 231.98L725.818 227.336H731.236L733.868 231.98L731.236 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 225.013H725.818L723.109 220.369L725.818 215.648H731.236L733.868 220.369L731.236 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 213.325H725.818L723.109 208.681L725.818 204.037H731.236L733.868 208.681L731.236 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 201.715H725.818L723.109 196.993L725.818 192.349H731.236L733.868 196.993L731.236 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 195.832H715.678L713.046 191.188L715.678 186.544H721.096L723.805 191.188L721.096 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 190.027H705.615L702.906 185.383L705.615 180.661H710.956L713.665 185.383L710.956 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 184.222H695.476L692.844 179.5L695.476 174.856H700.894L703.603 179.5L700.894 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 178.339H685.413L682.704 173.695L685.413 169.05H690.754L693.463 173.695L690.754 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 172.534H675.273L672.641 167.889L675.273 163.168H680.691L683.4 167.889L680.691 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 166.651H665.21L662.501 162.007L665.21 157.362H670.551L673.26 162.007L670.551 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 160.846H655.07L652.361 156.201L655.07 151.557H660.489L663.198 156.201L660.489 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 155.04H645.008L642.299 150.319L645.008 145.674H650.349L653.058 150.319L650.349 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 149.158H634.868L632.159 144.513L634.868 139.869H640.286L642.995 144.513L640.286 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 143.352H624.805L622.096 138.708L624.805 133.986H630.146L632.855 138.708L630.146 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.083 137.547H614.665L611.956 132.825L614.665 128.181H620.083L622.793 132.825L620.083 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 131.664H604.603L601.894 127.02L604.603 122.376H609.944L612.653 127.02L609.944 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 125.859H594.463L591.754 121.215L594.463 116.493H599.881L602.59 121.215L599.881 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 120.054H584.401L581.691 115.332L584.401 110.688H589.741L592.451 115.332L589.741 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.601 114.171H574.338L571.629 109.527L574.338 104.882H579.601L582.31 109.527L579.601 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.539 108.366H564.198L561.489 103.721L564.198 98.9998H569.539L572.248 103.721L569.539 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.857 101.399H554.677L552.665 97.8387L554.677 94.2781H558.857L560.87 97.8387L558.857 101.399Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.228 398.166H342.977L341.352 395.302L342.977 392.516H346.228L347.854 395.302L346.228 398.166Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 411.635H341.894L339.184 406.99L341.894 402.346H347.312L350.021 406.99L347.312 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 429.128H331.831L329.122 424.484L331.831 419.839H337.172L339.881 424.484L337.172 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 435.011H341.894L339.184 430.289L341.894 425.645H347.312L350.021 430.289L347.312 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 440.816H352.034L349.324 436.172L352.034 431.527H357.375L360.084 436.172L357.375 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 446.621H362.096L359.387 441.977L362.096 437.333H367.514L370.224 441.977L367.514 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.113 451.653H372.701L370.456 447.86L372.701 443.99H377.113L379.357 447.86L377.113 451.653Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.229 527.663H564.508L562.186 523.638L564.508 519.613H569.229L571.551 523.638L569.229 527.663Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 522.477H574.26L571.551 517.833L574.26 513.189H579.679L582.388 517.833L579.679 522.477Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 516.672H584.401L581.691 511.95L584.401 507.306H589.741L592.451 511.95L589.741 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 510.789H594.463L591.754 506.145L594.463 501.501H599.881L602.59 506.145L599.881 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 504.984H604.603L601.894 500.34L604.603 495.618H609.944L612.653 500.34L609.944 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.839 495.308H616.91L616.368 494.457L616.91 493.605H617.839L618.381 494.457L617.839 495.308Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.723 478.744H646.633L645.627 476.964L646.633 475.261H648.723L649.729 476.964L648.723 478.744Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 475.803H655.07L652.361 471.158L655.07 466.514H660.489L663.198 471.158L660.489 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.396 469.688H665.365L662.888 465.353L665.365 460.941H670.396L672.95 465.353L670.396 469.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.144 312.248H736.035L733.481 307.836L736.035 303.424H741.144L743.698 307.836L741.144 312.248Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 300.869H735.88L733.248 296.148L735.88 291.504H741.298L744.007 296.148L741.298 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 289.181H735.88L733.248 284.537L735.88 279.816H741.298L744.007 284.537L741.298 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 277.493H735.88L733.248 272.849L735.88 268.205H741.298L744.007 272.849L741.298 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 265.805H735.88L733.248 261.161L735.88 256.517H741.298L744.007 261.161L741.298 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 254.195H735.88L733.248 249.551L735.88 244.829H741.298L744.007 249.551L741.298 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 242.507H735.88L733.248 237.863L735.88 233.218H741.298L744.007 237.863L741.298 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 230.819H735.88L733.248 226.175L735.88 221.53H741.298L744.007 226.175L741.298 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 219.208H735.88L733.248 214.487L735.88 209.842H741.298L744.007 214.487L741.298 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 207.52H735.88L733.248 202.876L735.88 198.154H741.298L744.007 202.876L741.298 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 195.832H735.88L733.248 191.188L735.88 186.544H741.298L744.007 191.188L741.298 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 190.027H725.818L723.109 185.383L725.818 180.661H731.236L733.868 185.383L731.236 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 184.222H715.678L713.046 179.5L715.678 174.856H721.096L723.805 179.5L721.096 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 178.339H705.615L702.906 173.695L705.615 169.05H710.956L713.665 173.695L710.956 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 172.534H695.476L692.844 167.889L695.476 163.168H700.894L703.603 167.889L700.894 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 166.651H685.413L682.704 162.007L685.413 157.362H690.754L693.463 162.007L690.754 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 160.846H675.273L672.641 156.201L675.273 151.557H680.691L683.4 156.201L680.691 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 155.04H665.21L662.501 150.319L665.21 145.674H670.551L673.26 150.319L670.551 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 149.158H655.07L652.361 144.513L655.07 139.869H660.489L663.198 144.513L660.489 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 143.352H645.008L642.299 138.708L645.008 133.986H650.349L653.058 138.708L650.349 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 137.547H634.868L632.159 132.825L634.868 128.181H640.286L642.995 132.825L640.286 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.146 131.664H624.805L622.096 127.02L624.805 122.376H630.146L632.855 127.02L630.146 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.465 124.853H615.285L613.117 121.215L615.285 117.499H619.465L621.632 121.215L619.465 124.853Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 120.054H604.603L601.894 115.332L604.603 110.688H609.944L612.653 115.332L609.944 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 114.171H594.463L591.754 109.527L594.463 104.882H599.881L602.59 109.527L599.881 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 108.366H584.401L581.691 103.721L584.401 98.9998H589.741L592.451 103.721L589.741 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.679 102.56H574.26L571.551 97.8387L574.26 93.1945H579.679L582.388 97.8387L579.679 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.229 96.1358H564.507L562.108 92.0334L564.507 87.931H569.229L571.629 92.0334L569.229 96.1358Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.14 119.28H463.573L461.328 115.332L463.573 111.462H468.14L470.384 115.332L468.14 119.28Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.154 125.394H453.278L450.878 121.215L453.278 116.957H458.154L460.631 121.215L458.154 125.394Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.094 207.365H331.908L329.277 202.876L331.908 198.309H337.094L339.726 202.876L337.094 207.365Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.243 380.828H332.76L330.98 377.809L332.76 374.79H336.243L338.024 377.809L336.243 380.828Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.094 393.987H331.908L329.277 389.497L331.908 385.008H337.094L339.726 389.497L337.094 393.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 405.829H331.831L329.122 401.185L331.831 396.463H337.172L339.881 401.185L337.172 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 417.517H331.831L329.122 412.796L331.831 408.151H337.172L339.881 412.796L337.172 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 435.011H321.691L318.982 430.289L321.691 425.645H327.109L329.819 430.289L327.109 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 440.816H331.831L329.122 436.172L331.831 431.527H337.172L339.881 436.172L337.172 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 446.621H341.894L339.184 441.977L341.894 437.333H347.312L350.021 441.977L347.312 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 452.504H352.034L349.324 447.86L352.034 443.138H357.375L360.084 447.86L357.375 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 458.309H362.096L359.387 453.665L362.096 449.021H367.514L370.224 453.665L367.514 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.564 460.554H374.326L373.707 459.47L374.326 458.464H375.564L376.106 459.47L375.564 460.554Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.44 531.998H575.499L574.028 529.444L575.499 526.967H578.44L579.911 529.444L578.44 531.998Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.2 527.276H584.942L582.853 523.638L584.942 520H589.2L591.29 523.638L589.2 527.276Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.804 522.322H594.54L591.909 517.833L594.54 513.266H599.804L602.436 517.833L599.804 522.322Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.776 512.802H606.77L606.306 511.95L606.77 511.176H607.776L608.241 511.95L607.776 512.802Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.645 490.355H646.71L645.704 488.652L646.71 486.949H648.645L649.652 488.652L648.645 490.355Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 487.491H655.07L652.361 482.846L655.07 478.125H660.489L663.198 482.846L660.489 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.545 479.905H666.217L664.514 476.964L666.217 474.1H669.545L671.248 476.964L669.545 479.905Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.503 338.41H747.878L747.026 337.017L747.878 335.546H749.503L750.355 337.017L749.503 338.41Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.284 329.741H746.175L743.621 325.329L746.175 320.917H751.284L753.838 325.329L751.284 329.741Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 318.363H746.02L743.311 313.641L746.02 308.997H751.438L754.07 313.641L751.438 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 306.675H746.02L743.311 302.03L746.02 297.309H751.438L754.07 302.03L751.438 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 294.987H746.02L743.311 290.342L746.02 285.698H751.438L754.07 290.342L751.438 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 283.376H746.02L743.311 278.654L746.02 274.01H751.438L754.07 278.654L751.438 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 271.688H746.02L743.311 267.044L746.02 262.322H751.438L754.07 267.044L751.438 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 260H746.02L743.311 255.356L746.02 250.712H751.438L754.07 255.356L751.438 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 248.312H746.02L743.311 243.668L746.02 239.024H751.438L754.07 243.668L751.438 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 236.702H746.02L743.311 231.98L746.02 227.336H751.438L754.07 231.98L751.438 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 225.013H746.02L743.311 220.369L746.02 215.648H751.438L754.07 220.369L751.438 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 213.325H746.02L743.311 208.681L746.02 204.037H751.438L754.07 208.681L751.438 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 201.715H746.02L743.311 196.993L746.02 192.349H751.438L754.07 196.993L751.438 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 190.027H746.02L743.311 185.383L746.02 180.661H751.438L754.07 185.383L751.438 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 184.222H735.88L733.248 179.5L735.88 174.856H741.298L744.007 179.5L741.298 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 178.339H725.818L723.109 173.695L725.818 169.05H731.236L733.868 173.695L731.236 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 172.534H715.678L713.046 167.889L715.678 163.168H721.096L723.805 167.889L721.096 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 166.651H705.615L702.906 162.007L705.615 157.362H710.956L713.665 162.007L710.956 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 160.846H695.476L692.844 156.201L695.476 151.557H700.894L703.603 156.201L700.894 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 155.04H685.413L682.704 150.319L685.413 145.674H690.754L693.463 150.319L690.754 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 149.158H675.273L672.641 144.513L675.273 139.869H680.691L683.4 144.513L680.691 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 143.352H665.21L662.501 138.708L665.21 133.986H670.551L673.26 138.708L670.551 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 137.547H655.07L652.361 132.825L655.07 128.181H660.489L663.198 132.825L660.489 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 131.664H645.008L642.299 127.02L645.008 122.376H650.349L653.058 127.02L650.349 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.286 125.859H634.868L632.159 121.215L634.868 116.493H640.286L642.995 121.215L640.286 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.992 119.744H624.96L622.483 115.332L624.96 110.997H629.992L632.546 115.332L629.992 119.744Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.944 108.366H604.603L601.894 103.721L604.603 99.0771H609.944L612.653 103.721L609.944 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.881 102.56H594.463L591.754 97.8387L594.463 93.1945H599.881L602.59 97.8387L599.881 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.741 96.6776H584.401L581.691 92.0334L584.401 87.3892H589.741L592.451 92.0334L589.741 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.292 90.2531H574.647L572.325 86.2281L574.647 82.1256H579.292L581.614 86.2281L579.292 90.2531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.077 113.552H453.433L451.111 109.527L453.433 105.502H458.077L460.399 109.527L458.077 113.552Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.247 119.976H442.983L440.351 115.332L442.983 110.765H448.247L450.956 115.332L448.247 119.976Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.8 189.485H322.001L319.601 185.383L322.001 181.203H326.8L329.199 185.383L326.8 189.485Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.335 200.399H322.465L320.53 196.993L322.465 193.665H326.335L328.271 196.993L326.335 200.399Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.871 374.481H322.93L321.536 372.004L322.93 369.527H325.871L327.264 372.004L325.871 374.481Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 388.336H321.691L318.982 383.692L321.691 378.97H327.109L329.819 383.692L327.109 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 400.024H321.691L318.982 395.302L321.691 390.658H327.109L329.819 395.302L327.109 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 411.635H321.691L318.982 406.99L321.691 402.346H327.109L329.819 406.99L327.109 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 423.323H321.691L318.982 418.678L321.691 413.957H327.109L329.819 418.678L327.109 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 440.816H311.629L308.92 436.172L311.629 431.527H316.97L319.679 436.172L316.97 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 446.621H321.691L318.982 441.977L321.691 437.333H327.109L329.819 441.977L327.109 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 452.504H331.831L329.122 447.86L331.831 443.138H337.172L339.881 447.86L337.172 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 458.309H341.894L339.184 453.665L341.894 449.021H347.312L350.021 453.665L347.312 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 464.192H352.034L349.324 459.47L352.034 454.826H357.375L360.084 459.47L357.375 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 469.997H362.096L359.387 465.353L362.096 460.631H367.514L370.224 465.353L367.514 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.018 496.547H656.618L655.38 494.457L656.618 492.444H659.018L660.179 494.457L659.018 496.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.953 356.446H757.708L756.547 354.51L757.708 352.575H759.953L761.036 354.51L759.953 356.446Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 347.467H756.16L753.451 342.822L756.16 338.178H761.501L764.21 342.822L761.501 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 335.856H756.082L753.451 331.134L756.082 326.49H761.501L764.21 331.134L761.501 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 324.168H756.082L753.451 319.524L756.082 314.802H761.501L764.21 319.524L761.501 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 312.48H756.082L753.451 307.836L756.082 303.192H761.501L764.21 307.836L761.501 312.48Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 300.869H756.082L753.451 296.148L756.082 291.504H761.501L764.21 296.148L761.501 300.869Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 289.181H756.082L753.451 284.537L756.082 279.816H761.501L764.21 284.537L761.501 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 277.493H756.082L753.451 272.849L756.082 268.205H761.501L764.21 272.849L761.501 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 265.805H756.082L753.451 261.161L756.082 256.517H761.501L764.21 261.161L761.501 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 254.195H756.082L753.451 249.551L756.082 244.829H761.501L764.21 249.551L761.501 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 242.507H756.082L753.451 237.863L756.082 233.218H761.501L764.21 237.863L761.501 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 230.819H756.082L753.451 226.175L756.082 221.53H761.501L764.21 226.175L761.501 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 219.208H756.082L753.451 214.487L756.082 209.842H761.501L764.21 214.487L761.501 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 207.52H756.082L753.451 202.876L756.082 198.154H761.501L764.21 202.876L761.501 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 195.832H756.082L753.451 191.188L756.082 186.544H761.501L764.21 191.188L761.501 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 184.222H756.082L753.451 179.5L756.082 174.856H761.501L764.21 179.5L761.501 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 178.339H746.02L743.311 173.695L746.02 169.05H751.438L754.07 173.695L751.438 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 172.534H735.88L733.248 167.889L735.88 163.168H741.298L744.007 167.889L741.298 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 166.651H725.818L723.109 162.007L725.818 157.362H731.236L733.868 162.007L731.236 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 160.846H715.678L713.046 156.201L715.678 151.557H721.096L723.805 156.201L721.096 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 155.04H705.615L702.906 150.319L705.615 145.674H710.956L713.665 150.319L710.956 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 149.158H695.476L692.844 144.513L695.476 139.869H700.894L703.603 144.513L700.894 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 143.352H685.413L682.704 138.708L685.413 133.986H690.754L693.463 138.708L690.754 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 137.547H675.273L672.641 132.825L675.273 128.181H680.691L683.4 132.825L680.691 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 131.664H665.21L662.501 127.02L665.21 122.376H670.551L673.26 127.02L670.551 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 125.859H655.07L652.361 121.215L655.07 116.493H660.489L663.198 121.215L660.489 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.349 120.054H645.008L642.299 115.332L645.008 110.688H650.349L653.058 115.332L650.349 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.209 114.094H634.945L632.313 109.527L634.945 104.96H640.209L642.84 109.527L640.209 114.094Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.991 108.056H624.96L622.406 103.721L624.96 99.3094H629.991L632.546 103.721L629.991 108.056Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.929 102.328H614.82L612.266 97.8387L614.82 93.4266H619.929L622.483 97.8387L619.929 102.328Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.402 95.7488H605.145L602.977 92.0334L605.145 88.2406H609.402L611.569 92.0334L609.402 95.7488Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.339 89.9435H595.005L592.837 86.2281L595.005 82.4353H599.339L601.507 86.2281L599.339 89.9435Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.658 83.1319H585.484L583.859 80.3454L585.484 77.5588H588.658L590.283 80.3454L588.658 83.1319Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.931 105.966H444.299L443.061 103.721L444.299 101.477H446.931L448.247 103.721L446.931 105.966Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.106 146.526H373.784L372.623 144.513L373.784 142.501H376.106L377.267 144.513L376.106 146.526Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.18 176.868H322.62L320.762 173.695L322.62 170.521H326.18L328.038 173.695L326.18 176.868Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 184.222H311.629L308.92 179.5L311.629 174.856H316.97L319.679 179.5L316.97 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.808 193.82H312.79L311.319 191.188L312.79 188.556H315.808L317.279 191.188L315.808 193.82Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.267 367.824H313.332L312.403 366.199L313.332 364.496H315.267L316.196 366.199L315.267 367.824Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 382.531H311.629L308.92 377.809L311.629 373.165H316.97L319.679 377.809L316.97 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 394.141H311.629L308.92 389.497L311.629 384.853H316.97L319.679 389.497L316.97 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 405.829H311.629L308.92 401.185L311.629 396.463H316.97L319.679 401.185L316.97 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 417.517H311.629L308.92 412.796L311.629 408.151H316.97L319.679 412.796L316.97 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 429.128H311.629L308.92 424.484L311.629 419.839H316.97L319.679 424.484L316.97 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 446.621H301.488L298.779 441.977L301.488 437.333H306.907L309.616 441.977L306.907 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 452.504H311.629L308.92 447.86L311.629 443.138H316.97L319.679 447.86L316.97 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 458.309H321.691L318.982 453.665L321.691 449.021H327.109L329.819 453.665L327.109 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 464.192H331.831L329.122 459.47L331.831 454.826H337.172L339.881 459.47L337.172 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 469.997H341.894L339.184 465.353L341.894 460.631H347.312L350.021 465.353L347.312 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 475.803H352.034L349.324 471.158L352.034 466.514H357.375L360.084 471.158L357.375 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 481.685H362.096L359.387 476.964L362.096 472.319H367.514L370.224 476.964L367.514 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.867 363.721H766.919L764.984 360.316L766.919 356.91H770.867L772.879 360.316L770.867 363.721Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 353.349H766.222L763.513 348.705L766.222 343.984H771.641L774.272 348.705L771.641 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 341.661H766.222L763.513 337.017L766.222 332.373H771.641L774.272 337.017L771.641 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 329.973H766.222L763.513 325.329L766.222 320.685H771.641L774.272 325.329L771.641 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 318.363H766.222L763.513 313.641L766.222 308.997H771.641L774.272 313.641L771.641 318.363Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 306.675H766.222L763.513 302.03L766.222 297.309H771.641L774.272 302.03L771.641 306.675Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 294.987H766.222L763.513 290.342L766.222 285.698H771.641L774.272 290.342L771.641 294.987Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 283.376H766.222L763.513 278.654L766.222 274.01H771.641L774.272 278.654L771.641 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 271.688H766.222L763.513 267.044L766.222 262.322H771.641L774.272 267.044L771.641 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 260H766.222L763.513 255.356L766.222 250.712H771.641L774.272 255.356L771.641 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 248.312H766.222L763.513 243.668L766.222 239.024H771.641L774.272 243.668L771.641 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 236.702H766.222L763.513 231.98L766.222 227.336H771.641L774.272 231.98L771.641 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 225.013H766.222L763.513 220.369L766.222 215.648H771.641L774.272 220.369L771.641 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 213.325H766.222L763.513 208.681L766.222 204.037H771.641L774.272 208.681L771.641 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 201.715H766.222L763.513 196.993L766.222 192.349H771.641L774.272 196.993L771.641 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 190.027H766.222L763.513 185.383L766.222 180.661H771.641L774.272 185.383L771.641 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 178.339H766.222L763.513 173.695L766.222 169.05H771.641L774.272 173.695L771.641 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 172.534H756.082L753.451 167.889L756.082 163.168H761.501L764.21 167.889L761.501 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 166.651H746.02L743.311 162.007L746.02 157.362H751.438L754.07 162.007L751.438 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 160.846H735.88L733.248 156.201L735.88 151.557H741.298L744.007 156.201L741.298 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 155.04H725.818L723.109 150.319L725.818 145.674H731.236L733.868 150.319L731.236 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 149.158H715.678L713.046 144.513L715.678 139.869H721.096L723.805 144.513L721.096 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 143.352H705.615L702.906 138.708L705.615 133.986H710.956L713.665 138.708L710.956 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 137.547H695.476L692.844 132.825L695.476 128.181H700.894L703.603 132.825L700.894 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 131.664H685.413L682.704 127.02L685.413 122.376H690.754L693.463 127.02L690.754 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 125.859H675.273L672.641 121.215L675.273 116.493H680.691L683.4 121.215L680.691 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 120.054H665.21L662.501 115.332L665.21 110.688H670.551L673.26 115.332L670.551 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.489 114.171H655.07L652.361 109.527L655.07 104.882H660.489L663.198 109.527L660.489 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.42 106.663H645.937L644.234 103.721L645.937 100.703H649.42L651.123 103.721L649.42 106.663Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.899 101.864H635.255L633.01 97.8387L635.255 93.8911H639.899L642.221 97.8387L639.899 101.864Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 55.8857H554.058L551.426 51.1641L554.058 46.5198H559.476L562.108 51.1641L559.476 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.33 48.2227H545.002L543.299 45.3588L545.002 42.4948H548.33L550.033 45.3588L548.33 48.2227Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.726 41.566H535.404L534.243 39.5535L535.404 37.541H537.726L538.887 39.5535L537.726 41.566Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.627 128.104H384.388L383.846 127.02L384.388 126.014H385.627L386.246 127.02L385.627 128.104Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 137.547H372.236L369.527 132.825L372.236 128.181H377.577L380.286 132.825L377.577 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.205 142.81H362.406L360.006 138.708L362.406 134.528H367.205L369.604 138.708L367.205 142.81Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 172.534H311.629L308.92 167.889L311.629 163.168H316.97L319.679 167.889L316.97 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 178.339H301.488L298.779 173.695L301.488 169.05H306.907L309.616 173.695L306.907 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 190.027H301.488L298.779 185.383L301.488 180.661H306.907L309.616 185.383L306.907 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83 201.637H301.566L298.857 196.993L301.566 192.426H306.83L309.539 196.993L306.83 201.637Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.52 212.706H301.876L299.554 208.681L301.876 204.656H306.52L308.765 208.681L306.52 212.706Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.752 364.728H301.643L299.089 360.316L301.643 355.904H306.752L309.306 360.316L306.752 364.728Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 376.648H301.488L298.779 372.004L301.488 367.359H306.907L309.616 372.004L306.907 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 388.336H301.488L298.779 383.692L301.488 378.97H306.907L309.616 383.692L306.907 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 400.024H301.488L298.779 395.302L301.488 390.658H306.907L309.616 395.302L306.907 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 411.635H301.488L298.779 406.99L301.488 402.346H306.907L309.616 406.99L306.907 411.635Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 423.323H301.488L298.779 418.678L301.488 413.957H306.907L309.616 418.678L306.907 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 435.011H301.488L298.779 430.289L301.488 425.645H306.907L309.616 430.289L306.907 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 452.504H291.426L288.717 447.86L291.426 443.138H296.767L299.476 447.86L296.767 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 458.309H301.488L298.779 453.665L301.488 449.021H306.907L309.616 453.665L306.907 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 464.192H311.629L308.92 459.47L311.629 454.826H316.97L319.679 459.47L316.97 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 469.997H321.691L318.982 465.353L321.691 460.631H327.109L329.819 465.353L327.109 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 475.803H331.831L329.122 471.158L331.831 466.514H337.172L339.881 471.158L337.172 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 481.685H341.894L339.184 476.964L341.894 472.319H347.312L350.021 476.964L347.312 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 487.491H352.034L349.324 482.846L352.034 478.202H357.375L360.084 482.846L357.375 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.929 369.449H777.136L775.201 366.198L777.136 362.87H780.929L782.864 366.198L780.929 369.449Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.316 335.159H776.672L774.427 331.134L776.672 327.187H781.316L783.638 331.134L781.316 335.159Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 324.168H776.285L773.653 319.524L776.285 314.802H781.703L784.412 319.524L781.703 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 312.48H776.285L773.653 307.836L776.285 303.192H781.703L784.412 307.836L781.703 312.48Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 300.869H776.285L773.653 296.148L776.285 291.504H781.703L784.412 296.148L781.703 300.869Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 289.181H776.285L773.653 284.537L776.285 279.816H781.703L784.412 284.537L781.703 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 277.493H776.285L773.653 272.849L776.285 268.205H781.703L784.412 272.849L781.703 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 265.805H776.285L773.653 261.161L776.285 256.517H781.703L784.412 261.161L781.703 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 254.195H776.285L773.653 249.551L776.285 244.829H781.703L784.412 249.551L781.703 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 242.507H776.285L773.653 237.863L776.285 233.218H781.703L784.412 237.863L781.703 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 230.819H776.285L773.653 226.175L776.285 221.53H781.703L784.412 226.175L781.703 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 219.208H776.285L773.653 214.487L776.285 209.842H781.703L784.412 214.487L781.703 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 207.52H776.285L773.653 202.876L776.285 198.154H781.703L784.412 202.876L781.703 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 195.832H776.285L773.653 191.188L776.285 186.544H781.703L784.412 191.188L781.703 195.832Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 184.222H776.285L773.653 179.5L776.285 174.856H781.703L784.412 179.5L781.703 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 172.534H776.285L773.653 167.889L776.285 163.168H781.703L784.412 167.889L781.703 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 166.651H766.222L763.513 162.007L766.222 157.362H771.641L774.272 162.007L771.641 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 160.846H756.082L753.451 156.201L756.082 151.557H761.501L764.21 156.201L761.501 160.846Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 155.04H746.02L743.311 150.319L746.02 145.674H751.438L754.07 150.319L751.438 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 149.158H735.88L733.248 144.513L735.88 139.869H741.298L744.007 144.513L741.298 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 143.352H725.818L723.109 138.708L725.818 133.986H731.236L733.868 138.708L731.236 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 137.547H715.678L713.046 132.825L715.678 128.181H721.096L723.805 132.825L721.096 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 131.664H705.615L702.906 127.02L705.615 122.376H710.956L713.665 127.02L710.956 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 125.859H695.476L692.844 121.215L695.476 116.493H700.894L703.603 121.215L700.894 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 120.054H685.413L682.704 115.332L685.413 110.688H690.754L693.463 115.332L690.754 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 114.171H675.273L672.641 109.527L675.273 104.882H680.691L683.4 109.527L680.691 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.551 108.366H665.21L662.501 103.721L665.21 98.9998H670.551L673.26 103.721L670.551 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.637 101.012H655.999L654.142 97.8387L655.999 94.7426H659.637L661.418 97.8387L659.637 101.012Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.511 52.0929H576.428L575.886 51.1641L576.428 50.3126H577.511L578.053 51.1641L577.511 52.0929Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.913 47.2165H565.746L564.662 45.3588L565.746 43.5011H567.913L569.074 45.3588L567.913 47.2165Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.476 44.1977H554.058L551.349 39.5535L554.058 34.8318H559.476L562.185 39.5535L559.476 44.1977Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.336 38.3924H543.995L541.286 33.6707L543.995 29.0265H549.336L552.045 33.6707L549.336 38.3924Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.274 32.5097H533.856L531.146 27.8654L533.856 23.2212H539.274L541.906 27.8654L539.274 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.621 82.0482H444.686L443.68 80.3453L444.686 78.6425H446.621L447.55 80.3453L446.621 82.0482Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.178 89.0146H433.927L432.224 86.2281L433.927 83.3641H437.178L438.803 86.2281L437.178 89.0146Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.122 96.6776H422.781L420.072 92.0334L422.781 87.3892H428.122L430.753 92.0334L428.122 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 102.56H412.641L409.932 97.8387L412.641 93.1945H417.982L420.691 97.8387L417.982 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 108.366H402.501L399.869 103.721L402.501 99.0771H407.919L410.551 103.721L407.919 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.625 113.861H392.671L390.116 109.527L392.671 105.192H397.625L400.101 109.527L397.625 113.861Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.407 119.512H382.608L380.208 115.332L382.608 111.152H387.407L389.884 115.332L387.407 119.512Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 125.859H372.236L369.527 121.215L372.236 116.493H377.577L380.286 121.215L377.577 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 131.664H362.096L359.387 127.02L362.096 122.376H367.514L370.224 127.02L367.514 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 136.386H352.653L350.64 132.825L352.653 129.342H356.755L358.768 132.825L356.755 136.386Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.892 160.691H311.706L309.074 156.201L311.706 151.712H316.892L319.524 156.201L316.892 160.691Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 166.651H301.488L298.779 162.007L301.488 157.362H306.907L309.616 162.007L306.907 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 172.534H291.426L288.717 167.889L291.426 163.168H296.767L299.476 167.889L296.767 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 184.222H291.426L288.717 179.5L291.426 174.856H296.767L299.476 179.5L296.767 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 195.832H291.426L288.717 191.188L291.426 186.544H296.767L299.476 191.188L296.767 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 207.52H291.426L288.717 202.876L291.426 198.154H296.767L299.476 202.876L296.767 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.838 217.505H292.355L290.652 214.487L292.355 211.545H295.838L297.541 214.487L295.838 217.505Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.303 358.381H291.891L289.646 354.51L291.891 350.64H296.303L298.547 354.51L296.303 358.381Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 370.843H291.426L288.717 366.198L291.426 361.477H296.767L299.476 366.198L296.767 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 382.531H291.426L288.717 377.809L291.426 373.165H296.767L299.476 377.809L296.767 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 394.141H291.426L288.717 389.497L291.426 384.853H296.767L299.476 389.497L296.767 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 405.829H291.426L288.717 401.185L291.426 396.463H296.767L299.476 401.185L296.767 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 417.517H291.426L288.717 412.796L291.426 408.151H296.767L299.476 412.796L296.767 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 429.128H291.426L288.717 424.484L291.426 419.839H296.767L299.476 424.484L296.767 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 440.816H291.426L288.717 436.172L291.426 431.527H296.767L299.476 436.172L296.767 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 458.309H281.286L278.577 453.665L281.286 449.021H286.704L289.414 453.665L286.704 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 464.192H291.426L288.717 459.47L291.426 454.826H296.767L299.476 459.47L296.767 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 469.997H301.488L298.779 465.353L301.488 460.631H306.907L309.616 465.353L306.907 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 475.803H311.629L308.92 471.158L311.629 466.514H316.97L319.679 471.158L316.97 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 481.685H321.691L318.982 476.964L321.691 472.319H327.109L329.819 476.964L327.109 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 487.491H331.831L329.122 482.846L331.831 478.125H337.172L339.881 482.846L337.172 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 493.296H341.894L339.184 488.652L341.894 484.007H347.312L350.021 488.652L347.312 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.063 326.955H788.205L787.276 325.329L788.205 323.704H790.063L790.992 325.329L790.063 326.955Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 318.363H786.425L783.716 313.641L786.425 308.997H791.843L794.475 313.641L791.843 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 306.675H786.425L783.716 302.03L786.425 297.309H791.843L794.475 302.03L791.843 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 294.987H786.425L783.716 290.342L786.425 285.698H791.843L794.475 290.342L791.843 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 283.376H786.425L783.716 278.654L786.425 274.01H791.843L794.475 278.654L791.843 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 271.688H786.425L783.716 267.044L786.425 262.322H791.843L794.475 267.044L791.843 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 260H786.425L783.716 255.356L786.425 250.712H791.843L794.475 255.356L791.843 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 248.312H786.425L783.716 243.668L786.425 239.024H791.843L794.475 243.668L791.843 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 236.702H786.425L783.716 231.98L786.425 227.336H791.843L794.475 231.98L791.843 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 225.013H786.425L783.716 220.369L786.425 215.648H791.843L794.475 220.369L791.843 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 213.325H786.425L783.716 208.681L786.425 204.037H791.843L794.475 208.681L791.843 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 201.715H786.425L783.716 196.993L786.425 192.349H791.843L794.475 196.993L791.843 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 190.027H786.425L783.716 185.383L786.425 180.661H791.843L794.475 185.383L791.843 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 178.339H786.425L783.716 173.695L786.425 169.05H791.843L794.475 173.695L791.843 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 166.651H786.425L783.716 162.007L786.425 157.362H791.843L794.475 162.007L791.843 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 160.846H776.285L773.653 156.201L776.285 151.557H781.703L784.412 156.201L781.703 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 155.04H766.222L763.513 150.319L766.222 145.674H771.641L774.272 150.319L771.641 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 149.158H756.082L753.451 144.513L756.082 139.869H761.501L764.21 144.513L761.501 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 143.352H746.02L743.311 138.708L746.02 133.986H751.438L754.07 138.708L751.438 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 137.547H735.88L733.248 132.825L735.88 128.181H741.298L744.007 132.825L741.298 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 131.664H725.818L723.109 127.02L725.818 122.376H731.236L733.868 127.02L731.236 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 125.859H715.678L713.046 121.215L715.678 116.493H721.096L723.805 121.215L721.096 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 120.054H705.615L702.906 115.332L705.615 110.688H710.956L713.665 115.332L710.956 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 114.171H695.476L692.844 109.527L695.476 104.882H700.894L703.603 109.527L700.894 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 108.366H685.413L682.704 103.721L685.413 98.9998H690.754L693.463 103.721L690.754 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.691 102.56H675.273L672.641 97.8387L675.273 93.1945H680.691L683.4 97.8387L680.691 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.693 93.5041H667.068L666.216 92.0334L667.068 90.5627H668.693L669.545 92.0334L668.693 93.5041Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.976 41.2564H575.963L575.034 39.5535L575.963 37.8506H577.976L578.904 39.5535L577.976 41.2564Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.687 36.8443H565.049L563.269 33.6707L565.049 30.5746H568.687L570.468 33.6707L568.687 36.8443Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.083 30.1876H555.374L554.058 27.8655L555.374 25.5433H558.083L559.476 27.8655L558.083 30.1876Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.247 22.989H546.086L545.544 22.0602L546.086 21.0539H547.247L547.788 22.0602L547.247 22.989Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.247 73.2242H443.061L440.429 68.7348L443.061 64.1679H448.247L450.801 68.7348L448.247 73.2242Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.333 77.6362H433.773L431.992 74.5401L433.773 71.4439H437.333L439.113 74.5401L437.333 77.6362Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.502 83.9834H423.322L421.232 80.3454L423.322 76.7074H427.502L429.669 80.3454L427.502 83.9834Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 90.8723H412.641L409.932 86.2281L412.641 81.5064H417.982L420.691 86.2281L417.982 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 96.6776H402.501L399.869 92.0334L402.501 87.3892H407.919L410.628 92.0334L407.919 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.779 102.56H392.438L389.729 97.8387L392.438 93.1945H397.779L400.488 97.8387L397.779 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 108.366H382.299L379.667 103.721L382.299 98.9998H387.717L390.426 103.721L387.717 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 114.171H372.236L369.527 109.527L372.236 104.882H377.577L380.286 109.527L377.577 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 120.054H362.096L359.387 115.332L362.096 110.688H367.514L370.224 115.332L367.514 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.91 125.008H352.498L350.331 121.215L352.498 117.422H356.91L359.077 121.215L356.91 125.008Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.725 145.287H313.873L313.409 144.513L313.873 143.739H314.725L315.189 144.513L314.725 145.287Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.52 154.344H301.876L299.554 150.319L301.876 146.371H306.52L308.765 150.319L306.52 154.344Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 160.846H291.426L288.717 156.201L291.426 151.557H296.767L299.476 156.201L296.767 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 166.651H281.286L278.577 162.007L281.286 157.362H286.704L289.414 162.007L286.704 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 178.339H281.286L278.577 173.695L281.286 169.05H286.704L289.414 173.695L286.704 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 190.027H281.286L278.577 185.383L281.286 180.661H286.704L289.414 185.383L286.704 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 201.715H281.286L278.577 196.993L281.286 192.349H286.704L289.414 196.993L286.704 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 213.325H281.286L278.577 208.681L281.286 204.037H286.704L289.414 208.681L286.704 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.234 222.537H282.757L281.441 220.369L282.757 218.125H285.234L286.55 220.369L285.234 222.537Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.537 232.909H283.454L282.912 231.98L283.454 231.128H284.537L285.079 231.98L284.537 232.909Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.543 328.038H282.447L280.899 325.329L282.447 322.62H285.543L287.091 325.329L285.543 328.038Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.769 349.944H283.221L282.525 348.705L283.221 347.389H284.769L285.466 348.705L284.769 349.944Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 365.037H281.286L278.577 360.316L281.286 355.672H286.704L289.414 360.316L286.704 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 376.648H281.286L278.577 372.004L281.286 367.359H286.704L289.414 372.004L286.704 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 388.336H281.286L278.577 383.692L281.286 378.97H286.704L289.414 383.692L286.704 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 400.024H281.286L278.577 395.302L281.286 390.658H286.704L289.414 395.302L286.704 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 411.635H281.286L278.577 406.99L281.286 402.346H286.704L289.414 406.99L286.704 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 423.323H281.286L278.577 418.678L281.286 413.957H286.704L289.414 418.678L286.704 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 435.011H281.286L278.577 430.289L281.286 425.645H286.704L289.414 430.289L286.704 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 446.621H281.286L278.577 441.977L281.286 437.333H286.704L289.414 441.977L286.704 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 464.192H271.224L268.515 459.47L271.224 454.826H276.565L279.274 459.47L276.565 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 469.997H281.286L278.577 465.353L281.286 460.631H286.704L289.414 465.353L286.704 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 475.803H291.426L288.717 471.158L291.426 466.514H296.767L299.476 471.158L296.767 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 481.685H301.488L298.779 476.964L301.488 472.319H306.907L309.616 476.964L306.907 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 487.491H311.629L308.92 482.846L311.629 478.125H316.97L319.679 482.846L316.97 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 493.296H321.691L318.982 488.652L321.691 484.007H327.109L329.819 488.652L327.109 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 499.179H331.831L329.122 494.457L331.831 489.813H337.172L339.881 494.457L337.172 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 504.984H341.894L339.184 500.34L341.894 495.618H347.312L350.021 500.34L347.312 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 312.48H796.565L793.856 307.836L796.565 303.192H801.906L804.615 307.836L801.906 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 300.869H796.565L793.856 296.148L796.565 291.504H801.906L804.615 296.148L801.906 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 289.181H796.565L793.856 284.537L796.565 279.816H801.906L804.615 284.537L801.906 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 277.493H796.565L793.856 272.849L796.565 268.205H801.906L804.615 272.849L801.906 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 265.805H796.565L793.856 261.161L796.565 256.517H801.906L804.615 261.161L801.906 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 254.195H796.565L793.856 249.551L796.565 244.829H801.906L804.615 249.551L801.906 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 242.507H796.565L793.856 237.863L796.565 233.218H801.906L804.615 237.863L801.906 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 230.819H796.565L793.856 226.175L796.565 221.53H801.906L804.615 226.175L801.906 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 219.208H796.565L793.856 214.487L796.565 209.842H801.906L804.615 214.487L801.906 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 207.52H796.565L793.856 202.876L796.565 198.154H801.906L804.615 202.876L801.906 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 195.832H796.565L793.856 191.188L796.565 186.544H801.906L804.615 191.188L801.906 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 184.222H796.565L793.856 179.5L796.565 174.856H801.906L804.615 179.5L801.906 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 172.534H796.565L793.856 167.889L796.565 163.168H801.906L804.615 167.889L801.906 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 160.846H796.565L793.856 156.201L796.565 151.557H801.906L804.615 156.201L801.906 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 155.04H786.425L783.716 150.319L786.425 145.674H791.843L794.475 150.319L791.843 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 149.158H776.285L773.653 144.513L776.285 139.869H781.703L784.412 144.513L781.703 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 143.352H766.222L763.513 138.708L766.222 133.986H771.641L774.272 138.708L771.641 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 137.547H756.082L753.451 132.825L756.082 128.181H761.501L764.21 132.825L761.501 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 131.664H746.02L743.311 127.02L746.02 122.376H751.438L754.07 127.02L751.438 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 125.859H735.88L733.248 121.215L735.88 116.493H741.298L744.007 121.215L741.298 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 120.054H725.818L723.109 115.332L725.818 110.688H731.236L733.868 115.332L731.236 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 114.171H715.678L713.046 109.527L715.678 104.882H721.096L723.805 109.527L721.096 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 108.366H705.615L702.906 103.721L705.615 98.9998H710.956L713.665 103.721L710.956 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.894 102.56H695.476L692.844 97.8387L695.476 93.1945H700.894L703.603 97.8387L700.894 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 96.6776H685.413L682.704 92.0334L685.413 87.3892H690.754L693.463 92.0334L690.754 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.679 87.4666H677.285L676.589 86.2281L677.285 84.9896H678.679L679.453 86.2281L678.679 87.4666Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.164 84.3704H665.597L663.275 80.3454L665.597 76.3978H670.164L672.486 80.3454L670.164 84.3704Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.631 75.9334H656.928L656.154 74.5401L656.928 73.0694H658.631L659.405 74.5401L658.631 75.9334Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.214 31.7357H574.725L572.48 27.8655L574.725 23.9953H579.214L581.459 27.8655L579.214 31.7357Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.152 26.0077H564.585L562.263 22.0601L564.585 18.1125H569.152L571.396 22.0601L569.152 26.0077Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.297 52.1703H455.136L454.594 51.1641L455.136 50.1578H456.297L456.916 51.1641L456.297 52.1703Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.324 61.6136H442.983L440.274 57.0468L442.983 52.4025H448.324L450.956 57.0468L448.324 61.6136Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.262 67.4963H432.843L430.134 62.8521L432.843 58.2078H438.262L440.893 62.8521L438.262 67.4963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.122 73.379H422.703L420.072 68.7348L422.703 64.0131H428.122L430.831 68.7348L428.122 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 79.1843H412.641L409.932 74.5401L412.641 69.8958H417.982L420.691 74.5401L417.982 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 85.067H402.501L399.869 80.3454L402.501 75.7011H407.919L410.628 80.3454L407.919 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.779 90.8723H392.438L389.729 86.2281L392.438 81.5064H397.779L400.488 86.2281L397.779 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 96.6776H382.299L379.667 92.0334L382.299 87.3892H387.717L390.426 92.0334L387.717 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 102.56H372.236L369.527 97.8387L372.236 93.1945H377.577L380.286 97.8387L377.577 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 108.366H362.096L359.387 103.721L362.096 98.9998H367.514L370.224 103.721L367.514 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 114.171H352.034L349.324 109.527L352.034 104.882H357.375L360.084 109.527L357.375 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.457 148.538H291.736L289.414 144.513L291.736 140.488H296.457L298.779 144.513L296.457 148.538Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 155.04H281.286L278.577 150.319L281.286 145.674H286.704L289.414 150.319L286.704 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 160.846H271.224L268.515 156.201L271.224 151.557H276.565L279.274 156.201L276.565 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 172.534H271.224L268.515 167.889L271.224 163.168H276.565L279.274 167.889L276.565 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 184.222H271.224L268.515 179.5L271.224 174.856H276.565L279.274 179.5L276.565 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 195.832H271.224L268.515 191.188L271.224 186.544H276.565L279.274 191.188L276.565 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 207.52H271.224L268.515 202.876L271.224 198.154H276.565L279.274 202.876L276.565 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 219.208H271.224L268.515 214.487L271.224 209.842H276.565L279.274 214.487L276.565 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 230.819H271.224L268.515 226.175L271.224 221.53H276.565L279.274 226.175L276.565 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.707 309.229H273.081L272.307 307.836L273.081 306.443H274.707L275.481 307.836L274.707 309.229Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.255 323.626H271.533L269.134 319.524L271.533 315.344H276.255L278.654 319.524L276.255 323.626Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 359.155H271.224L268.515 354.51L271.224 349.866H276.565L279.274 354.51L276.565 359.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 370.843H271.224L268.515 366.198L271.224 361.477H276.565L279.274 366.198L276.565 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 382.531H271.224L268.515 377.809L271.224 373.165H276.565L279.274 377.809L276.565 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 394.141H271.224L268.515 389.497L271.224 384.853H276.565L279.274 389.497L276.565 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 405.829H271.224L268.515 401.185L271.224 396.463H276.565L279.274 401.185L276.565 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 417.517H271.224L268.515 412.796L271.224 408.151H276.565L279.274 412.796L276.565 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 429.128H271.224L268.515 424.484L271.224 419.839H276.565L279.274 424.484L276.565 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 440.816H271.224L268.515 436.172L271.224 431.527H276.565L279.274 436.172L276.565 440.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 452.504H271.224L268.515 447.86L271.224 443.138H276.565L279.274 447.86L276.565 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.255 475.183H271.533L269.211 471.158L271.533 467.133H276.255L278.577 471.158L276.255 475.183Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 481.685H281.286L278.577 476.964L281.286 472.319H286.704L289.414 476.964L286.704 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 487.491H291.426L288.717 482.846L291.426 478.125H296.767L299.476 482.846L296.767 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 493.296H301.488L298.779 488.652L301.488 484.007H306.907L309.616 488.652L306.907 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 499.179H311.629L308.92 494.457L311.629 489.813H316.97L319.679 494.457L316.97 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 504.984H321.691L318.982 500.34L321.691 495.618H327.109L329.819 500.34L327.109 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 510.789H331.831L329.122 506.145L331.831 501.501H337.172L339.881 506.145L337.172 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.764 513.963H343.442L342.281 511.95L343.442 509.938H345.764L346.925 511.95L345.764 513.963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.962 316.582H807.634L806.008 313.641L807.634 310.777H810.962L812.665 313.641L810.962 316.582Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 306.675H806.627L803.918 302.03L806.627 297.309H812.046L814.677 302.03L812.046 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 294.987H806.627L803.918 290.342L806.627 285.698H812.046L814.677 290.342L812.046 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 283.376H806.627L803.918 278.654L806.627 274.01H812.046L814.677 278.654L812.046 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 271.688H806.627L803.918 267.044L806.627 262.322H812.046L814.677 267.044L812.046 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 260H806.627L803.918 255.356L806.627 250.712H812.046L814.677 255.356L812.046 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 248.312H806.627L803.918 243.668L806.627 239.024H812.046L814.677 243.668L812.046 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 236.702H806.627L803.918 231.98L806.627 227.336H812.046L814.677 231.98L812.046 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 225.013H806.627L803.918 220.369L806.627 215.648H812.046L814.677 220.369L812.046 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 213.325H806.627L803.918 208.681L806.627 204.037H812.046L814.677 208.681L812.046 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 201.715H806.627L803.918 196.993L806.627 192.349H812.046L814.677 196.993L812.046 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 190.027H806.627L803.918 185.383L806.627 180.661H812.046L814.677 185.383L812.046 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 178.339H806.627L803.918 173.695L806.627 169.05H812.046L814.677 173.695L812.046 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 166.651H806.627L803.918 162.007L806.627 157.362H812.046L814.677 162.007L812.046 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 155.04H806.627L803.918 150.319L806.627 145.674H812.046L814.677 150.319L812.046 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 149.158H796.565L793.856 144.513L796.565 139.869H801.906L804.615 144.513L801.906 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 143.352H786.425L783.716 138.708L786.425 133.986H791.843L794.475 138.708L791.843 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 137.547H776.285L773.653 132.825L776.285 128.181H781.703L784.412 132.825L781.703 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 131.664H766.222L763.513 127.02L766.222 122.376H771.641L774.272 127.02L771.641 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 125.859H756.082L753.451 121.215L756.082 116.493H761.501L764.21 121.215L761.501 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 120.054H746.02L743.311 115.332L746.02 110.688H751.438L754.07 115.332L751.438 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 114.171H735.88L733.248 109.527L735.88 104.882H741.298L744.007 109.527L741.298 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.236 108.366H725.818L723.109 103.721L725.818 98.9998H731.236L733.868 103.721L731.236 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.096 102.56H715.678L713.046 97.8387L715.678 93.1945H721.096L723.805 97.8387L721.096 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.956 96.6776H705.615L702.906 92.0334L705.615 87.3892H710.956L713.665 92.0334L710.956 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.423 88.318H696.946L695.707 86.2281L696.946 84.0608H699.423L700.661 86.2281L699.423 88.318Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.7 71.7535H666.139L664.281 68.7348L666.139 65.6386H669.7L671.48 68.7348L669.7 71.7535Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.791 28.9491H596.553L595.934 27.8655L596.553 26.7818H597.791L598.41 27.8655L597.791 28.9491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.432 26.1626H584.71L582.311 22.0602L584.71 17.8803H589.432L591.831 22.0602L589.432 26.1626Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.589 17.2611H576.351L575.731 16.1775L576.351 15.0938H577.589L578.208 16.1775L577.589 17.2611Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.529 40.9467H454.903L454.129 39.5534L454.903 38.1602H456.529L457.38 39.5534L456.529 40.9467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.324 50.003H442.906L440.274 45.3588L442.906 40.7145H448.324L451.033 45.3588L448.324 50.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.262 55.8857H432.843L430.134 51.1641L432.843 46.5198H438.262L440.893 51.1641L438.262 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.122 61.691H422.703L420.072 57.0468L422.703 52.4025H428.122L430.831 57.0468L428.122 61.691Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 67.4963H412.641L409.932 62.8521L412.641 58.2078H417.982L420.691 62.8521L417.982 67.4963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 73.379H402.501L399.869 68.7348L402.501 64.0131H407.919L410.628 68.7348L407.919 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.779 79.1843H392.438L389.729 74.5401L392.438 69.8958H397.779L400.488 74.5401L397.779 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 85.067H382.299L379.667 80.3454L382.299 75.7011H387.717L390.426 80.3454L387.717 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 90.8723H372.236L369.527 86.2281L372.236 81.5064H377.577L380.286 86.2281L377.577 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 96.6776H362.096L359.387 92.0334L362.096 87.3892H367.514L370.224 92.0334L367.514 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.368 100.78H353.04L351.337 97.8387L353.04 94.9747H356.368L358.071 97.8387L356.368 100.78Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.957 122.298H313.641L313.022 121.215L313.641 120.131H314.957L315.576 121.215L314.957 122.298Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 131.664H301.488L298.779 127.02L301.488 122.376H306.907L309.616 127.02L306.907 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.142 134.606H293.052L292.045 132.825L293.052 131.122H295.142L296.148 132.825L295.142 134.606Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 143.352H281.286L278.577 138.708L281.286 133.986H286.704L289.414 138.708L286.704 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 149.158H271.224L268.515 144.513L271.224 139.869H276.565L279.274 144.513L276.565 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.651 165.258H261.935L260 162.007L261.935 158.756H265.651L267.586 162.007L265.651 165.258Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.347 178.107H261.239L258.684 173.695L261.239 169.283H266.347L268.902 173.695L266.347 178.107Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 190.027H261.084L258.375 185.383L261.084 180.661H266.502L269.211 185.383L266.502 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 201.715H261.084L258.375 196.993L261.084 192.349H266.502L269.211 196.993L266.502 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 213.325H261.084L258.375 208.681L261.084 204.037H266.502L269.211 208.681L266.502 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 225.013H261.084L258.375 220.369L261.084 215.648H266.502L269.211 220.369L266.502 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 236.702H261.084L258.375 231.98L261.084 227.336H266.502L269.211 231.98L266.502 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.425 248.235H261.161L258.529 243.668L261.161 239.178H266.425L268.979 243.668L266.425 248.235Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.257 256.13H263.329L262.864 255.356L263.329 254.582H264.257L264.722 255.356L264.257 256.13Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.799 303.733H262.787L261.78 302.031L262.787 300.25H264.799L265.805 302.031L264.799 303.733Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.489 314.957H263.019L262.322 313.641L263.019 312.403H264.489L265.264 313.641L264.489 314.957Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.264 327.961H262.322L260.774 325.329L262.322 322.775H265.264L266.812 325.329L265.264 327.961Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.347 353.117H261.239L258.684 348.705L261.239 344.216H266.347L268.902 348.705L266.347 353.117Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 365.037H261.084L258.375 360.316L261.084 355.672H266.502L269.211 360.316L266.502 365.037Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 376.648H261.084L258.375 372.004L261.084 367.359H266.502L269.211 372.004L266.502 376.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 388.336H261.084L258.375 383.692L261.084 378.97H266.502L269.211 383.692L266.502 388.336Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 400.024H261.084L258.375 395.302L261.084 390.658H266.502L269.211 395.302L266.502 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 411.635H261.084L258.375 406.99L261.084 402.346H266.502L269.211 406.99L266.502 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 423.323H261.084L258.375 418.678L261.084 413.957H266.502L269.211 418.678L266.502 423.323Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 435.011H261.084L258.375 430.289L261.084 425.645H266.502L269.211 430.289L266.502 435.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 446.621H261.084L258.375 441.977L261.084 437.333H266.502L269.211 441.977L266.502 446.621Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 458.309H261.084L258.375 453.665L261.084 449.021H266.502L269.211 453.665L266.502 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1 486.639H271.688L269.521 482.846L271.688 479.054H276.1L278.267 482.846L276.1 486.639Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 493.296H281.286L278.577 488.652L281.286 484.007H286.704L289.414 488.652L286.704 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 499.179H291.426L288.717 494.457L291.426 489.813H296.767L299.476 494.457L296.767 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 504.984H301.488L298.779 500.34L301.488 495.618H306.907L309.616 500.34L306.907 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 510.789H311.629L308.92 506.145L311.629 501.501H316.97L319.679 506.145L316.97 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 516.672H321.691L318.982 511.95L321.691 507.306H327.109L329.819 511.95L327.109 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 522.4H331.831L329.199 517.833L331.831 513.189H337.172L339.804 517.833L337.172 522.4Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.643 335.082H817.154L814.909 331.134L817.154 327.264H821.643L823.888 331.134L821.643 335.082Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 324.168H816.767L814.058 319.524L816.767 314.802H822.108L824.818 319.524L822.108 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 312.48H816.767L814.058 307.836L816.767 303.192H822.108L824.818 307.836L822.108 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 300.869H816.767L814.058 296.148L816.767 291.504H822.108L824.818 296.148L822.108 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 289.181H816.767L814.058 284.537L816.767 279.816H822.108L824.818 284.537L822.108 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 277.493H816.767L814.058 272.849L816.767 268.205H822.108L824.818 272.849L822.108 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 265.805H816.767L814.058 261.161L816.767 256.517H822.108L824.818 261.161L822.108 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 254.195H816.767L814.058 249.551L816.767 244.829H822.108L824.818 249.551L822.108 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 242.507H816.767L814.058 237.863L816.767 233.218H822.108L824.818 237.863L822.108 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 230.819H816.767L814.058 226.175L816.767 221.53H822.108L824.818 226.175L822.108 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 219.208H816.767L814.058 214.487L816.767 209.842H822.108L824.818 214.487L822.108 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 207.52H816.767L814.058 202.876L816.767 198.154H822.108L824.818 202.876L822.108 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 195.832H816.767L814.058 191.188L816.767 186.544H822.108L824.818 191.188L822.108 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 184.222H816.767L814.058 179.5L816.767 174.856H822.108L824.818 179.5L822.108 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 172.534H816.767L814.058 167.889L816.767 163.168H822.108L824.818 167.889L822.108 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 160.846H816.767L814.058 156.201L816.767 151.557H822.108L824.818 156.201L822.108 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 149.158H816.767L814.058 144.513L816.767 139.869H822.108L824.818 144.513L822.108 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 143.352H806.627L803.918 138.708L806.627 133.986H812.046L814.677 138.708L812.046 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 137.547H796.565L793.856 132.825L796.565 128.181H801.906L804.615 132.825L801.906 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 131.664H786.425L783.716 127.02L786.425 122.376H791.843L794.475 127.02L791.843 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 125.859H776.285L773.653 121.215L776.285 116.493H781.703L784.412 121.215L781.703 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 120.054H766.222L763.513 115.332L766.222 110.688H771.641L774.272 115.332L771.641 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 114.171H756.082L753.451 109.527L756.082 104.882H761.501L764.21 109.527L761.501 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 108.366H746.02L743.311 103.721L746.02 98.9998H751.438L754.07 103.721L751.438 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 102.56H735.88L733.248 97.8387L735.88 93.1945H741.298L744.007 97.8387L741.298 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.081 96.4454H725.972L723.418 92.0334L725.972 87.6214H731.081L733.558 92.0334L731.081 96.4454Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.018 90.7175H715.832L713.201 86.2281L715.832 81.7386H721.018L723.573 86.2281L721.018 90.7175Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.724 84.6026H705.847L703.448 80.3454L705.847 76.1656H710.724L713.201 80.3454L710.724 84.6026Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.304 66.7997H675.737L673.415 62.8521L675.737 58.9045H680.304L682.549 62.8521L680.304 66.7997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.306 57.8208H667.455L666.99 57.0467L667.455 56.2727H668.306L668.771 57.0467L668.306 57.8208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.372 26.4722H463.263L460.709 22.0602L463.263 17.5707H468.372L471.004 22.0602L468.372 26.4722Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.232 32.2775H453.201L450.646 27.8654L453.201 23.4534H458.232L460.786 27.8654L458.232 32.2775Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.324 38.3924H442.906L440.274 33.6707L442.906 29.0265H448.324L451.033 33.6707L448.324 38.3924Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.262 44.1977H432.843L430.134 39.5535L432.843 34.8318H438.262L440.893 39.5535L438.262 44.1977Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.122 50.003H422.703L420.072 45.3588L422.703 40.7145H428.122L430.831 45.3588L428.122 50.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 55.8857H412.641L409.932 51.1641L412.641 46.5198H417.982L420.691 51.1641L417.982 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 61.691H402.501L399.869 57.0468L402.501 52.4025H407.919L410.628 57.0468L407.919 61.691Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.779 67.4963H392.438L389.729 62.8521L392.438 58.2078H397.779L400.488 62.8521L397.779 67.4963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 73.379H382.299L379.667 68.7348L382.299 64.0131H387.717L390.426 68.7348L387.717 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 79.1843H372.236L369.527 74.5401L372.236 69.8958H377.577L380.286 74.5401L377.577 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 85.067H362.096L359.387 80.3454L362.096 75.7011H367.514L370.224 80.3454L367.514 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.142 90.4079H352.266L349.866 86.2281L352.266 81.9709H357.142L359.542 86.2281L357.142 90.4079Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.948 106.276H322.852L321.381 103.721L322.852 101.09H325.948L327.419 103.721L325.948 106.276Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 114.171H311.629L308.92 109.527L311.629 104.882H316.97L319.679 109.527L316.97 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 120.054H301.488L298.779 115.332L301.488 110.688H306.907L309.616 115.332L306.907 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 125.859H291.426L288.717 121.215L291.426 116.57H296.767L299.476 121.215L296.767 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 137.47H271.224L268.592 132.825L271.224 128.258H276.565L279.196 132.825L276.565 137.47Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.433 170.908H251.95L250.17 167.889L251.95 164.793H255.433L257.214 167.889L255.433 170.908Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.285 183.989H251.099L248.544 179.5L251.099 175.088H256.285L258.839 179.5L256.285 183.989Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 195.832H251.021L248.312 191.188L251.021 186.544H256.362L259.071 191.188L256.362 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 207.52H251.021L248.312 202.876L251.021 198.154H256.362L259.071 202.876L256.362 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 219.208H251.021L248.312 214.487L251.021 209.842H256.362L259.071 214.487L256.362 219.208Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 230.819H251.021L248.312 226.175L251.021 221.53H256.362L259.071 226.175L256.362 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 242.507H251.021L248.312 237.863L251.021 233.218H256.362L259.071 237.863L256.362 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 254.195H251.021L248.312 249.551L251.021 244.829H256.362L259.071 249.551L256.362 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.898 264.954H251.486L249.318 261.161L251.486 257.368H255.898L258.065 261.161L255.898 264.954Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.814 309.771H252.569L251.485 307.836L252.569 305.901H254.814L255.897 307.836L254.814 309.771Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.659 321.149H252.724L251.795 319.524L252.724 317.821H254.659L255.588 319.524L254.659 321.149Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82 358.226H251.563L249.396 354.51L251.563 350.795H255.82L257.988 354.51L255.82 358.226Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 370.843H251.021L248.312 366.198L251.021 361.477H256.362L259.071 366.198L256.362 370.843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 382.531H251.021L248.312 377.809L251.021 373.165H256.362L259.071 377.809L256.362 382.531Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 394.141H251.021L248.312 389.497L251.021 384.853H256.362L259.071 389.497L256.362 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 405.829H251.021L248.312 401.185L251.021 396.463H256.362L259.071 401.185L256.362 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 417.517H251.021L248.312 412.796L251.021 408.151H256.362L259.071 412.796L256.362 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 429.128H251.021L248.312 424.484L251.021 419.839H256.362L259.071 424.484L256.362 429.128Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 440.739H251.021L248.389 436.172L251.021 431.527H256.362L258.994 436.172L256.362 440.739Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.279 450.569H252.105L250.479 447.86L252.105 445.073H255.279L256.827 447.86L255.279 450.569Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.868 497.94H271.843L269.908 494.457L271.843 490.974H275.868L277.88 494.457L275.868 497.94Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 504.984H281.286L278.577 500.34L281.286 495.618H286.704L289.414 500.34L286.704 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 510.789H291.426L288.717 506.145L291.426 501.501H296.767L299.476 506.145L296.767 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 516.672H301.488L298.779 511.95L301.488 507.306H306.907L309.616 511.95L306.907 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 522.477H311.629L308.92 517.833L311.629 513.189H316.97L319.679 517.833L316.97 522.477Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.109 528.283H321.691L319.059 523.638L321.691 518.994H327.109L329.741 523.638L327.109 528.283Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.474 387.02H827.604L825.669 383.692L827.604 380.363H831.474L833.409 383.692L831.474 387.02Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.165 374.79H827.914L826.288 372.004L827.914 369.217H831.165L832.713 372.004L831.165 374.79Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.783 340.887H827.294L825.049 337.017L827.294 333.07H831.783L834.028 337.017L831.783 340.887Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 329.973H826.83L824.121 325.329L826.83 320.685H832.248L834.88 325.329L832.248 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 318.363H826.83L824.121 313.641L826.83 308.997H832.248L834.88 313.641L832.248 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 306.675H826.83L824.121 302.03L826.83 297.309H832.248L834.88 302.03L832.248 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 294.987H826.83L824.121 290.342L826.83 285.698H832.248L834.88 290.342L832.248 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 283.376H826.83L824.121 278.654L826.83 274.01H832.248L834.88 278.654L832.248 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 271.688H826.83L824.121 267.044L826.83 262.322H832.248L834.88 267.044L832.248 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 260H826.83L824.121 255.356L826.83 250.712H832.248L834.88 255.356L832.248 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 248.312H826.83L824.121 243.668L826.83 239.024H832.248L834.88 243.668L832.248 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 236.702H826.83L824.121 231.98L826.83 227.336H832.248L834.88 231.98L832.248 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 225.013H826.83L824.121 220.369L826.83 215.648H832.248L834.88 220.369L832.248 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 213.325H826.83L824.121 208.681L826.83 204.037H832.248L834.88 208.681L832.248 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 201.715H826.83L824.121 196.993L826.83 192.349H832.248L834.88 196.993L832.248 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 190.027H826.83L824.121 185.383L826.83 180.661H832.248L834.88 185.383L832.248 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 178.339H826.83L824.121 173.695L826.83 169.05H832.248L834.88 173.695L832.248 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 166.651H826.83L824.121 162.007L826.83 157.362H832.248L834.88 162.007L832.248 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 155.04H826.83L824.121 150.319L826.83 145.674H832.248L834.88 150.319L832.248 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 143.352H826.83L824.121 138.708L826.83 133.986H832.248L834.88 138.708L832.248 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 137.547H816.767L814.058 132.825L816.767 128.181H822.108L824.818 132.825L822.108 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 131.664H806.627L803.918 127.02L806.627 122.376H812.046L814.677 127.02L812.046 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 125.859H796.565L793.856 121.215L796.565 116.493H801.906L804.615 121.215L801.906 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 120.054H786.425L783.716 115.332L786.425 110.688H791.843L794.475 115.332L791.843 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 114.171H776.285L773.653 109.527L776.285 104.882H781.703L784.412 109.527L781.703 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 108.366H766.222L763.513 103.721L766.222 98.9998H771.641L774.272 103.721L771.641 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 102.56H756.082L753.451 97.8387L756.082 93.1945H761.501L764.21 97.8387L761.501 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.438 96.6776H746.02L743.311 92.0334L746.02 87.3892H751.438L754.07 92.0334L751.438 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.298 90.8723H735.88L733.248 86.2281L735.88 81.5064H741.298L744.007 86.2281L741.298 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.997 82.8997H727.056L725.585 80.3454L727.056 77.8684H729.997L731.391 80.3454L729.997 82.8997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.084 75.6237H717.768L717.148 74.5401L717.768 73.379H719.084L719.703 74.5401L719.084 75.6237Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.98 60.2203H686.264L684.406 57.0468L686.264 53.7958H689.98L691.76 57.0468L689.98 60.2203Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.535 19.351H453.975L452.117 16.1774L453.975 13.0813H457.535L459.316 16.1774L457.535 19.351Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.324 26.7044H442.906L440.274 22.0601L442.906 17.3385H448.324L451.033 22.0601L448.324 26.7044Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.262 32.5097H432.843L430.134 27.8654L432.843 23.2212H438.262L440.893 27.8654L438.262 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.122 38.3924H422.703L420.072 33.6707L422.703 29.0265H428.122L430.831 33.6707L428.122 38.3924Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 44.1977H412.641L409.932 39.5535L412.641 34.8318H417.982L420.691 39.5535L417.982 44.1977Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 50.003H402.501L399.869 45.3588L402.501 40.7145H407.919L410.628 45.3588L407.919 50.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.779 55.8857H392.438L389.729 51.1641L392.438 46.5198H397.779L400.488 51.1641L397.779 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 61.691H382.299L379.667 57.0468L382.299 52.4025H387.717L390.426 57.0468L387.717 61.691Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 67.4963H372.236L369.527 62.8521L372.236 58.2078H377.577L380.286 62.8521L377.577 67.4963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 73.379H362.096L359.387 68.7348L362.096 64.0131H367.514L370.224 68.7348L367.514 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.374 79.1069H352.033L349.402 74.5401L352.033 69.8958H357.374L360.006 74.5401L357.374 79.1069Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.222 81.3516H343.983L343.442 80.3454L343.983 79.3391H345.222L345.764 80.3454L345.222 81.3516Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.963 100.703H312.635L311.009 97.8387L312.635 94.9747H315.963L317.589 97.8387L315.963 100.703Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 108.366H301.488L298.779 103.721L301.488 98.9998H306.907L309.616 103.721L306.907 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 114.171H291.426L288.717 109.527L291.426 104.882H296.767L299.476 109.527L296.767 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.627 119.976H281.286L278.655 115.332L281.286 110.765H286.627L289.336 115.332L286.627 119.976Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.475 122.221H273.314L272.694 121.215L273.314 120.131H274.475L275.094 121.215L274.475 122.221Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.031 129.187H262.555L261.316 127.02L262.555 124.853H265.031L266.27 127.02L265.031 129.187Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.365 163.4H242.739L241.965 162.007L242.739 160.613H244.365L245.216 162.007L244.365 163.4Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 178.339H240.881L238.172 173.695L240.881 169.05H246.3L248.931 173.695L246.3 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 190.027H240.881L238.172 185.383L240.881 180.661H246.3L248.931 185.383L246.3 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 201.715H240.881L238.172 196.993L240.881 192.349H246.3L248.931 196.993L246.3 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 213.325H240.881L238.172 208.681L240.881 204.037H246.3L248.931 208.681L246.3 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 225.013H240.881L238.172 220.369L240.881 215.648H246.3L248.931 220.369L246.3 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 236.702H240.881L238.172 231.98L240.881 227.336H246.3L248.931 231.98L246.3 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 248.312H240.881L238.172 243.668L240.881 239.024H246.3L248.931 243.668L246.3 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 260H240.881L238.172 255.356L240.881 250.712H246.3L248.931 255.356L246.3 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.222 271.533H240.959L238.327 267.044L240.959 262.477H246.222L248.854 267.044L246.222 271.533Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.442 280.203H242.739L241.81 278.654L242.739 277.184H244.442L245.293 278.654L244.442 280.203Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.835 294.29H241.346L239.024 290.343L241.346 286.395H245.835L248.08 290.343L245.835 294.29Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.287 314.88H242.894L242.12 313.641L242.894 312.403H244.287L244.984 313.641L244.287 314.88Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.145 364.805H241.036L238.482 360.316L241.036 355.904H246.145L248.699 360.316L246.145 364.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.364 373.32H242.816L242.042 372.004L242.816 370.688H244.364L245.139 372.004L244.364 373.32Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.216 386.478H241.965L240.339 383.692L241.965 380.828H245.216L246.841 383.692L245.216 386.478Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 400.024H240.881L238.172 395.302L240.881 390.658H246.3L248.931 395.302L246.3 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.222 411.635H240.881L238.25 406.99L240.881 402.346H246.222L248.931 406.99L246.222 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.674 420.459H242.507L241.5 418.678L242.507 416.821H244.674L245.68 418.678L244.674 420.459Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.913 434.391H241.191L238.869 430.289L241.191 426.264H245.913L248.312 430.289L245.913 434.391Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.404 508.777H272.385L270.837 506.145L272.385 503.513H275.404L276.952 506.145L275.404 508.777Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 516.672H281.286L278.577 511.95L281.286 507.306H286.704L289.414 511.95L286.704 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 522.477H291.426L288.717 517.833L291.426 513.189H296.767L299.476 517.833L296.767 522.477Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 528.283H301.488L298.779 523.638L301.488 518.994H306.907L309.616 523.638L306.907 528.283Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 534.165H311.629L308.92 529.444L311.629 524.799H316.97L319.679 529.444L316.97 534.165Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.794 537.726H323.007L321.614 535.326L323.007 532.927H325.794L327.187 535.326L325.794 537.726Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.382 404.204H837.899L836.118 401.185L837.899 398.089H841.382L843.162 401.185L841.382 404.204Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.156 393.909H837.125L834.57 389.497L837.125 385.085H842.156L844.71 389.497L842.156 393.909Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.453 379.28H838.827L837.976 377.809L838.827 376.416H840.453L841.304 377.809L840.453 379.28Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.233 370.61H837.047L834.493 366.198L837.047 361.709H842.233L844.788 366.198L842.233 370.61Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.453 355.904H838.827L837.976 354.51L838.827 353.117H840.453L841.227 354.51L840.453 355.904Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.156 347.234H837.047L834.57 342.822L837.047 338.41H842.156L844.71 342.822L842.156 347.234Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 335.856H836.97L834.26 331.134L836.97 326.49H842.31L845.02 331.134L842.31 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 324.168H836.97L834.26 319.524L836.97 314.802H842.31L845.02 319.524L842.31 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 312.48H836.97L834.26 307.836L836.97 303.192H842.31L845.02 307.836L842.31 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 300.869H836.97L834.26 296.148L836.97 291.504H842.31L845.02 296.148L842.31 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 289.181H836.97L834.26 284.537L836.97 279.816H842.31L845.02 284.537L842.31 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 277.493H836.97L834.26 272.849L836.97 268.205H842.31L845.02 272.849L842.31 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 265.805H836.97L834.26 261.161L836.97 256.517H842.31L845.02 261.161L842.31 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 254.195H836.97L834.26 249.551L836.97 244.829H842.31L845.02 249.551L842.31 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 242.507H836.97L834.26 237.863L836.97 233.218H842.31L845.02 237.863L842.31 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 230.819H836.97L834.26 226.175L836.97 221.53H842.31L845.02 226.175L842.31 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 219.208H836.97L834.26 214.487L836.97 209.842H842.31L845.02 214.487L842.31 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 207.52H836.97L834.26 202.876L836.97 198.154H842.31L845.02 202.876L842.31 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 195.832H836.97L834.26 191.188L836.97 186.544H842.31L845.02 191.188L842.31 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 184.222H836.97L834.26 179.5L836.97 174.856H842.31L845.02 179.5L842.31 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 172.534H836.97L834.26 167.889L836.97 163.168H842.31L845.02 167.889L842.31 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 160.846H836.97L834.26 156.201L836.97 151.557H842.31L845.02 156.201L842.31 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 149.158H836.97L834.26 144.513L836.97 139.869H842.31L845.02 144.513L842.31 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 137.547H836.97L834.26 132.825L836.97 128.181H842.31L845.02 132.825L842.31 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 131.664H826.83L824.121 127.02L826.83 122.376H832.248L834.88 127.02L832.248 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 125.859H816.767L814.058 121.215L816.767 116.493H822.108L824.818 121.215L822.108 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 120.054H806.627L803.918 115.332L806.627 110.688H812.046L814.677 115.332L812.046 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 114.171H796.565L793.856 109.527L796.565 104.882H801.906L804.615 109.527L801.906 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 108.366H786.425L783.716 103.721L786.425 98.9998H791.843L794.475 103.721L791.843 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 102.56H776.285L773.653 97.8387L776.285 93.1945H781.703L784.412 97.8387L781.703 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 96.6776H766.222L763.513 92.0334L766.222 87.3892H771.641L774.272 92.0334L771.641 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 90.8723H756.082L753.451 86.2281L756.082 81.5064H761.501L764.21 86.2281L761.501 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.284 84.9122H746.098L743.466 80.3454L746.098 75.856H751.284L753.915 80.3454L751.284 84.9122Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.905 76.7074H737.35L736.035 74.5401L737.35 72.3728H739.905L741.143 74.5401L739.905 76.7074Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.584 55.2665H695.862L693.463 51.164L695.862 47.139H700.584L702.906 51.164L700.584 55.2665Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.535 7.74041H453.897L452.04 4.56684L453.897 1.31587H457.535L459.393 4.56684L457.535 7.74041Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.092 14.6294H443.215L440.739 10.3721L443.215 6.11491H448.092L450.491 10.3721L448.092 14.6294Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.714 18.2674H434.314L433.153 16.1774L434.314 14.0875H436.714L437.952 16.1774L436.714 18.2674Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.122 26.7044H422.703L420.072 22.0601L422.703 17.3385H428.122L430.831 22.0601L428.122 26.7044Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 32.5097H412.641L409.932 27.8654L412.641 23.2212H417.982L420.691 27.8654L417.982 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 38.3924H402.501L399.869 33.6707L402.501 29.0265H407.919L410.628 33.6707L407.919 38.3924Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.779 44.1977H392.438L389.729 39.5535L392.438 34.8318H397.779L400.488 39.5535L397.779 44.1977Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 50.003H382.299L379.667 45.3588L382.299 40.7145H387.717L390.426 45.3588L387.717 50.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 55.8857H372.236L369.527 51.1641L372.236 46.5198H377.577L380.286 51.1641L377.577 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 61.691H362.096L359.387 57.0468L362.096 52.4025H367.514L370.224 57.0468L367.514 61.691Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 67.4963H352.034L349.324 62.8521L352.034 58.2078H357.375L360.084 62.8521L357.375 67.4963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.609 70.4376H343.597L342.59 68.7348L343.597 66.9545H345.609L346.615 68.7348L345.609 70.4376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 96.6776H301.488L298.779 92.0334L301.488 87.3892H306.907L309.616 92.0334L306.907 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.612 102.251H291.581L289.027 97.8387L291.581 93.4267H296.612L299.167 97.8387L296.612 102.251Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.743 124.775H251.64L249.551 121.215L251.64 117.654H255.743L257.833 121.215L255.743 124.775Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.612 134.838H232.367L231.206 132.825L232.367 130.89H234.612L235.773 132.825L234.612 134.838Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.302 157.595H232.677L231.825 156.201L232.677 154.731H234.302L235.153 156.201L234.302 157.595Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 172.534H230.819L228.109 167.889L230.819 163.168H236.159L238.869 167.889L236.159 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 184.222H230.819L228.109 179.5L230.819 174.856H236.159L238.869 179.5L236.159 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 195.832H230.819L228.109 191.188L230.819 186.544H236.159L238.869 191.188L236.159 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 207.52H230.819L228.109 202.876L230.819 198.154H236.159L238.869 202.876L236.159 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 219.208H230.819L228.109 214.487L230.819 209.842H236.159L238.869 214.487L236.159 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 230.819H230.819L228.109 226.175L230.819 221.53H236.159L238.869 226.175L236.159 230.819Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 242.507H230.819L228.109 237.863L230.819 233.218H236.159L238.869 237.863L236.159 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 254.195H230.819L228.109 249.551L230.819 244.829H236.159L238.869 249.551L236.159 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 265.805H230.819L228.109 261.161L230.819 256.517H236.159L238.869 261.161L236.159 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 277.493H230.819L228.109 272.849L230.819 268.205H236.159L238.869 272.849L236.159 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.457 286.24H232.444L231.438 284.537L232.444 282.757H234.457L235.54 284.537L234.457 286.24Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.85 311.938H231.129L228.806 307.836L231.129 303.811H235.85L238.172 307.836L235.85 311.938Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.07 343.906H232.831L232.212 342.822L232.831 341.739H234.07L234.689 342.822L234.07 343.906Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.302 355.904H232.677L231.825 354.51L232.677 353.04H234.302L235.153 354.51L234.302 355.904Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.612 368.056H232.367L231.283 366.198L232.367 364.263H234.612L235.695 366.198L234.612 368.056Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.255 521.935H271.456L269.057 517.833L271.456 513.653H276.255L278.655 517.833L276.255 521.935Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 528.283H281.286L278.577 523.638L281.286 518.994H286.704L289.414 523.638L286.704 528.283Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 534.165H291.426L288.717 529.444L291.426 524.799H296.767L299.476 529.444L296.767 534.165Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 539.97H301.488L298.779 535.326L301.488 530.682H306.907L309.616 535.326L306.907 539.97Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 545.776H311.629L308.92 541.132L311.629 536.487H316.97L319.679 541.132L316.97 545.776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.296 411.402H847.187L844.633 406.99L847.187 402.578H852.296L854.773 406.99L852.296 411.402Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.218 399.637H847.264L844.788 395.302L847.264 391.045H852.218L854.695 395.302L852.218 399.637Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.902 385.627H848.58L847.419 383.692L848.58 381.679H850.902L852.063 383.692L850.902 385.627Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.057 374.326H848.425L847.11 372.004L848.425 369.682H851.057L852.373 372.004L851.057 374.326Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 353.349H847.032L844.323 348.705L847.032 343.984H852.45L855.16 348.705L852.45 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 341.661H847.032L844.323 337.017L847.032 332.373H852.45L855.16 337.017L852.45 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 329.973H847.032L844.323 325.329L847.032 320.685H852.45L855.16 325.329L852.45 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 318.363H847.032L844.323 313.641L847.032 308.997H852.45L855.16 313.641L852.45 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 306.675H847.032L844.323 302.03L847.032 297.309H852.45L855.16 302.03L852.45 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 294.987H847.032L844.323 290.342L847.032 285.698H852.45L855.16 290.342L852.45 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 283.376H847.032L844.323 278.654L847.032 274.01H852.45L855.16 278.654L852.45 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 271.688H847.032L844.323 267.044L847.032 262.322H852.45L855.16 267.044L852.45 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 260H847.032L844.323 255.356L847.032 250.712H852.45L855.16 255.356L852.45 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 248.312H847.032L844.323 243.668L847.032 239.024H852.45L855.16 243.668L852.45 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 236.702H847.032L844.323 231.98L847.032 227.336H852.45L855.16 231.98L852.45 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 225.013H847.032L844.323 220.369L847.032 215.648H852.45L855.16 220.369L852.45 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 213.325H847.032L844.323 208.681L847.032 204.037H852.45L855.16 208.681L852.45 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 201.715H847.032L844.323 196.993L847.032 192.349H852.45L855.16 196.993L852.45 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 190.027H847.032L844.323 185.383L847.032 180.661H852.45L855.16 185.383L852.45 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 178.339H847.032L844.323 173.695L847.032 169.05H852.45L855.16 173.695L852.45 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 166.651H847.032L844.323 162.007L847.032 157.362H852.45L855.16 162.007L852.45 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 155.04H847.032L844.323 150.319L847.032 145.674H852.45L855.16 150.319L852.45 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 143.352H847.032L844.323 138.708L847.032 133.986H852.45L855.16 138.708L852.45 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 131.664H847.032L844.323 127.02L847.032 122.376H852.45L855.16 127.02L852.45 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 125.859H836.97L834.26 121.215L836.97 116.493H842.31L845.02 121.215L842.31 125.859Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 120.054H826.83L824.121 115.332L826.83 110.688H832.248L834.88 115.332L832.248 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 114.171H816.767L814.058 109.527L816.767 104.882H822.108L824.818 109.527L822.108 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 108.366H806.627L803.918 103.721L806.627 98.9998H812.046L814.677 103.721L812.046 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 102.56H796.565L793.856 97.8387L796.565 93.1945H801.906L804.615 97.8387L801.906 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 96.6776H786.425L783.716 92.0334L786.425 87.3892H791.843L794.475 92.0334L791.843 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 90.8723H776.285L773.653 86.2281L776.285 81.5064H781.703L784.412 86.2281L781.703 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 85.067H766.222L763.513 80.3454L766.222 75.7011H771.641L774.272 80.3454L771.641 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.501 79.1843H756.082L753.451 74.5401L756.082 69.8958H761.501L764.21 74.5401L761.501 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.664 72.0631H746.794L744.859 68.7348L746.794 65.329H750.664L752.599 68.7348L750.664 72.0631Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.988 29.5683H676.975L676.047 27.8654L676.975 26.1626H678.988L679.994 27.8654L678.988 29.5683Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.107 9.05627H432.921L430.289 4.56684L432.921 0H438.107L440.738 4.56684L438.107 9.05627Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.967 14.7842H422.858L420.304 10.3721L422.858 5.96011H427.967L430.521 10.3721L427.967 14.7842Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 20.8991H412.641L409.932 16.1774L412.641 11.5332H417.982L420.691 16.1774L417.982 20.8991Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 26.7044H402.501L399.869 22.0601L402.501 17.3385H407.919L410.628 22.0601L407.919 26.7044Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.779 32.5097H392.438L389.729 27.8654L392.438 23.2212H397.779L400.488 27.8654L397.779 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 38.3924H382.299L379.667 33.6707L382.299 29.0265H387.717L390.426 33.6707L387.717 38.3924Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 44.1977H372.236L369.527 39.5535L372.236 34.8318H377.577L380.286 39.5535L377.577 44.1977Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 50.003H362.096L359.387 45.3588L362.096 40.7145H367.514L370.224 45.3588L367.514 50.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 55.8857H352.034L349.324 51.1641L352.034 46.5198H357.375L360.084 51.1641L357.375 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.234 61.5362H341.971L339.417 57.0468L341.971 52.4799H347.234L349.789 57.0468L347.234 61.5362Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.746 83.0545H302.65L301.024 80.3454L302.65 77.6362H305.746L307.371 80.3454L305.746 83.0545Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 90.8723H291.426L288.717 86.2281L291.426 81.5064H296.767L299.476 86.2281L296.767 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.008 95.5166H281.983L279.97 92.0334L281.983 88.5502H286.008L288.02 92.0334L286.008 95.5166Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 108.366H261.084L258.375 103.721L261.084 98.9998H266.502L269.211 103.721L266.502 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.285 113.939H251.099L248.544 109.527L251.099 105.115H256.285L258.839 109.527L256.285 113.939Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 120.054H240.881L238.172 115.332L240.881 110.688H246.3L248.931 115.332L246.3 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 125.859H230.819L228.109 121.215L230.819 116.493H236.159L238.869 121.215L236.159 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 131.664H220.679L217.97 127.02L220.679 122.376H226.097L228.729 127.02L226.097 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.942 143.197H220.756L218.202 138.708L220.756 134.219H225.942L228.574 138.708L225.942 143.197Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.787 154.498H220.988L218.589 150.319L220.988 146.216H225.787L228.11 150.319L225.787 154.498Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 166.651H220.679L217.97 162.007L220.679 157.362H226.097L228.729 162.007L226.097 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 178.339H220.679L217.97 173.695L220.679 169.05H226.097L228.729 173.695L226.097 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 190.027H220.679L217.97 185.383L220.679 180.661H226.097L228.729 185.383L226.097 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 201.715H220.679L217.97 196.993L220.679 192.349H226.097L228.729 196.993L226.097 201.715Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 213.325H220.679L217.97 208.681L220.679 204.037H226.097L228.729 208.681L226.097 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 225.013H220.679L217.97 220.369L220.679 215.648H226.097L228.729 220.369L226.097 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 236.702H220.679L217.97 231.98L220.679 227.336H226.097L228.729 231.98L226.097 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 248.312H220.679L217.97 243.668L220.679 239.024H226.097L228.729 243.668L226.097 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 260H220.679L217.97 255.356L220.679 250.712H226.097L228.729 255.356L226.097 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 271.688H220.679L217.97 267.044L220.679 262.322H226.097L228.729 267.044L226.097 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.942 283.144H220.756L218.202 278.654L220.756 274.165H225.942L228.574 278.654L225.942 283.144Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 341.661H220.679L217.97 337.017L220.679 332.373H226.097L228.729 337.017L226.097 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 353.349H220.679L217.97 348.705L220.679 343.984H226.097L228.729 348.705L226.097 353.349Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.775 361.09H222.924L222.537 360.316L222.924 359.619H223.775L224.24 360.316L223.775 361.09Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 534.165H271.224L268.515 529.444L271.224 524.799H276.565L279.274 529.444L276.565 534.165Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 539.97H281.286L278.577 535.326L281.286 530.682H286.704L289.414 535.326L286.704 539.97Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 545.776H291.426L288.717 541.132L291.426 536.487H296.767L299.476 541.132L296.767 545.776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 551.581H301.489L298.857 547.014L301.489 542.37H306.907L309.539 547.014L306.907 551.581Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.197 415.118H858.488L857.172 412.796L858.488 410.551H861.197L862.513 412.796L861.197 415.118Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.358 358.768H857.327L854.85 354.51L857.327 350.176H862.358L864.835 354.51L862.358 358.768Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 347.467H857.172L854.463 342.822L857.172 338.178H862.513L865.222 342.822L862.513 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 335.856H857.172L854.463 331.134L857.172 326.49H862.513L865.222 331.134L862.513 335.856Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.888 321.304H858.798L857.792 319.524L858.798 317.744H860.888L861.894 319.524L860.888 321.304Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 312.48H857.172L854.463 307.836L857.172 303.192H862.513L865.222 307.836L862.513 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 300.869H857.172L854.463 296.148L857.172 291.504H862.513L865.222 296.148L862.513 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 289.181H857.172L854.463 284.537L857.172 279.816H862.513L865.222 284.537L862.513 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 277.493H857.172L854.463 272.849L857.172 268.205H862.513L865.222 272.849L862.513 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 265.805H857.172L854.463 261.161L857.172 256.517H862.513L865.222 261.161L862.513 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 254.195H857.172L854.463 249.551L857.172 244.829H862.513L865.222 249.551L862.513 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 242.507H857.172L854.463 237.863L857.172 233.218H862.513L865.222 237.863L862.513 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 230.819H857.172L854.463 226.175L857.172 221.53H862.513L865.222 226.175L862.513 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 219.208H857.172L854.463 214.487L857.172 209.842H862.513L865.222 214.487L862.513 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 207.52H857.172L854.463 202.876L857.172 198.154H862.513L865.222 202.876L862.513 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 195.832H857.172L854.463 191.188L857.172 186.544H862.513L865.222 191.188L862.513 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 184.222H857.172L854.463 179.5L857.172 174.856H862.513L865.222 179.5L862.513 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 172.534H857.172L854.463 167.889L857.172 163.168H862.513L865.222 167.889L862.513 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 160.846H857.172L854.463 156.201L857.172 151.557H862.513L865.222 156.201L862.513 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 149.158H857.172L854.463 144.513L857.172 139.869H862.513L865.222 144.513L862.513 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 137.547H857.172L854.463 132.825L857.172 128.181H862.513L865.222 132.825L862.513 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 125.859H857.172L854.463 121.215L857.172 116.493H862.513L865.222 121.215L862.513 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 120.054H847.032L844.323 115.332L847.032 110.688H852.45L855.16 115.332L852.45 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 114.171H836.97L834.26 109.527L836.97 104.882H842.31L845.02 109.527L842.31 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 108.366H826.83L824.121 103.721L826.83 98.9998H832.248L834.88 103.721L832.248 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 102.56H816.767L814.058 97.8387L816.767 93.1945H822.108L824.818 97.8387L822.108 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 96.6776H806.627L803.918 92.0334L806.627 87.3892H812.046L814.677 92.0334L812.046 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 90.8723H796.565L793.856 86.2281L796.565 81.5064H801.906L804.615 86.2281L801.906 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 85.067H786.425L783.716 80.3454L786.425 75.7011H791.843L794.475 80.3454L791.843 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 79.1843H776.285L773.653 74.5401L776.285 69.8958H781.703L784.412 74.5401L781.703 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.641 73.379H766.222L763.513 68.7348L766.222 64.0131H771.641L774.272 68.7348L771.641 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.424 67.4189H756.16L753.606 62.8521L756.16 58.3626H761.424L764.055 62.8521L761.424 67.4189Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.982 9.05627H412.718L410.087 4.56684L412.718 0H417.982L420.536 4.56684L417.982 9.05627Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.919 15.0164H402.501L399.869 10.3721L402.501 5.72789H407.919L410.628 10.3721L407.919 15.0164Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.779 20.8991H392.438L389.729 16.1774L392.438 11.5332H397.779L400.488 16.1774L397.779 20.8991Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.717 26.7044H382.299L379.667 22.0601L382.299 17.3385H387.717L390.426 22.0601L387.717 26.7044Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 32.5097H372.236L369.527 27.8654L372.236 23.2212H377.577L380.286 27.8654L377.577 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 38.3924H362.096L359.387 33.6707L362.096 29.0265H367.514L370.224 33.6707L367.514 38.3924Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 44.1977H352.034L349.324 39.5535L352.034 34.8318H357.375L360.084 39.5535L357.375 44.1977Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 50.003H341.894L339.184 45.3588L341.894 40.7145H347.312L350.021 45.3588L347.312 50.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 55.8857H331.831L329.122 51.1641L331.831 46.5198H337.172L339.881 51.1641L337.172 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.407 58.827H323.394L322.388 57.0468L323.394 55.2665H325.407L326.413 57.0468L325.407 58.827Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.6 75.3915H293.594L293.052 74.5401L293.594 73.6112H294.6L295.142 74.5401L294.6 75.3915Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 85.067H281.286L278.577 80.3454L281.286 75.7011H286.704L289.414 80.3454L286.704 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 90.8723H271.224L268.515 86.2281L271.224 81.5064H276.565L279.274 86.2281L276.565 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.883 95.6714H261.703L259.536 92.0334L261.703 88.3954H265.883L268.05 92.0334L265.883 95.6714Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.201 100.548H252.105L250.557 97.8387L252.105 95.207H255.201L256.826 97.8387L255.201 100.548Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 108.366H240.881L238.172 103.721L240.881 98.9998H246.3L248.931 103.721L246.3 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.159 114.171H230.819L228.109 109.527L230.819 104.882H236.159L238.869 109.527L236.159 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 120.054H220.679L217.97 115.332L220.679 110.688H226.097L228.729 115.332L226.097 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 125.859H210.616L207.907 121.215L210.616 116.493H215.957L218.666 121.215L215.957 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 137.547H210.616L207.907 132.825L210.616 128.181H215.957L218.666 132.825L215.957 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 149.158H210.616L207.907 144.513L210.616 139.869H215.957L218.666 144.513L215.957 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 160.846H210.616L207.907 156.201L210.616 151.557H215.957L218.666 156.201L215.957 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 172.534H210.616L207.907 167.889L210.616 163.168H215.957L218.666 167.889L215.957 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 184.222H210.616L207.907 179.5L210.616 174.856H215.957L218.666 179.5L215.957 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 195.832H210.616L207.907 191.188L210.616 186.544H215.957L218.666 191.188L215.957 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 207.52H210.616L207.907 202.876L210.616 198.154H215.957L218.666 202.876L215.957 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 219.208H210.616L207.907 214.487L210.616 209.842H215.957L218.666 214.487L215.957 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 230.819H210.616L207.907 226.175L210.616 221.53H215.957L218.666 226.175L215.957 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 242.507H210.616L207.907 237.863L210.616 233.218H215.957L218.666 237.863L215.957 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 254.195H210.616L207.907 249.551L210.616 244.829H215.957L218.666 249.551L215.957 254.195Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 265.805H210.616L207.907 261.161L210.616 256.517H215.957L218.666 261.161L215.957 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 277.493H210.616L207.907 272.849L210.616 268.205H215.957L218.666 272.849L215.957 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.106 287.633H211.468L209.61 284.537L211.468 281.364H215.106L216.886 284.537L215.106 287.633Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 324.168H210.616L207.907 319.524L210.616 314.802H215.957L218.666 319.524L215.957 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.725 335.392H210.848L208.372 331.134L210.848 326.955H215.725L218.124 331.134L215.725 335.392Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 347.467H210.616L207.907 342.822L210.616 338.178H215.957L218.666 342.822L215.957 347.467Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.487 545.621H271.301L268.747 541.132L271.301 536.642H276.487L279.041 541.132L276.487 545.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 551.659H281.286L278.577 547.014L281.286 542.293H286.704L289.414 547.014L286.704 551.659Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 557.464H291.426L288.717 552.82L291.426 548.175H296.767L299.476 552.82L296.767 557.464Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.972 559.941H303.424L302.65 558.625L303.424 557.309H304.972L305.746 558.625L304.972 559.941Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.498 423.168H867.39L864.758 418.678L867.39 414.189H872.498L875.13 418.678L872.498 423.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.802 398.553H868.086L866.229 395.302L868.086 392.129H871.802L873.659 395.302L871.802 398.553Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.486 349.711H869.325L868.783 348.705L869.325 347.699H870.486L871.105 348.705L870.486 349.711Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.873 338.643H869.015L868.009 337.017L869.015 335.314H870.873L871.879 337.017L870.873 338.643Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.956 328.812H867.932L865.919 325.329L867.932 321.846H871.956L873.969 325.329L871.956 328.812Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.498 318.131H867.389L864.835 313.641L867.389 309.229H872.498L875.052 313.641L872.498 318.131Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 306.675H867.235L864.525 302.03L867.235 297.309H872.653L875.362 302.03L872.653 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 294.987H867.235L864.525 290.342L867.235 285.698H872.653L875.362 290.342L872.653 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 283.376H867.235L864.525 278.654L867.235 274.01H872.653L875.362 278.654L872.653 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 271.688H867.235L864.525 267.044L867.235 262.322H872.653L875.362 267.044L872.653 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 260H867.235L864.525 255.356L867.235 250.712H872.653L875.362 255.356L872.653 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 248.312H867.235L864.525 243.668L867.235 239.024H872.653L875.362 243.668L872.653 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 236.702H867.235L864.525 231.98L867.235 227.336H872.653L875.362 231.98L872.653 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 225.013H867.235L864.525 220.369L867.235 215.648H872.653L875.362 220.369L872.653 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 213.325H867.235L864.525 208.681L867.235 204.037H872.653L875.362 208.681L872.653 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 201.715H867.235L864.525 196.993L867.235 192.349H872.653L875.362 196.993L872.653 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 190.027H867.235L864.525 185.383L867.235 180.661H872.653L875.362 185.383L872.653 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 178.339H867.235L864.525 173.695L867.235 169.05H872.653L875.362 173.695L872.653 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 166.651H867.235L864.525 162.007L867.235 157.362H872.653L875.362 162.007L872.653 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 155.04H867.235L864.525 150.319L867.235 145.674H872.653L875.362 150.319L872.653 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 143.352H867.235L864.525 138.708L867.235 133.986H872.653L875.362 138.708L872.653 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 131.664H867.235L864.525 127.02L867.235 122.376H872.653L875.362 127.02L872.653 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 120.054H867.235L864.525 115.332L867.235 110.688H872.653L875.362 115.332L872.653 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 114.171H857.172L854.463 109.527L857.172 104.882H862.513L865.222 109.527L862.513 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 108.366H847.032L844.323 103.721L847.032 98.9998H852.45L855.16 103.721L852.45 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 102.56H836.97L834.26 97.8387L836.97 93.1945H842.31L845.02 97.8387L842.31 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 96.6776H826.83L824.121 92.0334L826.83 87.3892H832.248L834.88 92.0334L832.248 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 90.8723H816.767L814.058 86.2281L816.767 81.5064H822.108L824.818 86.2281L822.108 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 85.067H806.627L803.918 80.3454L806.627 75.7011H812.046L814.677 80.3454L812.046 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 79.1843H796.565L793.856 74.5401L796.565 69.8958H801.906L804.615 74.5401L801.906 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 73.379H786.425L783.716 68.7348L786.425 64.0131H791.843L794.475 68.7348L791.843 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.703 67.4963H776.285L773.653 62.8521L776.285 58.2078H781.703L784.412 62.8521L781.703 67.4963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.325 59.4463H767.461L766.068 57.0468L767.461 54.5698H770.325L771.718 57.0468L770.325 59.4463Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.315 8.28224H392.98L390.813 4.56684L392.98 0.774048H397.315L399.482 4.56684L397.315 8.28224Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.175 14.0875H382.918L380.75 10.3721L382.918 6.65675H387.175L389.265 10.3721L387.175 14.0875Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.958 19.8154H372.855L370.765 16.1774L372.855 12.6169H376.958L379.047 16.1774L376.958 19.8154Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.514 26.7044H362.096L359.387 22.0601L362.096 17.3385H367.514L370.224 22.0601L367.514 26.7044Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 32.5097H352.034L349.324 27.8654L352.034 23.2212H357.375L360.084 27.8654L357.375 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 38.3924H341.894L339.184 33.6707L341.894 29.0265H347.312L350.021 33.6707L347.312 38.3924Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 44.1977H331.831L329.122 39.5535L331.831 34.8318H337.172L339.881 39.5535L337.172 44.1977Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.639 47.5261H323.162L321.923 45.3588L323.162 43.2688H325.639L326.877 45.3588L325.639 47.5261Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.815 55.5761H311.783L309.229 51.1641L311.783 46.8294H316.815L319.369 51.1641L316.815 55.5761Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.487 79.0295H271.301L268.747 74.5401L271.301 70.0507H276.487L279.041 74.5401L276.487 79.0295Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 85.067H261.084L258.375 80.3454L261.084 75.7011H266.502L269.211 80.3454L266.502 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 90.8723H251.021L248.312 86.2281L251.021 81.5064H256.362L259.071 86.2281L256.362 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3 96.6776H240.881L238.25 92.0334L240.881 87.3892H246.3L248.931 92.0334L246.3 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.927 102.019H231.051L228.651 97.8387L231.051 93.6589H235.927L238.327 97.8387L235.927 102.019Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 108.366H220.679L217.97 103.721L220.679 98.9998H226.097L228.729 103.721L226.097 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.957 114.171H210.616L207.907 109.527L210.616 104.882H215.957L218.666 109.527L215.957 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 120.054H200.476L197.767 115.332L200.476 110.688H205.895L208.526 115.332L205.895 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 131.664H200.476L197.767 127.02L200.476 122.376H205.895L208.526 127.02L205.895 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 143.352H200.476L197.767 138.708L200.476 133.986H205.895L208.526 138.708L205.895 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 155.04H200.476L197.767 150.319L200.476 145.674H205.895L208.526 150.319L205.895 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 166.651H200.476L197.767 162.007L200.476 157.362H205.895L208.526 162.007L205.895 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 178.339H200.476L197.767 173.695L200.476 169.05H205.895L208.526 173.695L205.895 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 190.027H200.476L197.767 185.383L200.476 180.661H205.895L208.526 185.383L205.895 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 201.715H200.476L197.767 196.993L200.476 192.349H205.895L208.526 196.993L205.895 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 213.325H200.476L197.767 208.681L200.476 204.037H205.895L208.526 208.681L205.895 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 225.013H200.476L197.767 220.369L200.476 215.648H205.895L208.526 220.369L205.895 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 236.702H200.476L197.767 231.98L200.476 227.336H205.895L208.526 231.98L205.895 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 248.312H200.476L197.767 243.668L200.476 239.024H205.895L208.526 243.668L205.895 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 260H200.476L197.767 255.356L200.476 250.712H205.895L208.526 255.356L205.895 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 271.688H200.476L197.767 267.044L200.476 262.322H205.895L208.526 267.044L205.895 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.74 283.144H200.554L198 278.654L200.554 274.165H205.74L208.372 278.654L205.74 283.144Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.882 314.88H202.489L201.792 313.641L202.489 312.48H203.882L204.579 313.641L203.882 314.88Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.817 329.973H200.476L197.845 325.329L200.476 320.685H205.817L208.526 325.329L205.817 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.817 341.661H200.476L197.767 337.017L200.476 332.373H205.817L208.526 337.017L205.817 341.661Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.332 557.077H271.456L268.979 552.82L271.456 548.562H276.332L278.732 552.82L276.332 557.077Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 563.346H281.286L278.577 558.625L281.286 553.981H286.704L289.414 558.625L286.704 563.346Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 569.152H291.426L288.717 564.508L291.426 559.786H296.767L299.476 564.508L296.767 569.152Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.561 510.48H877.53L875.053 506.145L877.53 501.888H882.561L885.038 506.145L882.561 510.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 499.101H877.375L874.743 494.457L877.375 489.89H882.716L885.347 494.457L882.716 499.101Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.322 485.014H878.768L877.53 482.846L878.768 480.602H881.322L882.561 482.846L881.322 485.014Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.252 428.354H877.839L875.595 424.484L877.839 420.691H882.252L884.496 424.484L882.252 428.354Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 405.829H877.375L874.666 401.185L877.375 396.463H882.716L885.425 401.185L882.716 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 394.141H877.375L874.666 389.497L877.375 384.853H882.716L885.425 389.497L882.716 394.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.703 378.893H879.387L878.768 377.809L879.387 376.725H880.703L881.322 377.809L880.703 378.893Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 312.48H877.375L874.666 307.836L877.375 303.192H882.716L885.425 307.836L882.716 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 300.869H877.375L874.666 296.148L877.375 291.504H882.716L885.425 296.148L882.716 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 289.181H877.375L874.666 284.537L877.375 279.816H882.716L885.425 284.537L882.716 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 277.493H877.375L874.666 272.849L877.375 268.205H882.716L885.425 272.849L882.716 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 265.805H877.375L874.666 261.161L877.375 256.517H882.716L885.425 261.161L882.716 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 254.195H877.375L874.666 249.551L877.375 244.829H882.716L885.425 249.551L882.716 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 242.507H877.375L874.666 237.863L877.375 233.218H882.716L885.425 237.863L882.716 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 230.819H877.375L874.666 226.175L877.375 221.53H882.716L885.425 226.175L882.716 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 219.208H877.375L874.666 214.487L877.375 209.842H882.716L885.425 214.487L882.716 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 207.52H877.375L874.666 202.876L877.375 198.154H882.716L885.425 202.876L882.716 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 195.832H877.375L874.666 191.188L877.375 186.544H882.716L885.425 191.188L882.716 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 184.222H877.375L874.666 179.5L877.375 174.856H882.716L885.425 179.5L882.716 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 172.534H877.375L874.666 167.889L877.375 163.168H882.716L885.425 167.889L882.716 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 160.846H877.375L874.666 156.201L877.375 151.557H882.716L885.425 156.201L882.716 160.846Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 149.158H877.375L874.666 144.513L877.375 139.869H882.716L885.425 144.513L882.716 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 137.547H877.375L874.666 132.825L877.375 128.181H882.716L885.425 132.825L882.716 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 125.859H877.375L874.666 121.215L877.375 116.493H882.716L885.425 121.215L882.716 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 114.171H877.375L874.666 109.527L877.375 104.882H882.716L885.425 109.527L882.716 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 108.366H867.235L864.525 103.721L867.235 98.9998H872.653L875.362 103.721L872.653 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 102.56H857.172L854.463 97.8387L857.172 93.1945H862.513L865.222 97.8387L862.513 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 96.6776H847.032L844.323 92.0334L847.032 87.3892H852.45L855.16 92.0334L852.45 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 90.8723H836.97L834.26 86.2281L836.97 81.5064H842.31L845.02 86.2281L842.31 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.248 85.067H826.83L824.121 80.3454L826.83 75.7011H832.248L834.88 80.3454L832.248 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 79.1843H816.767L814.058 74.5401L816.767 69.8958H822.108L824.818 74.5401L822.108 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 73.379H806.627L803.918 68.7348L806.627 64.0131H812.046L814.677 68.7348L812.046 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 67.4963H796.565L793.856 62.8521L796.565 58.2078H801.906L804.615 62.8521L801.906 67.4963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.766 61.6136H786.425L783.793 57.0468L786.425 52.4025H791.766L794.475 57.0468L791.766 61.6136Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.768 52.4799H778.22L777.523 51.1641L778.22 49.8482H779.768L780.542 51.1641L779.768 52.4799Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.678 19.5832H352.808L350.873 16.1774L352.808 12.8491H356.678L358.613 16.1774L356.678 19.5832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.157 26.4722H342.048L339.494 22.0601L342.048 17.6481H347.157L349.711 22.0601L347.157 26.4722Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.172 32.5097H331.831L329.122 27.8654L331.831 23.2212H337.172L339.881 27.8654L337.172 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.252 35.2188H323.549L322.697 33.6708L323.549 32.2001H325.252L326.103 33.6708L325.252 35.2188Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.196 42.8818H312.403L310.468 39.5534L312.403 36.2251H316.196L318.131 39.5534L316.196 42.8818Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.085 60.6074H281.905L279.816 57.0468L281.905 53.4088H286.085L288.098 57.0468L286.085 60.6074Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.255 66.8771H271.533L269.211 62.8521L271.533 58.8271H276.255L278.577 62.8521L276.255 66.8771Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.418 71.5987H262.09L260.465 68.7348L262.09 65.7934H265.418L267.121 68.7348L265.418 71.5987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.285 79.0295H251.099L248.467 74.5401L251.099 70.0507H256.285L258.916 74.5401L256.285 79.0295Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.082 90.7175H230.896L228.264 86.2281L230.896 81.7386H236.082L238.637 86.2281L236.082 90.7175Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.099 99.232H212.474L211.7 97.8387L212.474 96.5228H214.099L214.874 97.8387L214.099 99.232Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 108.366H200.476L197.767 103.721L200.476 98.9998H205.895L208.526 103.721L205.895 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 114.171H190.336L187.705 109.527L190.336 104.882H195.755L198.464 109.527L195.755 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 125.859H190.336L187.705 121.215L190.336 116.493H195.755L198.464 121.215L195.755 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 137.547H190.336L187.705 132.825L190.336 128.181H195.755L198.464 132.825L195.755 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 149.158H190.336L187.705 144.513L190.336 139.869H195.755L198.464 144.513L195.755 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 160.846H190.336L187.705 156.201L190.336 151.557H195.755L198.464 156.201L195.755 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 172.534H190.336L187.705 167.889L190.336 163.168H195.755L198.464 167.889L195.755 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 184.222H190.336L187.705 179.5L190.336 174.856H195.755L198.464 179.5L195.755 184.222Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 195.832H190.336L187.705 191.188L190.336 186.544H195.755L198.464 191.188L195.755 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 207.52H190.336L187.705 202.876L190.336 198.154H195.755L198.464 202.876L195.755 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 219.208H190.336L187.705 214.487L190.336 209.842H195.755L198.464 214.487L195.755 219.208Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 230.819H190.336L187.705 226.175L190.336 221.53H195.755L198.464 226.175L195.755 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 242.507H190.336L187.705 237.863L190.336 233.218H195.755L198.464 237.863L195.755 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 254.195H190.336L187.705 249.551L190.336 244.829H195.755L198.464 249.551L195.755 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 265.805H190.336L187.705 261.161L190.336 256.517H195.755L198.464 261.161L195.755 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 277.493H190.336L187.705 272.849L190.336 268.205H195.755L198.464 272.849L195.755 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.058 288.02H191.033L189.021 284.537L191.033 280.977H195.058L197.071 284.537L195.058 288.02Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.742 320.685H192.426L191.73 319.524L192.426 318.363H193.742L194.361 319.524L193.742 320.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 335.779H190.414L187.705 331.134L190.414 326.568H195.755L198.386 331.134L195.755 335.779Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 569.152H271.224L268.515 564.508L271.224 559.786H276.565L279.274 564.508L276.565 569.152Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 574.957H281.286L278.577 570.313L281.286 565.669H286.704L289.414 570.313L286.704 574.957Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 580.762H291.426L288.717 576.118L291.426 571.474H296.767L299.476 576.118L296.767 580.762Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.399 520.155H878.69L877.297 517.833L878.69 515.433H881.399L882.793 517.833L881.399 520.155Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 516.672H887.437L884.728 511.95L887.437 507.306H892.855L895.565 511.95L892.855 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 504.984H887.437L884.728 500.34L887.437 495.618H892.855L895.565 500.34L892.855 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 493.296H887.437L884.728 488.652L887.437 484.007H892.855L895.565 488.652L892.855 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.082 480.369H888.211L886.276 476.964L888.211 473.635H892.082L894.017 476.964L892.082 480.369Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.701 411.402H887.592L885.038 406.99L887.592 402.578H892.701L895.255 406.99L892.701 411.402Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 400.024H887.437L884.728 395.302L887.437 390.658H892.855L895.565 395.302L892.855 400.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 388.336H887.437L884.728 383.692L887.437 378.97H892.855L895.565 383.692L892.855 388.336Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.391 375.874H887.902L885.734 372.004L887.902 368.134H892.391L894.558 372.004L892.391 375.874Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.623 306.21H887.67L885.27 302.031L887.67 297.773H892.623L895.023 302.031L892.623 306.21Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 294.987H887.437L884.728 290.342L887.437 285.698H892.855L895.565 290.342L892.855 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 283.376H887.437L884.728 278.654L887.437 274.01H892.855L895.565 278.654L892.855 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 271.688H887.437L884.728 267.044L887.437 262.322H892.855L895.565 267.044L892.855 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 260H887.437L884.728 255.356L887.437 250.712H892.855L895.565 255.356L892.855 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.617 246.222H888.676L887.205 243.668L888.676 241.191H891.617L893.088 243.668L891.617 246.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 236.702H887.437L884.728 231.98L887.437 227.336H892.855L895.565 231.98L892.855 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 225.013H887.437L884.728 220.369L887.437 215.648H892.855L895.565 220.369L892.855 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 213.325H887.437L884.728 208.681L887.437 204.037H892.855L895.565 208.681L892.855 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 201.715H887.437L884.728 196.993L887.437 192.349H892.855L895.565 196.993L892.855 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 190.027H887.437L884.728 185.383L887.437 180.661H892.855L895.565 185.383L892.855 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 178.339H887.437L884.728 173.695L887.437 169.05H892.855L895.565 173.695L892.855 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 166.651H887.437L884.728 162.007L887.437 157.362H892.855L895.565 162.007L892.855 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 155.04H887.437L884.728 150.319L887.437 145.674H892.855L895.565 150.319L892.855 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 143.352H887.437L884.728 138.708L887.437 133.986H892.855L895.565 138.708L892.855 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 131.664H887.437L884.728 127.02L887.437 122.376H892.855L895.565 127.02L892.855 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 120.054H887.437L884.728 115.332L887.437 110.688H892.855L895.565 115.332L892.855 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 108.366H887.437L884.728 103.721L887.437 98.9998H892.855L895.565 103.721L892.855 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 102.56H877.375L874.666 97.8387L877.375 93.1945H882.716L885.425 97.8387L882.716 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 96.6776H867.235L864.525 92.0334L867.235 87.3892H872.653L875.362 92.0334L872.653 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 90.8723H857.172L854.463 86.2281L857.172 81.5064H862.513L865.222 86.2281L862.513 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.45 85.067H847.032L844.323 80.3454L847.032 75.7011H852.45L855.16 80.3454L852.45 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.31 79.1843H836.97L834.26 74.5401L836.97 69.8958H842.31L845.02 74.5401L842.31 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.171 73.3016H826.907L824.275 68.7348L826.907 64.0905H832.171L834.802 68.7348L832.171 73.3016Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 67.4963H816.767L814.135 62.852L816.767 58.2852H822.108L824.74 62.852L822.108 67.4963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.046 61.691H806.627L803.918 57.0468L806.627 52.4025H812.046L814.677 57.0468L812.046 61.691Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.906 55.8857H796.565L793.856 51.1641L796.565 46.5198H801.906L804.615 51.1641L801.906 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.867 37.0765H766.919L764.984 33.6708L766.919 30.265H770.867L772.879 33.6708L770.867 37.0765Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.108 30.0328H757.553L756.237 27.8655L757.553 25.6982H760.108L761.346 27.8655L760.108 30.0328Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.398 19.4284H332.683L330.747 16.1774L332.683 13.0039H336.398L338.256 16.1774L336.398 19.4284Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.871 24.6145H322.93L321.459 22.0602L322.93 19.4284H325.871L327.419 22.0602L325.871 24.6145Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.66 31.9679H311.938L309.539 27.8655L311.938 23.763H316.66L319.059 27.8655L316.66 31.9679Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.823 36.4573H302.572L301.024 33.6707L302.572 30.9616H305.823L307.371 33.6707L305.823 36.4573Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.69 43.9655H291.504L288.949 39.5534L291.504 35.064H296.69L299.244 39.5534L296.69 43.9655Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 50.003H281.286L278.577 45.3588L281.286 40.7145H286.704L289.414 45.3588L286.704 50.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 55.8857H271.224L268.515 51.1641L271.224 46.5198H276.565L279.274 51.1641L276.565 55.8857Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.954 58.9819H262.632L261.548 57.0468L262.632 55.1117H264.954L266.038 57.0468L264.954 58.9819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.969 65.0968H252.337L251.099 62.8521L252.337 60.6073H254.969L256.285 62.8521L254.969 65.0968Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.627 82.5901H222.072L220.834 80.3454L222.072 78.1781H224.627L225.942 80.3454L224.627 82.5901Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.874 89.0146H211.623L209.997 86.2281L211.623 83.3641H214.874L216.499 86.2281L214.874 89.0146Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.811 94.8973H201.483L199.857 92.0334L201.483 89.1694H204.811L206.514 92.0334L204.811 94.8973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82 99.1546H192.272L191.575 97.8387L192.272 96.5228H193.82L194.594 97.8387L193.82 99.1546Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 108.366H180.274L177.565 103.721L180.274 98.9998H185.692L188.324 103.721L185.692 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 120.054H180.274L177.565 115.332L180.274 110.688H185.692L188.324 115.332L185.692 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 131.664H180.274L177.565 127.02L180.274 122.376H185.692L188.324 127.02L185.692 131.664Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 143.352H180.274L177.565 138.708L180.274 133.986H185.692L188.324 138.708L185.692 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 155.04H180.274L177.565 150.319L180.274 145.674H185.692L188.324 150.319L185.692 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 166.651H180.274L177.565 162.007L180.274 157.362H185.692L188.324 162.007L185.692 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 178.339H180.274L177.565 173.695L180.274 169.05H185.692L188.324 173.695L185.692 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 190.027H180.274L177.565 185.383L180.274 180.661H185.692L188.324 185.383L185.692 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 201.715H180.274L177.565 196.993L180.274 192.349H185.692L188.324 196.993L185.692 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 213.325H180.274L177.565 208.681L180.274 204.037H185.692L188.324 208.681L185.692 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 225.013H180.274L177.565 220.369L180.274 215.648H185.692L188.324 220.369L185.692 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 236.702H180.274L177.565 231.98L180.274 227.336H185.692L188.324 231.98L185.692 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 248.312H180.274L177.565 243.668L180.274 239.024H185.692L188.324 243.668L185.692 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 260H180.274L177.565 255.356L180.274 250.712H185.692L188.324 255.356L185.692 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 271.688H180.274L177.565 267.044L180.274 262.322H185.692L188.324 267.044L185.692 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 283.376H180.274L177.565 278.654L180.274 274.01H185.692L188.324 278.654L185.692 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 294.987H180.274L177.565 290.342L180.274 285.698H185.692L188.324 290.342L185.692 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 306.675H180.274L177.565 302.03L180.274 297.309H185.692L188.324 302.03L185.692 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 318.363H180.274L177.565 313.641L180.274 308.997H185.692L188.324 313.641L185.692 318.363Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 329.973H180.274L177.565 325.329L180.274 320.685H185.692L188.324 325.329L185.692 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.525 338.023H182.364L181.822 337.017L182.364 336.011H183.525L184.144 337.017L183.525 338.023Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 580.762H271.224L268.515 576.118L271.224 571.474H276.565L279.274 576.118L276.565 580.762Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 586.645H281.286L278.577 582.001L281.286 577.279H286.704L289.414 582.001L286.704 586.645Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 592.373H291.426L288.794 587.806L291.426 583.239H296.767L299.399 587.806L296.767 592.373Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.935 530.992H879.155L878.304 529.444L879.155 527.973H880.935L881.787 529.444L880.935 530.992Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 528.283H887.437L884.728 523.638L887.437 518.994H892.855L895.565 523.638L892.855 528.283Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 522.477H897.577L894.868 517.833L897.577 513.189H902.918L905.627 517.833L902.918 522.477Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 510.789H897.577L894.868 506.145L897.577 501.501H902.918L905.627 506.145L902.918 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 499.179H897.577L894.868 494.457L897.577 489.813H902.918L905.627 494.457L902.918 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 487.491H897.577L894.868 482.846L897.577 478.125H902.918L905.627 482.846L902.918 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.841 475.648H897.654L895.1 471.158L897.654 466.669H902.841L905.395 471.158L902.841 475.648Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.75 460.322H899.744L899.28 459.47L899.744 458.696H900.75L901.215 459.47L900.75 460.322Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.912 404.049H898.583L896.958 401.185L898.583 398.321H901.912L903.537 401.185L901.912 404.049Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.138 390.968H899.357L898.506 389.497L899.357 388.026H901.138L901.989 389.497L901.138 390.968Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.912 380.673H898.583L896.958 377.809L898.583 374.945H901.912L903.537 377.809L901.912 380.673Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.602 310.158H898.893L897.577 307.836L898.893 305.514H901.602L902.918 307.836L901.602 310.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.06 297.618H899.434L898.583 296.148L899.434 294.755H901.06L901.911 296.148L901.06 297.618Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.686 288.717H897.81L895.333 284.537L897.81 280.28H902.686L905.163 284.537L902.686 288.717Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.84 277.339H897.654L895.022 272.849L897.654 268.36H902.84L905.472 272.849L902.84 277.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.673 261.935H899.822L899.357 261.161L899.822 260.387H900.673L901.138 261.161L900.673 261.935Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.37 251.408H899.125L898.042 249.551L899.125 247.615H901.37L902.454 249.551L901.37 251.408Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.608 241.965H897.887L895.564 237.863L897.887 233.76H902.608L904.93 237.863L902.608 241.965Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 230.819H897.577L894.868 226.175L897.577 221.53H902.918L905.627 226.175L902.918 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 219.208H897.577L894.868 214.487L897.577 209.842H902.918L905.627 214.487L902.918 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 207.52H897.577L894.868 202.876L897.577 198.154H902.918L905.627 202.876L902.918 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 195.832H897.577L894.868 191.188L897.577 186.544H902.918L905.627 191.188L902.918 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 184.222H897.577L894.868 179.5L897.577 174.856H902.918L905.627 179.5L902.918 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 172.534H897.577L894.868 167.889L897.577 163.168H902.918L905.627 167.889L902.918 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 160.846H897.577L894.868 156.201L897.577 151.557H902.918L905.627 156.201L902.918 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 149.158H897.577L894.868 144.513L897.577 139.869H902.918L905.627 144.513L902.918 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 137.547H897.577L894.868 132.825L897.577 128.181H902.918L905.627 132.825L902.918 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 125.859H897.577L894.868 121.215L897.577 116.493H902.918L905.627 121.215L902.918 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 114.171H897.577L894.868 109.527L897.577 104.882H902.918L905.627 109.527L902.918 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 102.56H897.577L894.868 97.8387L897.577 93.1945H902.918L905.627 97.8387L902.918 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 96.6776H887.437L884.728 92.0334L887.437 87.3892H892.855L895.565 92.0334L892.855 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.716 90.8723H877.375L874.666 86.2281L877.375 81.5064H882.716L885.425 86.2281L882.716 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.653 85.067H867.235L864.525 80.3454L867.235 75.7011H872.653L875.362 80.3454L872.653 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.513 79.1843H857.172L854.463 74.5401L857.172 69.8958H862.513L865.145 74.5401L862.513 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.902 70.7473H848.503L847.342 68.7347L848.503 66.6448H850.902L852.141 68.7347L850.902 70.7473Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.777 59.1367H828.3L827.062 57.0468L828.3 54.8795H830.777L832.016 57.0468L830.777 59.1367Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.108 55.8083H816.767L814.058 51.1641L816.767 46.5972H822.108L824.74 51.1641L822.108 55.8083Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.31 30.0327H777.756L776.518 27.8654L777.756 25.6981H780.31L781.549 27.8654L780.31 30.0327Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.258 13.6231H322.543L320.607 10.3722L322.543 7.12119H326.258L328.193 10.3722L326.258 13.6231Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 20.8991H311.629L308.92 16.1774L311.629 11.5332H316.97L319.679 16.1774L316.97 20.8991Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 26.7044H301.488L298.779 22.0601L301.488 17.3385H306.907L309.616 22.0601L306.907 26.7044Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 32.5097H291.426L288.717 27.8654L291.426 23.2212H296.767L299.476 27.8654L296.767 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 38.3924H281.286L278.577 33.6707L281.286 29.0265H286.704L289.414 33.6707L286.704 38.3924Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 44.1977H271.224L268.515 39.5535L271.224 34.8318H276.565L279.274 39.5535L276.565 44.1977Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.115 49.3838H261.471L259.149 45.3587L261.471 41.3337H266.115L268.437 45.3587L266.115 49.3838Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82 54.9568H251.563L249.396 51.164L251.563 47.4487H255.82L257.988 51.164L255.82 54.9568Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.287 58.2078H242.894L242.197 57.0468L242.894 55.8857H244.287L244.906 57.0468L244.287 58.2078Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.097 73.379H220.679L217.97 68.7348L220.679 64.0131H226.097L228.729 68.7348L226.097 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.177 76.0108H212.397L211.545 74.5401L212.397 72.992H214.177L215.028 74.5401L214.177 76.0108Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.895 85.067H200.476L197.767 80.3454L200.476 75.7011H205.895L208.526 80.3454L205.895 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 90.8723H190.336L187.705 86.2281L190.336 81.5064H195.755L198.464 86.2281L195.755 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.305 95.981H180.661L178.339 92.0334L180.661 88.0084H185.305L187.55 92.0334L185.305 95.981Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.32 102.096H170.444L167.967 97.8387L170.444 93.5815H175.32L177.797 97.8387L175.32 102.096Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 114.171H170.134L167.502 109.527L170.134 104.882H175.552L178.261 109.527L175.552 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 125.859H170.134L167.502 121.215L170.134 116.493H175.552L178.261 121.215L175.552 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 137.547H170.134L167.502 132.825L170.134 128.181H175.552L178.261 132.825L175.552 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 149.158H170.134L167.502 144.513L170.134 139.869H175.552L178.261 144.513L175.552 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 160.846H170.134L167.502 156.201L170.134 151.557H175.552L178.261 156.201L175.552 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 172.534H170.134L167.502 167.889L170.134 163.168H175.552L178.261 167.889L175.552 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 184.222H170.134L167.502 179.5L170.134 174.856H175.552L178.261 179.5L175.552 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 195.832H170.134L167.502 191.188L170.134 186.544H175.552L178.261 191.188L175.552 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 207.52H170.134L167.502 202.876L170.134 198.154H175.552L178.261 202.876L175.552 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 219.208H170.134L167.502 214.487L170.134 209.842H175.552L178.261 214.487L175.552 219.208Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 230.819H170.134L167.502 226.175L170.134 221.53H175.552L178.261 226.175L175.552 230.819Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 242.507H170.134L167.502 237.863L170.134 233.218H175.552L178.261 237.863L175.552 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 254.195H170.134L167.502 249.551L170.134 244.829H175.552L178.261 249.551L175.552 254.195Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 265.805H170.134L167.502 261.161L170.134 256.517H175.552L178.261 261.161L175.552 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 277.493H170.134L167.502 272.849L170.134 268.205H175.552L178.261 272.849L175.552 277.493Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 289.181H170.134L167.502 284.537L170.134 279.816H175.552L178.261 284.537L175.552 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 300.869H170.134L167.502 296.148L170.134 291.504H175.552L178.261 296.148L175.552 300.869Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 312.48H170.134L167.502 307.836L170.134 303.192H175.552L178.261 307.836L175.552 312.48Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 324.168H170.134L167.502 319.524L170.134 314.802H175.552L178.261 319.524L175.552 324.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.159 333.379H171.605L170.289 331.134L171.605 328.967H174.159L175.397 331.134L174.159 333.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.255 591.831H271.533L269.211 587.806L271.533 583.781H276.255L278.577 587.806L276.255 591.831Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 598.333H281.286L278.577 593.611L281.286 588.967H286.704L289.414 593.611L286.704 598.333Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.909 600.81H293.284L292.51 599.494L293.284 598.101H294.909L295.683 599.494L294.909 600.81Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.665 525.96H909.033L907.64 523.638L909.033 521.316H911.665L913.058 523.638L911.665 525.96Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 516.672H907.64L904.931 511.95L907.64 507.306H913.058L915.767 511.95L913.058 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 504.984H907.64L904.931 500.34L907.64 495.618H913.058L915.767 500.34L913.058 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 493.296H907.64L904.931 488.652L907.64 484.007H913.058L915.767 488.652L913.058 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 481.685H907.64L904.931 476.964L907.64 472.319H913.058L915.767 476.964L913.058 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 469.997H907.64L904.931 465.353L907.64 460.631H913.058L915.767 465.353L913.058 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.432 408.925H909.265L908.181 406.99L909.265 405.055H911.432L912.516 406.99L911.432 408.925Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.826 399.714H907.872L905.318 395.302L907.872 390.968H912.826L915.38 395.302L912.826 399.714Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 329.973H907.64L904.931 325.329L907.64 320.685H913.058L915.767 325.329L913.058 329.973Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.206 246.919H908.491L906.633 243.668L908.491 240.494H912.206L914.064 243.668L912.206 246.919Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 236.702H907.64L904.931 231.98L907.64 227.336H913.058L915.767 231.98L913.058 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 225.013H907.64L904.931 220.369L907.64 215.648H913.058L915.767 220.369L913.058 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 213.325H907.64L904.931 208.681L907.64 204.037H913.058L915.767 208.681L913.058 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 201.715H907.64L904.931 196.993L907.64 192.349H913.058L915.767 196.993L913.058 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 190.027H907.64L904.931 185.383L907.64 180.661H913.058L915.767 185.383L913.058 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 178.339H907.64L904.931 173.695L907.64 169.05H913.058L915.767 173.695L913.058 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 166.651H907.64L904.931 162.007L907.64 157.362H913.058L915.767 162.007L913.058 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 155.04H907.64L904.931 150.319L907.64 145.674H913.058L915.767 150.319L913.058 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 143.352H907.64L904.931 138.708L907.64 133.986H913.058L915.767 138.708L913.058 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 131.664H907.64L904.931 127.02L907.64 122.376H913.058L915.767 127.02L913.058 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 120.054H907.64L904.931 115.332L907.64 110.688H913.058L915.767 115.332L913.058 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 108.366H907.64L904.931 103.721L907.64 98.9998H913.058L915.767 103.721L913.058 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 96.6776H907.64L904.931 92.0334L907.64 87.3892H913.058L915.767 92.0334L913.058 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.918 90.8723H897.577L894.868 86.2281L897.577 81.5064H902.918L905.627 86.2281L902.918 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.855 85.067H887.437L884.728 80.3454L887.437 75.7011H892.855L895.565 80.3454L892.855 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.555 77.0944H878.536L877.065 74.5401L878.536 71.9857H881.555L883.025 74.5401L881.555 77.0944Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.288 14.0101H302.108L299.941 10.3722L302.108 6.73416H306.288L308.455 10.3722L306.288 14.0101Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.767 20.8991H291.426L288.717 16.1774L291.426 11.5332H296.767L299.476 16.1774L296.767 20.8991Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 26.7044H281.286L278.577 22.0601L281.286 17.3385H286.704L289.414 22.0601L286.704 26.7044Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 32.5097H271.224L268.515 27.8654L271.224 23.2212H276.565L279.274 27.8654L276.565 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.418 36.4573H262.167L260.619 33.6707L262.167 30.9616H265.418L266.967 33.6707L265.418 36.4573Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82 43.2688H251.563L249.396 39.5535L251.563 35.8381H255.82L257.988 39.5535L255.82 43.2688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.225 52.4799H232.754L232.057 51.1641L232.754 49.9256H234.225L234.921 51.1641L234.225 52.4799Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.633 60.917H221.143L218.821 57.0468L221.143 53.0992H225.633L227.877 57.0468L225.633 60.917Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.409 64.7872H212.164L211.003 62.8521L212.164 60.917H214.409L215.57 62.8521L214.409 64.7872Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43 72.6824H200.863L198.619 68.7348L200.863 64.7098H205.43L207.752 68.7348L205.43 72.6824Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.755 79.1843H190.414L187.705 74.5401L190.414 69.8958H195.755L198.386 74.5401L195.755 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.692 85.067H180.274L177.565 80.3454L180.274 75.7011H185.692L188.324 80.3454L185.692 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.243 90.3305H170.444L168.121 86.2281L170.444 82.0483H175.243L177.642 86.2281L175.243 90.3305Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 93.1171H162.161L161.542 92.0334L162.161 90.9497H163.4L164.019 92.0334L163.4 93.1171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 108.366H160.072L157.362 103.721L160.072 98.9998H165.49L168.122 103.721L165.49 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 120.054H160.072L157.362 115.332L160.072 110.688H165.49L168.122 115.332L165.49 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 131.664H160.072L157.362 127.02L160.072 122.376H165.49L168.122 127.02L165.49 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 143.352H160.072L157.362 138.708L160.072 133.986H165.49L168.122 138.708L165.49 143.352Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 155.04H160.072L157.362 150.319L160.072 145.674H165.49L168.122 150.319L165.49 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 166.651H160.072L157.362 162.007L160.072 157.362H165.49L168.122 162.007L165.49 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 178.339H160.072L157.362 173.695L160.072 169.05H165.49L168.122 173.695L165.49 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 190.027H160.072L157.362 185.383L160.072 180.661H165.49L168.122 185.383L165.49 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 201.715H160.072L157.362 196.993L160.072 192.349H165.49L168.122 196.993L165.49 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 213.325H160.072L157.362 208.681L160.072 204.037H165.49L168.122 208.681L165.49 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 225.013H160.072L157.362 220.369L160.072 215.648H165.49L168.122 220.369L165.49 225.013Z",
    fill: "#0C1338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 236.702H160.072L157.362 231.98L160.072 227.336H165.49L168.122 231.98L165.49 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 248.312H160.072L157.362 243.668L160.072 239.024H165.49L168.122 243.668L165.49 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 260H160.072L157.362 255.356L160.072 250.712H165.49L168.122 255.356L165.49 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 271.688H160.072L157.362 267.044L160.072 262.322H165.49L168.122 267.044L165.49 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 283.376H160.072L157.362 278.654L160.072 274.01H165.49L168.122 278.654L165.49 283.376Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 294.987H160.072L157.362 290.342L160.072 285.698H165.49L168.122 290.342L165.49 294.987Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 306.675H160.072L157.362 302.03L160.072 297.309H165.49L168.122 302.03L165.49 306.675Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.412 318.285H160.071L157.44 313.641L160.071 309.074H165.412L168.044 313.641L165.412 318.285Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.864 327.264H161.697L160.536 325.329L161.697 323.471H163.864L164.948 325.329L163.864 327.264Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 602.048H272.385L270.914 599.494L272.385 596.94H275.326L276.797 599.494L275.326 602.048Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.704 609.944H281.286L278.577 605.299L281.286 600.655H286.704L289.414 605.299L286.704 609.944Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.612 615.439H291.581L289.104 611.105L291.581 606.77H296.612L299.089 611.105L296.612 615.439Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.359 619H303.037L301.798 616.987L303.037 614.898H305.359L306.597 616.987L305.359 619Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.501 521.393H918.398L916.309 517.833L918.398 514.272H922.501L924.591 517.833L922.501 521.393Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 510.789H917.779L915.07 506.145L917.779 501.501H923.12L925.829 506.145L923.12 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 499.179H917.779L915.07 494.457L917.779 489.813H923.12L925.829 494.457L923.12 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 487.491H917.779L915.07 482.846L917.779 478.125H923.12L925.829 482.846L923.12 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 475.803H917.779L915.07 471.158L917.779 466.514H923.12L925.829 471.158L923.12 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 464.192H917.779L915.07 459.47L917.779 454.826H923.12L925.829 459.47L923.12 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.424 451.265H918.476L916.464 447.86L918.476 444.376H922.424L924.436 447.86L922.424 451.265Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.495 356.291H919.405L918.399 354.51L919.405 352.73H921.495L922.501 354.51L921.495 356.291Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.263 344.293H919.637L918.786 342.822L919.637 341.352H921.263L922.114 342.822L921.263 344.293Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.043 253.963H917.934L915.303 249.551L917.934 245.061H923.043L925.598 249.551L923.043 253.963Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.424 241.268H918.476L916.464 237.863L918.476 234.379H922.424L924.436 237.863L922.424 241.268Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 230.819H917.779L915.07 226.175L917.779 221.53H923.12L925.829 226.175L923.12 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 219.208H917.779L915.07 214.487L917.779 209.842H923.12L925.829 214.487L923.12 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 207.52H917.779L915.07 202.876L917.779 198.154H923.12L925.829 202.876L923.12 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 195.832H917.779L915.07 191.188L917.779 186.544H923.12L925.829 191.188L923.12 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 184.222H917.779L915.07 179.5L917.779 174.856H923.12L925.829 179.5L923.12 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 172.534H917.779L915.07 167.889L917.779 163.168H923.12L925.829 167.889L923.12 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 160.846H917.779L915.07 156.201L917.779 151.557H923.12L925.829 156.201L923.12 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 149.158H917.779L915.07 144.513L917.779 139.869H923.12L925.829 144.513L923.12 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 137.547H917.779L915.07 132.825L917.779 128.181H923.12L925.829 132.825L923.12 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 125.859H917.779L915.07 121.215L917.779 116.493H923.12L925.829 121.215L923.12 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 114.171H917.779L915.07 109.527L917.779 104.882H923.12L925.829 109.527L923.12 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 102.56H917.779L915.07 97.8387L917.779 93.1945H923.12L925.829 97.8387L923.12 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 90.8723H917.779L915.07 86.2281L917.779 81.5064H923.12L925.829 86.2281L923.12 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.058 85.067H907.64L904.931 80.3454L907.64 75.7011H913.058L915.767 80.3454L913.058 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.757 77.0944H898.738L897.268 74.5401L898.738 71.9857H901.757L903.228 74.5401L901.757 77.0944Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.621 13.1587H282.37L280.744 10.3721L282.37 7.58557H285.621L287.246 10.3721L285.621 13.1587Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.565 20.8991H271.224L268.515 16.1774L271.224 11.5332H276.565L279.274 16.1774L276.565 20.8991Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.728 25.3885H261.858L259.845 22.0602L261.858 18.6544H265.728L267.663 22.0602L265.728 25.3885Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 32.5097H251.021L248.312 27.8654L251.021 23.2212H256.362L259.071 27.8654L256.362 32.5097Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1 52.7121H212.397L211.545 51.1641L212.397 49.6934H214.1L214.951 51.1641L214.1 52.7121Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.74 61.4588H200.631L198.077 57.0468L200.631 52.6347H205.74L208.217 57.0468L205.74 61.4588Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.981 66.103H191.188L189.33 62.852L191.188 59.6011H194.981L196.838 62.852L194.981 66.103Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.615 73.379H180.274L177.565 68.7348L180.274 64.0131H185.615L188.324 68.7348L185.615 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 79.1843H170.134L167.502 74.5401L170.134 69.8958H175.552L178.261 74.5401L175.552 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 81.5064H162.084L161.387 80.3454L162.084 79.1843H163.4L164.097 80.3454L163.4 81.5064Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 102.56H149.932L147.3 97.8387L149.932 93.1945H155.35L158.059 97.8387L155.35 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 114.171H149.932L147.3 109.527L149.932 104.882H155.35L158.059 109.527L155.35 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 125.859H149.932L147.3 121.215L149.932 116.493H155.35L158.059 121.215L155.35 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 137.547H149.932L147.3 132.825L149.932 128.181H155.35L158.059 132.825L155.35 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 149.158H149.932L147.3 144.513L149.932 139.869H155.35L158.059 144.513L155.35 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 160.846H149.932L147.3 156.201L149.932 151.557H155.35L158.059 156.201L155.35 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 172.534H149.932L147.3 167.889L149.932 163.168H155.35L158.059 167.889L155.35 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 184.222H149.932L147.3 179.5L149.932 174.856H155.35L158.059 179.5L155.35 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 195.832H149.932L147.3 191.188L149.932 186.544H155.35L158.059 191.188L155.35 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 207.52H149.932L147.3 202.876L149.932 198.154H155.35L158.059 202.876L155.35 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 219.208H149.932L147.3 214.487L149.932 209.842H155.35L158.059 214.487L155.35 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 230.819H149.932L147.3 226.175L149.932 221.53H155.35L158.059 226.175L155.35 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 242.507H149.932L147.3 237.863L149.932 233.218H155.35L158.059 237.863L155.35 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 254.195H149.932L147.3 249.551L149.932 244.829H155.35L158.059 249.551L155.35 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 265.805H149.932L147.3 261.161L149.932 256.517H155.35L158.059 261.161L155.35 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 277.493H149.932L147.3 272.849L149.932 268.205H155.35L158.059 272.849L155.35 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 289.181H149.932L147.3 284.537L149.932 279.816H155.35L158.059 284.537L155.35 289.181Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.195 300.56H150.164L147.609 296.148L150.164 291.813H155.195L157.672 296.148L155.195 300.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 516.672H927.842L925.133 511.95L927.842 507.306H933.26L935.969 511.95L933.26 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 504.984H927.842L925.133 500.34L927.842 495.618H933.26L935.969 500.34L933.26 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 493.296H927.842L925.133 488.652L927.842 484.007H933.26L935.969 488.652L933.26 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 481.685H927.842L925.133 476.964L927.842 472.319H933.26L935.969 476.964L933.26 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 469.997H927.842L925.133 465.353L927.842 460.631H933.26L935.969 465.353L933.26 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 458.309H927.842L925.133 453.665L927.842 449.021H933.26L935.969 453.665L933.26 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.325 443.37H929.777L928.926 441.977L929.777 440.584H931.325L932.177 441.977L931.325 443.37Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.183 353.195H927.92L925.365 348.705L927.92 344.138H933.183L935.737 348.705L933.183 353.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.564 270.527H928.539L926.526 267.044L928.539 263.483H932.564L934.576 267.044L932.564 270.527Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.938 256.053H930.164L929.7 255.356L930.164 254.659H930.938L931.403 255.356L930.938 256.053Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.105 224.781H927.997L925.442 220.369L927.997 215.957H933.105L935.66 220.369L933.105 224.781Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 213.325H927.842L925.133 208.681L927.842 204.037H933.26L935.969 208.681L933.26 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 201.715H927.842L925.133 196.993L927.842 192.349H933.26L935.969 196.993L933.26 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 190.027H927.842L925.133 185.383L927.842 180.661H933.26L935.969 185.383L933.26 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.183 178.261H927.919L925.288 173.695L927.919 169.128H933.183L935.815 173.695L933.183 178.261Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.332 165.103H928.771L926.991 162.007L928.771 158.988H932.332L934.112 162.007L932.332 165.103Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 155.04H927.842L925.133 150.319L927.842 145.674H933.26L935.969 150.319L933.26 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 143.352H927.842L925.133 138.708L927.842 133.986H933.26L935.969 138.708L933.26 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 131.664H927.842L925.133 127.02L927.842 122.376H933.26L935.969 127.02L933.26 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 120.054H927.842L925.133 115.332L927.842 110.688H933.26L935.969 115.332L933.26 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 108.366H927.842L925.133 103.721L927.842 98.9998H933.26L935.969 103.721L933.26 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 96.6776H927.842L925.133 92.0334L927.842 87.3892H933.26L935.969 92.0334L933.26 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.26 85.067H927.842L925.133 80.3454L927.842 75.7011H933.26L935.969 80.3454L933.26 85.067Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.12 79.1843H917.779L915.07 74.5401L917.779 69.8958H923.12L925.829 74.5401L923.12 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.665 70.9795H909.033L907.717 68.7348L909.033 66.4127H911.665L912.981 68.7348L911.665 70.9795Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.257 11.1462H263.329L262.864 10.3721L263.329 9.5981H264.257L264.722 10.3721L264.257 11.1462Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.117 17.0289H253.266L252.802 16.1774L253.266 15.4034H254.117L254.582 16.1774L254.117 17.0289Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.192 47.139H202.179L201.096 45.3588L202.179 43.5785H204.192L205.198 45.3588L204.192 47.139Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.742 52.3251H192.426L191.73 51.1641L192.426 50.0804H193.742L194.361 51.1641L193.742 52.3251Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.144 59.0593H181.822L180.584 57.0468L181.822 55.0343H184.144L185.305 57.0468L184.144 59.0593Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.475 67.3415H170.289L167.734 62.8521L170.289 58.3626H175.475L178.029 62.8521L175.475 67.3415Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49 73.379H160.072L157.362 68.7348L160.072 64.0131H165.49L168.122 68.7348L165.49 73.379Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 79.1843H149.932L147.3 74.5401L149.932 69.8958H155.35L158.059 74.5401L155.35 79.1843Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.126 94.7426H141.03L139.405 92.0334L141.03 89.3243H144.126L145.675 92.0334L144.126 94.7426Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 108.366H139.869L137.16 103.721L139.869 98.9998H145.287L147.919 103.721L145.287 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 120.054H139.869L137.16 115.332L139.869 110.688H145.287L147.919 115.332L145.287 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 131.664H139.869L137.16 127.02L139.869 122.376H145.287L147.919 127.02L145.287 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 143.352H139.869L137.16 138.708L139.869 133.986H145.287L147.919 138.708L145.287 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 155.04H139.869L137.16 150.319L139.869 145.674H145.287L147.919 150.319L145.287 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 166.651H139.869L137.16 162.007L139.869 157.362H145.287L147.919 162.007L145.287 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 178.339H139.869L137.16 173.695L139.869 169.05H145.287L147.919 173.695L145.287 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 190.027H139.869L137.16 185.383L139.869 180.661H145.287L147.919 185.383L145.287 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 201.715H139.869L137.16 196.993L139.869 192.349H145.287L147.919 196.993L145.287 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 213.325H139.869L137.16 208.681L139.869 204.037H145.287L147.919 208.681L145.287 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 225.013H139.869L137.16 220.369L139.869 215.648H145.287L147.919 220.369L145.287 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 236.702H139.869L137.16 231.98L139.869 227.336H145.287L147.919 231.98L145.287 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 248.312H139.869L137.16 243.668L139.869 239.024H145.287L147.919 243.668L145.287 248.312Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 260H139.869L137.16 255.356L139.869 250.712H145.287L147.919 255.356L145.287 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.287 271.688H139.869L137.16 267.044L139.869 262.322H145.287L147.919 267.044L145.287 271.688Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21 283.221H139.946L137.315 278.654L139.946 274.088H145.21L147.842 278.654L145.21 283.221Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9 294.368H140.256L137.934 290.343L140.256 286.318H144.9L147.145 290.343L144.9 294.368Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.513 305.436H140.566L138.553 302.031L140.566 298.547H144.513L146.526 302.031L144.513 305.436Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.698 531.301H939.608L938.602 529.443L939.608 527.663H941.698L942.704 529.443L941.698 531.301Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 522.477H937.982L935.272 517.833L937.982 513.189H943.322L946.032 517.833L943.322 522.477Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 510.789H937.982L935.272 506.145L937.982 501.501H943.322L946.032 506.145L943.322 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 499.179H937.982L935.272 494.457L937.982 489.813H943.322L946.032 494.457L943.322 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 487.491H937.982L935.272 482.846L937.982 478.125H943.322L946.032 482.846L943.322 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 475.803H937.982L935.272 471.158L937.982 466.514H943.322L946.032 471.158L943.322 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 464.192H937.982L935.272 459.47L937.982 454.826H943.322L946.032 459.47L943.322 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 452.504H937.982L935.272 447.86L937.982 443.138H943.322L946.032 447.86L943.322 452.504Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.93 438.339H939.375L938.137 436.172L939.375 434.004H941.93L943.168 436.172L941.93 438.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.162 403.739H939.143L937.672 401.185L939.143 398.553H942.162L943.632 401.185L942.162 403.739Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.245 393.909H938.059L935.505 389.497L938.059 385.085H943.245L945.8 389.497L943.245 393.909Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.168 265.496H938.137L935.66 261.161L938.137 256.827H943.168L945.645 261.161L943.168 265.496Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.156 215.415H940.149L939.607 214.487L940.149 213.635H941.156L941.697 214.487L941.156 215.415Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.323 207.443H937.982L935.35 202.876L937.982 198.232H943.323L946.032 202.876L943.323 207.443Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 195.832H937.982L935.272 191.188L937.982 186.544H943.322L946.032 191.188L943.322 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.323 184.144H937.982L935.35 179.5L937.982 174.933H943.323L945.954 179.5L943.323 184.144Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.775 169.824H939.53L938.369 167.889L939.53 165.877H941.775L942.936 167.889L941.775 169.824Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.246 149.003H938.059L935.428 144.513L938.059 140.024H943.246L945.877 144.513L943.246 149.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 137.547H937.982L935.272 132.825L937.982 128.181H943.322L946.032 132.825L943.322 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 125.859H937.982L935.272 121.215L937.982 116.493H943.322L946.032 121.215L943.322 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 114.171H937.982L935.272 109.527L937.982 104.882H943.322L946.032 109.527L943.322 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 102.56H937.982L935.272 97.8387L937.982 93.1945H943.322L946.032 97.8387L943.322 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.322 90.8723H937.982L935.272 86.2281L937.982 81.5064H943.322L946.032 86.2281L943.322 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.748 61.1492H907.949L905.55 57.0468L907.949 52.8669H912.748L915.148 57.0468L912.748 61.1492Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.376 54.8794H898.119L895.952 51.164L898.119 47.5261H902.376L904.543 51.164L902.376 54.8794Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71 58.6722H161.774L160.846 57.0468L161.774 55.3439H163.71L164.716 57.0468L163.71 58.6722Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.034 65.1742H151.325L149.932 62.8521L151.325 60.53H154.034L155.35 62.8521L154.034 65.1742Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 102.56H129.729L127.097 97.8387L129.729 93.1945H135.147L137.857 97.8387L135.147 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 114.171H129.729L127.097 109.527L129.729 104.882H135.147L137.857 109.527L135.147 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 125.859H129.729L127.097 121.215L129.729 116.493H135.147L137.857 121.215L135.147 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 137.547H129.729L127.097 132.825L129.729 128.181H135.147L137.857 132.825L135.147 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 149.158H129.729L127.097 144.513L129.729 139.869H135.147L137.857 144.513L135.147 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 160.846H129.729L127.097 156.201L129.729 151.557H135.147L137.857 156.201L135.147 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 172.534H129.729L127.097 167.889L129.729 163.168H135.147L137.857 167.889L135.147 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 184.222H129.729L127.097 179.5L129.729 174.856H135.147L137.857 179.5L135.147 184.222Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 195.832H129.729L127.097 191.188L129.729 186.544H135.147L137.857 191.188L135.147 195.832Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 207.52H129.729L127.097 202.876L129.729 198.154H135.147L137.857 202.876L135.147 207.52Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 219.208H129.729L127.097 214.487L129.729 209.842H135.147L137.857 214.487L135.147 219.208Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 230.819H129.729L127.097 226.175L129.729 221.53H135.147L137.857 226.175L135.147 230.819Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 242.507H129.729L127.097 237.863L129.729 233.218H135.147L137.857 237.863L135.147 242.507Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 254.195H129.729L127.097 249.551L129.729 244.829H135.147L137.857 249.551L135.147 254.195Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 265.805H129.729L127.097 261.161L129.729 256.517H135.147L137.857 261.161L135.147 265.805Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 277.493H129.729L127.097 272.849L129.729 268.205H135.147L137.857 272.849L135.147 277.493Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.993 288.872H129.961L127.407 284.537L129.961 280.125H134.993L137.47 284.537L134.993 288.872Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.528 536.642H949.98L949.283 535.326L949.98 534.01H951.528L952.224 535.326L951.528 536.642Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 528.283H948.044L945.335 523.638L948.044 518.994H953.462L956.172 523.638L953.462 528.283Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 516.672H948.044L945.335 511.95L948.044 507.306H953.462L956.172 511.95L953.462 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 504.984H948.044L945.335 500.34L948.044 495.618H953.462L956.172 500.34L953.462 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 493.296H948.044L945.335 488.652L948.044 484.007H953.462L956.172 488.652L953.462 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 481.685H948.044L945.335 476.964L948.044 472.319H953.462L956.172 476.964L953.462 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 469.997H948.044L945.335 465.353L948.044 460.631H953.462L956.172 465.353L953.462 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 458.309H948.044L945.335 453.665L948.044 449.021H953.462L956.172 453.665L953.462 458.309Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 446.621H948.044L945.335 441.977L948.044 437.333H953.462L956.172 441.977L953.462 446.621Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 260H948.044L945.335 255.356L948.044 250.712H953.462L956.172 255.356L953.462 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.147 222.769H949.361L947.967 220.369L949.361 217.892H952.147L953.54 220.369L952.147 222.769Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.605 198.464H949.902L949.051 196.993L949.902 195.523H951.605L952.457 196.993L951.605 198.464Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.456 188.324H949.05L947.27 185.383L949.05 182.364H952.456L954.237 185.383L952.456 188.324Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.766 177.255H948.741L946.651 173.695L948.741 170.134H952.766L954.856 173.695L952.766 177.255Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 143.352H948.044L945.335 138.708L948.044 133.986H953.462L956.172 138.708L953.462 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 131.664H948.044L945.335 127.02L948.044 122.376H953.462L956.172 127.02L953.462 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 120.054H948.044L945.335 115.332L948.044 110.688H953.462L956.172 115.332L953.462 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 108.366H948.044L945.335 103.721L948.044 98.9998H953.462L956.172 103.721L953.462 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.462 96.6776H948.044L945.335 92.0334L948.044 87.3892H953.462L956.172 92.0334L953.462 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.45 81.5838H950.057L949.36 80.3454L950.057 79.1843H951.45L952.147 80.3454L951.45 81.5838Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.079 95.0521H120.596L118.893 92.0334L120.596 89.0146H124.079L125.859 92.0334L124.079 95.0521Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 108.366H119.667L116.958 103.721L119.667 98.9998H125.008L127.717 103.721L125.008 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 120.054H119.667L116.958 115.332L119.667 110.688H125.008L127.717 115.332L125.008 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 131.664H119.667L116.958 127.02L119.667 122.376H125.008L127.717 127.02L125.008 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 143.352H119.667L116.958 138.708L119.667 133.986H125.008L127.717 138.708L125.008 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 155.04H119.667L116.958 150.319L119.667 145.674H125.008L127.717 150.319L125.008 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 166.651H119.667L116.958 162.007L119.667 157.362H125.008L127.717 162.007L125.008 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 178.339H119.667L116.958 173.695L119.667 169.05H125.008L127.717 173.695L125.008 178.339Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 190.027H119.667L116.958 185.383L119.667 180.661H125.008L127.717 185.383L125.008 190.027Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 201.715H119.667L116.958 196.993L119.667 192.349H125.008L127.717 196.993L125.008 201.715Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 213.325H119.667L116.958 208.681L119.667 204.037H125.008L127.717 208.681L125.008 213.325Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 225.013H119.667L116.958 220.369L119.667 215.648H125.008L127.717 220.369L125.008 225.013Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 236.702H119.667L116.958 231.98L119.667 227.336H125.008L127.717 231.98L125.008 236.702Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 248.312H119.667L116.958 243.668L119.667 239.024H125.008L127.717 243.668L125.008 248.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 260H119.667L116.958 255.356L119.667 250.712H125.008L127.717 255.356L125.008 260Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.15 268.437H121.524L120.673 267.044L121.524 265.573H123.15L124.001 267.044L123.15 268.437Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.519 555.761H959.191L957.488 552.82L959.191 549.878H962.519L964.222 552.82L962.519 555.761Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 545.776H958.184L955.475 541.132L958.184 536.487H963.525L966.234 541.132L963.525 545.776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 534.165H958.184L955.475 529.444L958.184 524.799H963.525L966.234 529.444L963.525 534.165Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 522.477H958.184L955.475 517.833L958.184 513.189H963.525L966.234 517.833L963.525 522.477Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 510.789H958.184L955.475 506.145L958.184 501.501H963.525L966.234 506.145L963.525 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 499.179H958.184L955.475 494.457L958.184 489.813H963.525L966.234 494.457L963.525 499.179Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 487.491H958.184L955.475 482.846L958.184 478.125H963.525L966.234 482.846L963.525 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 475.803H958.184L955.475 471.158L958.184 466.514H963.525L966.234 471.158L963.525 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 464.192H958.184L955.475 459.47L958.184 454.826H963.525L966.234 459.47L963.525 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.513 413.957H960.197L959.578 412.796L960.197 411.712H961.513L962.132 412.796L961.513 413.957Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 405.829H958.184L955.475 401.185L958.184 396.463H963.525L966.234 401.185L963.525 405.829Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.216 253.653H958.494L956.095 249.551L958.494 245.371H963.216L965.615 249.551L963.216 253.653Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.441 240.572H959.268L957.72 237.863L959.268 235.153H962.441L963.989 237.863L962.441 240.572Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.823 227.8H959.965L959.036 226.175L959.965 224.549H961.823L962.752 226.175L961.823 227.8Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.293 218.744H958.417L956.017 214.487L958.417 210.307H963.293L965.693 214.487L963.293 218.744Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.977 193.123H959.733L958.649 191.188L959.733 189.253H961.977L963.061 191.188L961.977 193.123Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.448 149.003H958.262L955.63 144.513L958.262 140.024H963.448L966.08 144.513L963.448 149.003Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 137.547H958.184L955.475 132.825L958.184 128.181H963.525L966.234 132.825L963.525 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 125.859H958.184L955.475 121.215L958.184 116.493H963.525L966.234 121.215L963.525 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 114.171H958.184L955.475 109.527L958.184 104.882H963.525L966.234 109.527L963.525 114.171Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 102.56H958.184L955.475 97.8387L958.184 93.1945H963.525L966.234 97.8387L963.525 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.525 90.8723H958.184L955.475 86.2281L958.184 81.5064H963.525L966.234 86.2281L963.525 90.8723Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.945 102.56H109.527L106.895 97.8387L109.527 93.1945H114.945L117.654 97.8387L114.945 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.945 114.171H109.527L106.895 109.527L109.527 104.882H114.945L117.654 109.527L114.945 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.945 125.859H109.527L106.895 121.215L109.527 116.493H114.945L117.654 121.215L114.945 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.945 137.547H109.527L106.895 132.825L109.527 128.181H114.945L117.654 132.825L114.945 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.945 149.158H109.527L106.895 144.513L109.527 139.869H114.945L117.654 144.513L114.945 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.945 160.846H109.527L106.895 156.201L109.527 151.557H114.945L117.654 156.201L114.945 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79 172.301H109.681L107.127 167.889L109.681 163.4H114.79L117.344 167.889L114.79 172.301Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.248 182.906H110.301L108.288 179.5L110.301 176.094H114.248L116.183 179.5L114.248 182.906Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.242 192.891H111.307L110.301 191.188L111.307 189.485H113.242L114.171 191.188L113.242 192.891Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.855 203.882H111.694L111.075 202.876L111.694 201.87H112.855L113.397 202.876L112.855 203.882Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.087 216.035H111.384L110.456 214.487L111.384 213.016H113.087L114.016 214.487L113.087 216.035Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.242 227.877H111.307L110.301 226.175L111.307 224.472H113.242L114.171 226.175L113.242 227.877Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.171 241.268H110.301L108.366 237.863L110.301 234.457H114.171L116.183 237.863L114.171 241.268Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.242 251.176H111.307L110.301 249.551L111.307 247.848H113.242L114.171 249.551L113.242 251.176Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 563.269H968.247L965.615 558.625L968.247 553.981H973.665L976.297 558.625L973.665 563.269Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.272 549.259H969.64L968.324 547.014L969.64 544.692H972.272L973.588 547.014L972.272 549.259Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 539.97H968.247L965.615 535.326L968.247 530.682H973.665L976.374 535.326L973.665 539.97Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 528.283H968.247L965.615 523.638L968.247 518.994H973.665L976.374 523.638L973.665 528.283Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 516.672H968.247L965.615 511.95L968.247 507.306H973.665L976.374 511.95L973.665 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 504.984H968.247L965.615 500.34L968.247 495.618H973.665L976.374 500.34L973.665 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 493.296H968.247L965.615 488.652L968.247 484.007H973.665L976.374 488.652L973.665 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 481.685H968.247L965.615 476.964L968.247 472.319H973.665L976.374 476.964L973.665 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 469.997H968.247L965.615 465.353L968.247 460.631H973.665L976.374 465.353L973.665 469.997Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.04 455.523H969.873L968.866 453.665L969.873 451.807H972.04L973.123 453.665L972.04 455.523Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.588 423.168H968.325L965.77 418.678L968.325 414.112H973.588L976.22 418.678L973.588 423.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 411.635H968.247L965.615 406.99L968.247 402.346H973.665L976.374 406.99L973.665 411.635Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.576 396.463H970.337L969.641 395.302L970.337 394.219H971.576L972.272 395.302L971.576 396.463Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.659 153.337H969.253L967.55 150.319L969.253 147.377H972.659L974.362 150.319L972.659 153.337Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 143.352H968.247L965.615 138.708L968.247 133.986H973.665L976.374 138.708L973.665 143.352Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 131.664H968.247L965.615 127.02L968.247 122.376H973.665L976.374 127.02L973.665 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 120.054H968.247L965.615 115.332L968.247 110.688H973.665L976.374 115.332L973.665 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.665 108.366H968.247L965.615 103.721L968.247 98.9998H973.665L976.374 103.721L973.665 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.588 96.6002H968.324L965.693 92.0334L968.324 87.4666H973.588L976.22 92.0334L973.588 96.6002Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.108 95.3617H100.238L98.3031 92.0334L100.238 88.705H104.108L106.044 92.0334L104.108 95.3617Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.805 108.366H99.4641L96.755 103.721L99.4641 98.9998H104.805L107.514 103.721L104.805 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.805 120.054H99.4641L96.755 115.332L99.4641 110.688H104.805L107.514 115.332L104.805 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.805 131.664H99.4641L96.755 127.02L99.4641 122.376H104.805L107.514 127.02L104.805 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.805 143.352H99.4641L96.755 138.708L99.4641 133.986H104.805L107.514 138.708L104.805 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.805 155.04H99.4641L96.755 150.319L99.4641 145.674H104.805L107.514 150.319L104.805 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.263 165.645H100.006L97.9161 162.007L100.006 158.369H104.263L106.353 162.007L104.263 165.645Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.715 553.903H980.477L979.857 552.82L980.477 551.736H981.715L982.334 552.82L981.715 553.903Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.65 545.544H978.542L975.987 541.132L978.542 536.72H983.65L986.127 541.132L983.65 545.544Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 534.165H978.387L975.678 529.444L978.387 524.799H983.728L986.437 529.444L983.728 534.165Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 522.477H978.387L975.678 517.833L978.387 513.189H983.728L986.437 517.833L983.728 522.477Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 510.789H978.387L975.678 506.145L978.387 501.501H983.728L986.437 506.145L983.728 510.789Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 499.179H978.387L975.678 494.457L978.387 489.813H983.728L986.437 494.457L983.728 499.179Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 487.491H978.387L975.678 482.846L978.387 478.125H983.728L986.437 482.846L983.728 487.491Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 475.803H978.387L975.678 471.158L978.387 466.514H983.728L986.437 471.158L983.728 475.803Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 464.192H978.387L975.678 459.47L978.387 454.826H983.728L986.437 459.47L983.728 464.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.496 451.962H978.697L976.22 447.86L978.697 443.68H983.496L985.895 447.86L983.496 451.962Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.948 437.642H980.167L979.316 436.172L980.167 434.624H981.948L982.799 436.172L981.948 437.642Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.573 428.818H978.619L976.065 424.484L978.619 420.226H983.573L986.05 424.484L983.573 428.818Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 417.517H978.387L975.678 412.796L978.387 408.151H983.728L986.437 412.796L983.728 417.517Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 137.47H978.387L975.678 132.825L978.387 128.181H983.728L986.437 132.825L983.728 137.47Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 125.859H978.387L975.678 121.215L978.387 116.493H983.728L986.437 121.215L983.728 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 114.171H978.387L975.678 109.527L978.387 104.882H983.728L986.437 109.527L983.728 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.728 102.56H978.387L975.678 97.8387L978.387 93.1945H983.728L986.437 97.8387L983.728 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5753 87.0796H91.5691L91.0272 86.2281L91.5691 85.2993H92.5753L93.0397 86.2281L92.5753 87.0796Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7425 102.56H89.3242L86.6925 97.8387L89.3242 93.1945H94.7425L97.4517 97.8387L94.7425 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7425 114.171H89.3242L86.6925 109.527L89.3242 104.882H94.7425L97.4517 109.527L94.7425 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7425 125.859H89.3242L86.6925 121.215L89.3242 116.493H94.7425L97.4517 121.215L94.7425 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7425 137.547H89.3242L86.6925 132.825L89.3242 128.181H94.7425L97.4517 132.825L94.7425 137.547Z",
    fill: "#01C0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7425 149.158H89.3242L86.6925 144.513L89.3242 139.869H94.7425L97.4517 144.513L94.7425 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9684 159.53H90.0982L88.1631 156.201L90.0982 152.873H93.9684L95.9035 156.201L93.9684 159.53Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.784 538.113H989.533L987.907 535.326L989.533 532.54H992.784L994.409 535.326L992.784 538.113Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 528.283H988.45L985.818 523.638L988.45 518.994H993.868L996.577 523.638L993.868 528.283Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 516.672H988.45L985.818 511.95L988.45 507.306H993.868L996.577 511.95L993.868 516.672Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 504.984H988.45L985.818 500.34L988.45 495.618H993.868L996.577 500.34L993.868 504.984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 493.296H988.45L985.818 488.652L988.45 484.007H993.868L996.577 488.652L993.868 493.296Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 481.685H988.45L985.818 476.964L988.45 472.319H993.868L996.577 476.964L993.868 481.685Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.481 469.378H988.836L986.514 465.353L988.836 461.251H993.481L995.803 465.353L993.481 469.378Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.791 423.168H988.527L985.895 418.678L988.527 414.112H993.791L996.422 418.678L993.791 423.168Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.7 186.234H990.694L990.152 185.383L990.694 184.454H991.7L992.165 185.383L991.7 186.234Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.636 178.029H988.682L986.127 173.695L988.682 169.36H993.636L996.19 173.695L993.636 178.029Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 166.651H988.45L985.818 162.007L988.45 157.362H993.868L996.577 162.007L993.868 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.79 154.886H988.527L985.972 150.319L988.527 145.829H993.79L996.422 150.319L993.79 154.886Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.475 140.953H989.843L988.604 138.708L989.843 136.463H992.475L993.791 138.708L992.475 140.953Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 131.664H988.45L985.818 127.02L988.45 122.376H993.868L996.577 127.02L993.868 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 120.054H988.45L985.818 115.332L988.45 110.688H993.868L996.577 115.332L993.868 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.868 108.366H988.45L985.818 103.721L988.45 98.9998H993.868L996.577 103.721L993.868 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.79 96.5228H988.604L985.972 92.0334L988.604 87.5439H993.79L996.344 92.0334L993.79 96.5228Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6025 96.6776H79.2616L76.5525 92.0334L79.2616 87.3892H84.6025L87.3117 92.0334L84.6025 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6025 108.366H79.2616L76.5525 103.721L79.2616 98.9998H84.6025L87.3117 103.721L84.6025 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6025 120.054H79.2616L76.5525 115.332L79.2616 110.688H84.6025L87.3117 115.332L84.6025 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6025 131.664H79.2616L76.5525 127.02L79.2616 122.376H84.6025L87.3117 127.02L84.6025 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6025 143.352H79.2616L76.5525 138.708L79.2616 133.986H84.6025L87.3117 138.708L84.6025 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6675 151.557H81.2743L80.5776 150.319L81.2743 149.158H82.6675L83.3642 150.319L82.6675 151.557Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.31 521.393H999.208L997.196 517.833L999.208 514.272H1003.31L1005.4 517.833L1003.31 521.393Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.93 510.789H998.59L995.88 506.145L998.59 501.501H1003.93L1006.64 506.145L1003.93 510.789Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.93 499.024H998.667L995.958 494.457L998.667 489.89H1003.93L1006.56 494.457L1003.93 499.024Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.08 485.865H999.518L997.738 482.846L999.518 479.75H1003.08L1004.86 482.846L1003.08 485.865Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.3 426.264H1000.21L999.208 424.484L1000.21 422.703H1002.3L1003.31 424.484L1002.3 426.264Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.85 172.301H998.744L996.19 167.889L998.744 163.4H1003.85L1006.41 167.889L1003.85 172.301Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.93 160.768H998.667L996.035 156.201L998.667 151.635H1003.93L1006.56 156.201L1003.93 160.768Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.93 149.158H998.59L995.958 144.513L998.59 139.946H1003.93L1006.56 144.513L1003.93 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.93 137.547H998.59L995.88 132.825L998.59 128.181H1003.93L1006.64 132.825L1003.93 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.93 125.859H998.59L995.88 121.215L998.59 116.493H1003.93L1006.64 121.215L1003.93 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.93 114.171H998.59L995.88 109.527L998.59 104.882H1003.93L1006.64 109.527L1003.93 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.93 102.56H998.59L995.88 97.8387L998.59 93.1945H1003.93L1006.64 97.8387L1003.93 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.46 88.2406H1000.06L998.899 86.2281L1000.06 84.1382H1002.46L1003.62 86.2281L1002.46 88.2406Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2241 88.6276H70.4376L69.0443 86.2281L70.4376 83.7512H73.2241L74.6948 86.2281L73.2241 88.6276Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5401 102.56H69.1219L66.4127 97.8387L69.1219 93.1945H74.5401L77.2493 97.8387L74.5401 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5401 114.171H69.1219L66.4127 109.527L69.1219 104.882H74.5401L77.2493 109.527L74.5401 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5401 125.859H69.1219L66.4127 121.215L69.1219 116.493H74.5401L77.2493 121.215L74.5401 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5401 137.547H69.1219L66.4127 132.825L69.1219 128.181H74.5401L77.2493 132.825L74.5401 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5401 149.158H69.1219L66.4127 144.513L69.1219 139.869H74.5401L77.2493 144.513L74.5401 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.37 478.744H1010.35L1009.43 476.964L1010.35 475.261H1012.37L1013.37 476.964L1012.37 478.744Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.06 466.514H1010.66L1009.97 465.353L1010.66 464.115H1012.06L1012.75 465.353L1012.06 466.514Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.07 143.352H1008.73L1006.02 138.708L1008.73 134.064H1014.07L1016.78 138.708L1014.07 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.07 131.664H1008.65L1006.02 127.02L1008.65 122.376H1014.07L1016.78 127.02L1014.07 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.07 120.054H1008.65L1006.02 115.332L1008.65 110.688H1014.07L1016.78 115.332L1014.07 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.07 108.366H1008.65L1006.02 103.721L1008.65 98.9998H1014.07L1016.78 103.721L1014.07 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.07 96.6776H1008.73L1006.02 92.0334L1008.73 87.3892H1014.07L1016.78 92.0334L1014.07 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3877 81.4291H61.1493L60.4526 80.3454L61.1493 79.2617H62.3877L63.007 80.3454L62.3877 81.4291Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4002 96.6776H59.0594L56.3502 92.0334L59.0594 87.3892H64.4002L67.1094 92.0334L64.4002 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4002 108.366H59.0594L56.3502 103.721L59.0594 98.9998H64.4002L67.1094 103.721L64.4002 108.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4002 120.054H59.0594L56.3502 115.332L59.0594 110.688H64.4002L67.1094 115.332L64.4002 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4002 131.664H59.0594L56.3502 127.02L59.0594 122.376H64.4002L67.1094 127.02L64.4002 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4002 143.352H59.0594L56.3502 138.708L59.0594 133.986H64.4002L67.1094 138.708L64.4002 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4002 155.04H59.0594L56.3502 150.319L59.0594 145.674H64.4002L67.1094 150.319L64.4002 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4002 166.651H59.0594L56.3502 162.007L59.0594 157.362H64.4002L67.1094 162.007L64.4002 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.28 145.907H1020.73L1019.95 144.513L1020.73 143.197H1022.28L1023.05 144.513L1022.28 145.907Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.21 137.547H1018.79L1016.08 132.825L1018.79 128.181H1024.21L1026.84 132.825L1024.21 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.21 125.859H1018.79L1016.08 121.215L1018.79 116.493H1024.21L1026.84 121.215L1024.21 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.21 114.171H1018.79L1016.08 109.527L1018.79 104.882H1024.21L1026.84 109.527L1024.21 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.21 102.56H1018.79L1016.08 97.8387L1018.79 93.1945H1024.21L1026.84 97.8387L1024.21 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9506 90.1757H49.3064L47.0616 86.2281L49.3064 82.2031H53.9506L56.1953 86.2281L53.9506 90.1757Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3376 102.56H48.9193L46.2102 97.8387L48.9193 93.1945H54.3376L57.0468 97.8387L54.3376 102.56Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3376 114.171H48.9193L46.2102 109.527L48.9193 104.882H54.3376L57.0468 109.527L54.3376 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3376 125.859H48.9193L46.2102 121.215L48.9193 116.493H54.3376L57.0468 121.215L54.3376 125.859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3376 137.547H48.9193L46.2102 132.825L48.9193 128.181H54.3376L57.0468 132.825L54.3376 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3376 149.158H48.9193L46.2102 144.513L48.9193 139.869H54.3376L57.0468 144.513L54.3376 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2602 160.768H48.9967L46.2876 156.201L48.9967 151.557H54.2602L56.9694 156.201L54.2602 160.768Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1055 172.147H49.1516L46.6747 167.889L49.1516 163.555H54.1055L56.5824 167.889L54.1055 172.147Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.03 582.852H1031.1L1030.63 582.001L1031.1 581.149H1032.03L1032.57 582.001L1032.03 582.852Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.27 131.664H1028.85L1026.22 127.02L1028.85 122.376H1034.27L1036.98 127.02L1034.27 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.27 120.054H1028.85L1026.22 115.332L1028.85 110.688H1034.27L1036.98 115.332L1034.27 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.27 108.366H1028.85L1026.22 103.721L1028.85 98.9998H1034.27L1036.98 103.721L1034.27 108.366Z",
    fill: "#FC9536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.18 93.1171H1030.94L1030.32 92.0334L1030.94 90.9497H1032.18L1032.8 92.0334L1032.18 93.1171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1977 96.6776H38.8568L36.1477 92.0334L38.8568 87.3892H44.1977L46.9069 92.0334L44.1977 96.6776Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8881 107.824H39.1665L36.767 103.721L39.1665 99.619H43.8881L46.2877 103.721L43.8881 107.824Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1977 120.054H38.8568L36.1477 115.332L38.8568 110.688H44.1977L46.9069 115.332L44.1977 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1977 131.664H38.8568L36.1477 127.02L38.8568 122.376H44.1977L46.9069 127.02L44.1977 131.664Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1977 143.352H38.8568L36.1477 138.708L38.8568 133.986H44.1977L46.9069 138.708L44.1977 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1977 155.04H38.8568L36.1477 150.319L38.8568 145.674H44.1977L46.9069 150.319L44.1977 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1977 166.651H38.8568L36.1477 162.007L38.8568 157.362H44.1977L46.9069 162.007L44.1977 166.651Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.26 580.608H1039.07L1036.52 576.118L1039.07 571.629H1044.26L1046.89 576.118L1044.26 580.608Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.55 565.978H1040.77L1039.92 564.508L1040.77 562.96H1042.55L1043.48 564.508L1042.55 565.978Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.48 134.141H1040.93L1040.16 132.825L1040.93 131.509H1042.48L1043.17 132.825L1042.48 134.141Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.33 124.001H1040.08L1038.38 121.215L1040.08 118.351H1043.33L1044.95 121.215L1043.33 124.001Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.41 114.171H1038.99L1036.28 109.527L1038.99 104.882H1044.41L1047.04 109.527L1044.41 114.171Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.87 101.631H1039.46L1037.29 97.8387L1039.46 94.0459H1043.87L1046.04 97.8387L1043.87 101.631Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8903 87.0021H30.9615L30.4971 86.2281L30.9615 85.3766H31.8903L32.3548 86.2281L31.8903 87.0021Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6644 100.006H30.1874L28.949 97.8387L30.1874 95.6714H32.6644L33.9802 97.8387L32.6644 100.006Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0578 114.094H28.7943L26.1626 109.527L28.7943 104.96H34.0578L36.7669 109.527L34.0578 114.094Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5161 124.853H29.3363L27.1689 121.215L29.3363 117.499H33.5161L35.6834 121.215L33.5161 124.853Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1352 137.547H28.717L26.0078 132.825L28.717 128.181H34.1352L36.8444 132.825L34.1352 137.547Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1352 149.158H28.717L26.0078 144.513L28.717 139.869H34.1352L36.8444 144.513L34.1352 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1352 160.846H28.717L26.0078 156.201L28.717 151.557H34.1352L36.8444 156.201L34.1352 160.846Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1351 172.534H28.7168L26.0851 167.889L28.7168 163.168H34.1351L36.7668 167.889L34.1351 172.534Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.39 573.099H1050.22L1048.59 570.313L1050.22 567.526H1053.39L1054.94 570.313L1053.39 573.099Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.24 562.959H1049.29L1046.81 558.625L1049.29 554.368H1054.24L1056.72 558.625L1054.24 562.959Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.62 118.583H1049.91L1048.05 115.332L1049.91 112.158H1053.62L1055.56 115.332L1053.62 118.583Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.55 106.74H1050.06L1048.28 103.721L1050.06 100.703H1053.55L1055.25 103.721L1053.55 106.74Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.215 105.192H20.4347L19.5833 103.721L20.4347 102.173H22.215L23.0664 103.721L22.215 105.192Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9953 120.054H18.6545L15.9453 115.332L18.6545 110.688H23.9953L26.7045 115.332L23.9953 120.054Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7504 127.794H20.899L20.4346 127.02L20.899 126.246H21.7504L22.2149 127.02L21.7504 127.794Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9953 143.352H18.6545L15.9453 138.708L18.6545 133.986H23.9953L26.7045 138.708L23.9953 143.352Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9953 155.04H18.6545L15.9453 150.319L18.6545 145.674H23.9953L26.7045 150.319L23.9953 155.04Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5245 164.096H20.1249L18.8865 162.007L20.1249 159.917H22.5245L23.7629 162.007L22.5245 164.096Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8342 176.249H19.8154L18.3447 173.695L19.8154 171.14H22.8342L24.3048 173.695L22.8342 176.249Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4535 189.098H19.1962L17.0289 185.383L19.1962 181.667H23.4535L25.6208 185.383L23.4535 189.098Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.45 565.436H1061.36L1060.82 564.508L1061.36 563.579H1062.45L1062.99 564.508L1062.45 565.436Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.53 555.684H1060.2L1058.58 552.82L1060.2 549.956H1063.53L1065.23 552.82L1063.53 555.684Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.76 542.68H1060.98L1060.13 541.131L1060.98 539.661H1062.76L1063.61 541.131L1062.76 542.68Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.38 123.769H1060.44L1058.89 121.215L1060.44 118.583H1063.38L1064.85 121.215L1063.38 123.769Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.45 112.236H1060.36L1058.73 109.527L1060.36 106.818H1063.45L1065 109.527L1063.45 112.236Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9265 112.468H9.52076L7.81787 109.527L9.52076 106.585H12.9265L14.6294 109.527L12.9265 112.468Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3134 136.541H9.13362L6.96631 132.825L9.13362 129.187H13.3134L15.4808 132.825L13.3134 136.541Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9327 149.158H8.51444L5.8053 144.513L8.51444 139.869H13.9327L16.6419 144.513L13.9327 149.158Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3134 159.839H9.13362L6.96631 156.201L9.13362 152.563H13.3134L15.4808 156.201L13.3134 159.839Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8427 180.584H10.6042L9.98499 179.5L10.6042 178.494H11.8427L12.4619 179.5L11.8427 180.584Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8491 193.975H9.59814L7.97266 191.188L9.59814 188.401H12.8491L14.4746 191.188L12.8491 193.975Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.21 550.884H1069.72L1067.48 547.014L1069.72 543.067H1074.21L1076.54 547.014L1074.21 550.884Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.68 539.893H1069.34L1066.71 535.326L1069.34 530.682H1074.68L1077.31 535.326L1074.68 539.893Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.51 524.567H1071.43L1070.96 523.638L1071.43 522.709H1072.51L1073.05 523.638L1072.51 524.567Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70289 139.637H0.541828L0 138.708L0.541828 137.702H1.70289L2.24472 138.708L1.70289 139.637Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70289 186.312H0.541828L0 185.383L0.541828 184.376H1.70289L2.24472 185.383L1.70289 186.312Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6256 197.922H0.619343L0.0775146 196.993L0.619343 196.142H1.6256L2.16742 196.993L1.6256 197.922Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.88 530.837H1081.33L1080.56 529.444L1081.33 528.128H1082.88L1083.66 529.444L1082.88 530.837Z",
    fill: "#EBECF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.49031eb93c24a5ec23233716a388470a.svg";
export { ForwardRef as ReactComponent };